import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** date & time custom scalar type */
  DateTime: number;
  /** Scalar for JSON data, allowing arbitrary JSON objects to be passed as values. */
  JSON: any;
  _Any: any;
  _FieldSet: any;
};

/** Account response */
export type IAccount = {
  __typename?: 'Account';
  /** Manager of the account - reseller admin or CS who manages the account */
  accountManager?: Maybe<IAccountManager>;
  /** Account's child accounts - relevant to master account */
  childAccounts: Array<IAccount>;
  /** Summary of child accounts that match optional Account Filters */
  childAccountsSummary?: Maybe<IChildAccountsSummary>;
  /** Credits information */
  credits: IAccountCredits;
  /** Account's creation date */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** Account's ID */
  id: Scalars['ID'];
  /** The activity status of the account */
  isActive: Scalars['Boolean'];
  /** The accounts set logo url */
  logoUrl?: Maybe<Scalars['String']>;
  /** Account's name */
  name: Scalars['String'];
  /** Information from deprecated Organization */
  orgInfo?: Maybe<IOrgInfo>;
  /**
   * Parent master account to the account. May be undefined if user does not have access to view the account, or
   * the account is the root level account.
   */
  parentAccount?: Maybe<IAccount>;
  /** The primary contact of the account */
  primaryContact?: Maybe<IUser>;
  /** Account's type */
  type: IAccountType;
  /** Users of the account */
  users: Array<IUser>;
};


/** Account response */
export type IAccountChildAccountsArgs = {
  input: IAccountFilters;
  pagination: IPagination;
};


/** Account response */
export type IAccountChildAccountsSummaryArgs = {
  input?: InputMaybe<IAccountFilters>;
};

/** Credit limits for an account */
export type IAccountCredits = {
  __typename?: 'AccountCredits';
  /** Personalized Insights credits */
  personalizedInsights: Scalars['Int'];
  /** Smart Reply credits */
  smartReply: Scalars['Int'];
};

/** Possible filters for account query */
export type IAccountFilter = {
  /** ID of the account to fetch */
  id: Scalars['ID'];
};

/** Filters for the accounts query */
export type IAccountFilters = {
  /** Filter on the account manager assigned to account */
  accountManagerUserId?: InputMaybe<Scalars['ID']>;
  /** Filter that is used for fuzzy search on the account name */
  accountName?: InputMaybe<Scalars['String']>;
  /** If included filter by accounts that are either active or inactive */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** The master account of the accounts to fetch */
  masterAccountId?: InputMaybe<Scalars['String']>;
};

/** Account manager information */
export type IAccountManager = {
  __typename?: 'AccountManager';
  /** Account Manager's first name */
  firstName: Scalars['String'];
  /** Account Manager's Id */
  id: Scalars['ID'];
  /** Account Manager's last name */
  lastName: Scalars['String'];
};

/** Account type */
export const IAccountType = {
  /** Master Account - reseller account which has capability to add prospecting account for its customers */
  Master: 'MASTER',
  /** Regular Account - prospecting account */
  Regular: 'REGULAR'
} as const;

export type IAccountType = typeof IAccountType[keyof typeof IAccountType];
/** Input for Activating users */
export type IActivateUsersInput = {
  /** Account users belong to, only single account be updated at a time */
  accountId: Scalars['ID'];
  /** users to activate */
  users: Array<Scalars['ID']>;
};

/** Input for adding an account */
export type IAddAccountInput = {
  /** Name of added account */
  accountName: Scalars['String'];
  /** Parent account of the added account */
  parentAccountId: Scalars['ID'];
};

/** Input for creating an organization */
export type IAddOrganizationInput = {
  /** Instance id of the organization, or null to create tenant under instance id of requestor */
  domainInstanceId?: InputMaybe<Scalars['ID']>;
  /** Monthly invites the organization is allowed to send, or null to use default of 2000 invites */
  monthlyInvites?: InputMaybe<Scalars['Int']>;
  /** Monthly messages the organization is allowed to send, or null to use default of 400 messages */
  monthlyMessages?: InputMaybe<Scalars['Int']>;
  /** Organization name */
  organizationName: Scalars['String'];
  /** Tenant id to create the organization under, or null to create organization under node tenant of requestor */
  tenantId?: InputMaybe<Scalars['ID']>;
};

export const IAttentionLevel = {
  /** The item requires immediate attention */
  Blocker: 'BLOCKER',
  /** The item requires attention */
  Warning: 'WARNING'
} as const;

export type IAttentionLevel = typeof IAttentionLevel[keyof typeof IAttentionLevel];
/** The different statuses of audience segment generation. */
export const IAudienceParameterStatus = {
  /** Audience segment generation failed with an error. */
  Error: 'ERROR',
  /** Audience segment generation is in progress. */
  Running: 'RUNNING',
  /** Audience segment generation completed successfully. */
  Success: 'SUCCESS'
} as const;

export type IAudienceParameterStatus = typeof IAudienceParameterStatus[keyof typeof IAudienceParameterStatus];
/** Individual audience segment */
export type IAudienceSegment = {
  __typename?: 'AudienceSegment';
  /** Description of the audience segment */
  description: Scalars['String'];
  /** Name of the audience segment */
  name: Scalars['String'];
  /** Rationale for the segment */
  rationale: Scalars['String'];
  /** LinkedIn Sales Navigator search criteria */
  searchCriteria: ISalesNavigatorPeopleSearch;
};

/** Audience segment result with search criteria or error */
export type IAudienceSegmentResult = {
  __typename?: 'AudienceSegmentResult';
  /** Error message if generation failed */
  error?: Maybe<Scalars['String']>;
  /** The generated audience segment */
  segment?: Maybe<IAudienceSegment>;
  /** Current status of the audience segment generation */
  status: IAudienceSegmentStatus;
};

/** The different statuses of audience segment generation. */
export const IAudienceSegmentStatus = {
  /** Audience segment generation failed with an error. */
  Error: 'ERROR',
  /** Audience segment generation has not been initiated */
  NotStarted: 'NOT_STARTED',
  /** Audience segment generation is in progress. */
  Running: 'RUNNING',
  /** Audience segment generation completed successfully. */
  Success: 'SUCCESS'
} as const;

export type IAudienceSegmentStatus = typeof IAudienceSegmentStatus[keyof typeof IAudienceSegmentStatus];
/** Auto reply settings for a campaign. */
export type IAutoReplySettings = {
  __typename?: 'AutoReplySettings';
  /** The calendar link for the campaign. */
  calendarLink?: Maybe<Scalars['String']>;
  /** Whether auto reply is enabled for the campaign. */
  isEnabled: Scalars['Boolean'];
};

export type IBaseAttentionItem = {
  /** The attention item level */
  level: IAttentionLevel;
};

export type IBaseCampaignStats = {
  /**
   * The end of the date range the stats were collected from.
   * Null or undefined if there is no end to the date range.
   */
  end?: Maybe<Scalars['DateTime']>;
  /** The number of interested replies from contacts in the target campaign */
  numInterestedReplies: Scalars['Int'];
  /** The number of meetings booked with LinkedIn users targeted by the campaign */
  numMeetingsBooked: Scalars['Int'];
  /** The number of replies from LinkedIn users targeted by the campaign. */
  numUserReplies: Scalars['Int'];
  /** The ID of the owner of the stats (i.e. the campaign member or campaign they are for) */
  ownerId: Scalars['ID'];
  /** The type of the owner of the campaign. */
  ownerType: ICampaignStatsOwnerType;
  /** The percentage of replies that were categorized as an interested reply */
  percentInterestedReplied?: Maybe<Scalars['Float']>;
  /** The percentage of users contacted by the who've returned a message. */
  percentReplied?: Maybe<Scalars['Float']>;
  /**
   * The start of the date range the stats were collected from.
   * Null or undefined if there is no start to the date range.
   */
  start?: Maybe<Scalars['DateTime']>;
};

export const IBlockedStatus = {
  /** Is blocked */
  Blocked: 'BLOCKED',
  /** Is not blocked */
  Unblocked: 'UNBLOCKED',
  /** The blocked status is unknown */
  Unknown: 'UNKNOWN'
} as const;

export type IBlockedStatus = typeof IBlockedStatus[keyof typeof IBlockedStatus];
/** Business context with structured company research data */
export type IBusinessContext = {
  __typename?: 'BusinessContext';
  /** Linkedin Company ID used to generate context */
  companyId: Scalars['ID'];
  /** The ID of the business context */
  id: Scalars['ID'];
  /** Company's name */
  name: Scalars['String'];
  /** The organization member ID this business context belongs to */
  orgMemberId: Scalars['ID'];
  /** Error message if processing failed */
  processingError?: Maybe<Scalars['String']>;
  /** Processing state of the business context */
  processingState: IBusinessContextProcessingState;
  /** Research data generated by agent flow, undefined if it has not been completed */
  research?: Maybe<ICompanyResearchData>;
  /** User's role/position at the company */
  role: Scalars['String'];
  /** End date of the role */
  roleEndTime?: Maybe<Scalars['DateTime']>;
  /** Start date of the role */
  roleStartTime?: Maybe<Scalars['DateTime']>;
  /** URL for company's official website */
  website: Scalars['String'];
};

/** Processing states for business context generation */
export const IBusinessContextProcessingState = {
  /** Business context processing has completed successfully */
  Completed: 'COMPLETED',
  /** Business context processing encountered an error */
  Error: 'ERROR',
  /** Business context is currently being processed */
  Processing: 'PROCESSING'
} as const;

export type IBusinessContextProcessingState = typeof IBusinessContextProcessingState[keyof typeof IBusinessContextProcessingState];
/** Input for querying business contexts */
export type IBusinessContextsQueryInput = {
  /** The organization member ID for whom to query business contexts */
  orgMemberId: Scalars['ID'];
};

/** A campaign. */
export type ICampaign = {
  __typename?: 'Campaign';
  /** A list of items require attention */
  attentionItems: Array<ICampaignAttentionItem>;
  /** Auto reply settings for the campaign */
  autoReplySettings: IAutoReplySettings;
  /** The business context for the campaign, if undefined it has not been set */
  businessContext?: Maybe<IBusinessContext>;
  /** The goal for the campaign, if undefined no goal has been set */
  goal?: Maybe<Scalars['String']>;
  /** The ID of the campaign. */
  id: Scalars['ID'];
  /** The inmail message sequence for the campaign. */
  inMailMessageSequence: Array<ISequenceNode>;
  /** The initial launch date of the campaign. */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** A list of members in the campaign. */
  members: Array<ICampaignMember>;
  /** The message sequence for the campaign. */
  messageSequence: Array<ISequenceNode>;
  /** The name of the campaign. */
  name: Scalars['String'];
  /** The number of active org members within the campaign. */
  numActiveMembers?: Maybe<Scalars['Int']>;
  /** Whether the campaign is enabled for inMail */
  openInMailEnabled: Scalars['Boolean'];
  /** The org member that owns the campaign */
  orgMember: IOrgMember;
  /** The search url for the campaign */
  searchUrl?: Maybe<Scalars['String']>;
  /** Last search date */
  searchUrlLastUpdated?: Maybe<Scalars['DateTime']>;
  /** The service schedule for the campaign. */
  serviceSchedule?: Maybe<IServiceSchedule>;
  /** The statistics describing the campaign's efforts. Start and end date are provided as milliseconds since the Unix Epoch. */
  stats?: Maybe<ICampaignStats>;
  /** The status of the campaign. */
  status: ICampaignStatus;
  /** The type of the campaign. */
  type: ICampaignType;
};


/** A campaign. */
export type ICampaignStatsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

/** Input for specifying allocations for a specific campaign */
export type ICampaignAllocation = {
  /** The ID of the campaign to update allocations for */
  campaignId: Scalars['ID'];
  /** The number of invites allocated for this campaign */
  monthlyInvitesAllocated?: InputMaybe<Scalars['Int']>;
  /** The number of messages allocated for this campaign */
  monthlyMessagesAllocated?: InputMaybe<Scalars['Int']>;
  /** The number of daily Open InMail allocated for this campaign */
  monthlyOpenInMailAllocated?: InputMaybe<Scalars['Int']>;
};

export type ICampaignAllocationListItem = {
  __typename?: 'CampaignAllocationListItem';
  /** The ID of the campaign to update allocations for */
  campaignId: Scalars['ID'];
  /** The name of the campaign */
  campaignName: Scalars['String'];
  /** The campaign type */
  campaignType: ICampaignType;
  /** The number of invites allocated for this campaign */
  monthlyInvitesAllocated?: Maybe<Scalars['Int']>;
  /** The number of messages allocated for this campaign */
  monthlyMessagesAllocated?: Maybe<Scalars['Int']>;
  /** The number of daily Open InMail allocated for this campaign */
  monthlyOpenInMailAllocated?: Maybe<Scalars['Int']>;
};

/** Input for querying campaign allocations */
export type ICampaignAllocationsByOrgMemberQueryInput = {
  /** The campaign type to query allocations for */
  campaignType?: InputMaybe<ICampaignType>;
  /** The campaign member ID for whom to query allocations */
  isAllocated?: InputMaybe<Scalars['Boolean']>;
  /** The organization member ID for whom to query allocations */
  orgMemberId?: InputMaybe<Scalars['ID']>;
  /** The sort order for the allocations */
  sort?: InputMaybe<ISortInput>;
};

/** A campaign attention item */
export type ICampaignAttentionItem = IBaseAttentionItem & {
  __typename?: 'CampaignAttentionItem';
  /** The attention item level */
  level: IAttentionLevel;
  /** The campaign member's ID */
  memberId: Scalars['ID'];
  /** The campaign attention item type */
  type: ICampaignAttentionType;
};

/** Campaign attention item's type */
export const ICampaignAttentionType = {
  /** The number of campaign connections to invite is below threshold */
  CampaignSearchListLow: 'CAMPAIGN_SEARCH_LIST_LOW',
  /** The daily allocated invites is not set for a prospecting campaign */
  NoInvitesSetForProspectingCampaign: 'NO_INVITES_SET_FOR_PROSPECTING_CAMPAIGN',
  /** The number of outbound messages is not set for a nurture campaign */
  NoMessagesSetForNurtureCampaign: 'NO_MESSAGES_SET_FOR_NURTURE_CAMPAIGN'
} as const;

export type ICampaignAttentionType = typeof ICampaignAttentionType[keyof typeof ICampaignAttentionType];
/** A campaign connection. */
export type ICampaignConnection = {
  __typename?: 'CampaignConnection';
  /** Auto reply settings for the campaign connection */
  autoReplySettings: IConnectionAutoReplySettings;
  /** Whether if the connection is blocked */
  blockedStatus: IBlockedStatus;
  /** The history of the campaign connection in different campaigns. */
  campaignHistory: Array<ICampaignHistory>;
  /** The ID of the campaign the connection belongs to. */
  campaignId: Scalars['String'];
  /** Campaign member that the connection belongs to */
  campaignMember: ICampaignMember;
  /** Communication style analysis of the connection */
  communicationStyles?: Maybe<ICommunicationStylesAnalysis>;
  /** The company of the connection */
  company?: Maybe<Scalars['String']>;
  /** Information from deprecated Org Contact */
  contactInfo?: Maybe<IContactInfo>;
  /** The date the connection was created */
  dateCreated: Scalars['DateTime'];
  /** The ID of the campaign connection. */
  id: Scalars['ID'];
  /** The linkedin invite url */
  inviteUrl: Scalars['String'];
  /** Whether or not the connection was manually terminated */
  isManualTermination?: Maybe<Scalars['Boolean']>;
  /** The LinkedIn Profile associated with this connection. */
  linkedInProfile: ILinkedInProfile;
  /** The location of the connection */
  location?: Maybe<Scalars['String']>;
  /** A meeting booked with the connection. */
  meeting: IMeetingContext;
  /** The name of the connection */
  name: Scalars['String'];
  /** The connection's next node in campaign */
  nextAutomationNode?: Maybe<INextAutomationNode>;
  /** The ID of the linkedin profile */
  profileId: Scalars['ID'];
  /** The reply prediction score */
  replyPrediction?: Maybe<Scalars['Float']>;
  /** The status of the connection */
  status: IConnectionStatus;
  /** Information from linkedin thread */
  threadInfo?: Maybe<IThreadInfo>;
  /** The job title of the connection */
  title?: Maybe<Scalars['String']>;
};

/** Input used for querying campaign connections */
export type ICampaignConnectionFilters = {
  /** Blocked Status */
  blockedStatus?: InputMaybe<Array<IBlockedStatus>>;
  /** Campaign member ids to filter connections by */
  campaignMemberIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Whether or not to filter by open profile */
  isOpenProfile?: InputMaybe<Scalars['Boolean']>;
  /** text search to filter connections by */
  searchText?: InputMaybe<Scalars['String']>;
  /** Connection status to filter connections by. Currently only supports fetching one status */
  status?: InputMaybe<Array<IConnectionStatus>>;
};

/** Input used for querying campaign connections */
export type ICampaignConnectionsInput = {
  /** Contact id to filter connections by */
  contactId: Scalars['ID'];
};

/** Input used for querying campaign connections */
export type ICampaignConnectionsPaginatedInput = {
  /** Filters to apply when querying campaign connections */
  filters: ICampaignConnectionFilters;
  /** Pagination details */
  pagination: IPaginationInput;
  /** Sort details */
  sort: ISortInput;
};

/** A record of a campaign connection in a campaign. */
export type ICampaignHistory = {
  __typename?: 'CampaignHistory';
  /** The ID of the campaign. */
  campaignId: Scalars['ID'];
  /** The last known date at which the connection was included in the campaign. */
  end?: Maybe<Scalars['DateTime']>;
  /** The name of the campaign. */
  name: Scalars['String'];
  /** The first known date at which the connection was included in the campaign. */
  start: Scalars['DateTime'];
};

/** Input used for querying campaigns. */
export type ICampaignInput = {
  /** Query for campaigns for specific org */
  orgId?: InputMaybe<Scalars['ID']>;
  /** Query for campaign the user is a part of */
  orgMemberId?: InputMaybe<Scalars['ID']>;
};

/** A campaign member. */
export type ICampaignMember = {
  __typename?: 'CampaignMember';
  /** The number of invites the member has allocated */
  dailyInvitesAllocated: Scalars['Int'];
  /** The number of messages the number has allocated */
  dailyMessagesAllocated: Scalars['Int'];
  /** The number of daily Open InMail the member has allocated */
  dailyOpenInMailAllocated: Scalars['Int'];
  /** The campaign member's ID. */
  id: Scalars['ID'];
  /** The number of invites the member has allocated */
  monthlyInvitesAllocated: Scalars['Int'];
  /** The number of messages the number has allocated */
  monthlyMessagesAllocated: Scalars['Int'];
  /** The number of daily Open InMail the member has allocated */
  monthlyOpenInMailAllocated: Scalars['Int'];
  /** The ID of the member within the organization. */
  orgMemberId: Scalars['ID'];
};

/** The input for a campaign member events query. */
export type ICampaignMemberEventsInput = {
  /** The campaign member ID to query for. */
  campaignMemberId: Scalars['ID'];
  /** The last day of the time frame to query. Should provided alongside numDays. */
  end?: InputMaybe<Scalars['DateTime']>;
  /** Length of the time frame to query for. Should be provided alongside end. */
  numDays?: InputMaybe<Scalars['Int']>;
};

export type ICampaignStats = INurtureCampaignStats | IProspectingCampaignStats;

/** Possible filters to use when querying for Campaign Stats. */
export type ICampaignStatsFilters = {
  /** The campaign IDs of the requested stats. Only one of CampaignIds or CampaignMemberIds or OrganizationFilters should be used in a single query. */
  campaignIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The campaign member IDs of the requested stats. Only one of CampaignIds or CampaignMemberIds or OrganizationFilters should be used in a single query. */
  campaignMemberIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Stats of campaign types to be fetched if specified. */
  campaignTypes?: InputMaybe<Array<ICampaignType>>;
  /** Specifies the latest date to aggregate stats from. */
  end?: InputMaybe<Scalars['DateTime']>;
  /** Interval group stats by. */
  interval?: InputMaybe<ITimeInterval>;
  /** The organization filter of the requested stats. Only one of CampaignIds or CampaignMemberIds or OrganizationFilters should be used in a single query. */
  organizationFilters?: InputMaybe<Array<IOrganizationFilter>>;
  /** Specifies the earliest date to aggregate stats from. */
  start?: InputMaybe<Scalars['DateTime']>;
};

/** Input used for querying campaign stats. */
export type ICampaignStatsInput = {
  /** Filters to apply when querying campaign stats. */
  filter?: InputMaybe<ICampaignStatsFilters>;
};

export const ICampaignStatsOwnerType = {
  /** Campaign stats of a campaign. */
  Campaign: 'CAMPAIGN',
  /** Campaign stats of a campaign member. */
  CampaignMember: 'CAMPAIGN_MEMBER',
  /** Aggregated campaign stats of an organization */
  Organization: 'ORGANIZATION',
  /** Aggregated campaign stats of an organization member */
  OrganizationMember: 'ORGANIZATION_MEMBER'
} as const;

export type ICampaignStatsOwnerType = typeof ICampaignStatsOwnerType[keyof typeof ICampaignStatsOwnerType];
/** The different statuses of a campaign. */
export const ICampaignStatus = {
  /** The type of a disabled campaign. */
  Disabled: 'DISABLED',
  /** The type of an active campaign. */
  Enabled: 'ENABLED',
  /** The type of an UNKNOWN campaign. */
  Unknown: 'UNKNOWN'
} as const;

export type ICampaignStatus = typeof ICampaignStatus[keyof typeof ICampaignStatus];
/** Input for the desired status for a campaign */
export const ICampaignStatusInput = {
  /** The value used to set a campaign to disabled. */
  Disabled: 'DISABLED',
  /** The value used to set a campaign to enabled. */
  Enabled: 'ENABLED'
} as const;

export type ICampaignStatusInput = typeof ICampaignStatusInput[keyof typeof ICampaignStatusInput];
/** The different types of campaigns. */
export const ICampaignType = {
  /** The type of a LinkedIn nurture campaign. */
  Nurture: 'NURTURE',
  /** The type of a LinkedIn prospecting campaign. */
  Prospecting: 'PROSPECTING'
} as const;

export type ICampaignType = typeof ICampaignType[keyof typeof ICampaignType];
/** A usage event within the Campaign domain. */
export type ICampaignUsage = {
  __typename?: 'CampaignUsage';
  /** The action causing the usage. */
  action: ICampaignUsageAction;
  /** The ID of the campaign the event pertained to. */
  campaignId: Scalars['ID'];
  /** The ID of the campaign member the event pertained to. */
  campaignMemberId?: Maybe<Scalars['ID']>;
  /** The date & time the usage occurred on. */
  dateCreated: Scalars['DateTime'];
};

/** The different types of actions that can occur within the campaign domain. */
export const ICampaignUsageAction = {
  /** An update to a campaign's messaging. */
  MessagingChange: 'MESSAGING_CHANGE',
  /** An update to a campaign's search list and messaging */
  SearchListAndMessagingChange: 'SEARCH_LIST_AND_MESSAGING_CHANGE',
  /** An update to a campaign's search list. */
  SearchListChange: 'SEARCH_LIST_CHANGE'
} as const;

export type ICampaignUsageAction = typeof ICampaignUsageAction[keyof typeof ICampaignUsageAction];
export type IChatCompletionChoice = {
  __typename?: 'ChatCompletionChoice';
  /** The chat completed message generated by ChatGPT. */
  message: IChatCompletionMessage;
};

export type IChatCompletionInput = {
  /** The penalty for repeated tokens in the generated text, between -2.0 and 2.0. */
  frequencyPenalty?: InputMaybe<Scalars['Float']>;
  /** The maximum number of tokens to generate. */
  maxLength?: InputMaybe<Scalars['Int']>;
  /** The messages to complete. */
  messages: Array<IChatCompletionMessageInput>;
  /** The penalty for tokens that are present in the generated text, between -2.0 and 2.0. */
  presencePenalty?: InputMaybe<Scalars['Float']>;
  /** The expected format to generate the response in */
  responseFormat?: InputMaybe<IChatCompletionResponseFormatInput>;
  /** The randomness of the generated text, between 0.0 and 2.0. */
  temperature?: InputMaybe<Scalars['Float']>;
  /** The diversity of the generated text. */
  topP?: InputMaybe<Scalars['Float']>;
};

export type IChatCompletionMessage = {
  __typename?: 'ChatCompletionMessage';
  /** The text of the message. */
  content: Scalars['String'];
  /** The role of the message. */
  role: IChatCompletionMessageRole;
};

export type IChatCompletionMessageInput = {
  /** The text of the message. */
  content: Scalars['String'];
  /** The role of the message. */
  role: IChatCompletionMessageRole;
};

export const IChatCompletionMessageRole = {
  /** The author of the message is the assistant. */
  Assistant: 'ASSISTANT',
  /** The author of the message is the system. */
  System: 'SYSTEM',
  /** The author of the message is the user. */
  User: 'USER'
} as const;

export type IChatCompletionMessageRole = typeof IChatCompletionMessageRole[keyof typeof IChatCompletionMessageRole];
export type IChatCompletionOrModerationResult = IChatCompletionResult | IModerationResult;

/** Response format */
export const IChatCompletionResponseFormat = {
  /** JSON Object response */
  JsonObject: 'json_object',
  /** Regular text response */
  Text: 'text'
} as const;

export type IChatCompletionResponseFormat = typeof IChatCompletionResponseFormat[keyof typeof IChatCompletionResponseFormat];
/** Chat Completion response type */
export type IChatCompletionResponseFormatInput = {
  /** The type of response we're expecting */
  type: IChatCompletionResponseFormat;
};

export type IChatCompletionResult = {
  __typename?: 'ChatCompletionResult';
  /** A list of chat completed responses by ChatGPT. */
  choices: Array<IChatCompletionChoice>;
};

export type IChildAccountsSummary = {
  __typename?: 'ChildAccountsSummary';
  /** Total child accounts, includes all types of accounts */
  totalAccounts: Scalars['Int'];
  /** Total active users in child accounts */
  totalActiveUsers: Scalars['Int'];
  /** Total users in child accounts */
  totalUsers: Scalars['Int'];
};

/** Communication style of a connection */
export type ICommunicationStyle = {
  __typename?: 'CommunicationStyle';
  /** The style of the connection */
  style: Scalars['String'];
};

/** Communication style analysis of a connection */
export type ICommunicationStylesAnalysis = {
  __typename?: 'CommunicationStylesAnalysis';
  /** The reason for failure of the analysis */
  failureReason?: Maybe<Scalars['String']>;
  /** The last updated date of the analysis */
  lastUpdated: Scalars['DateTime'];
  /** The analysis of the connection */
  styles: Array<ICommunicationStyle>;
};

/** Company headcount range */
export type ICompanyHeadcountRange = {
  __typename?: 'CompanyHeadcountRange';
  max: Scalars['Int'];
  min: Scalars['Int'];
};

/** Research data generated by agent flow */
export type ICompanyResearchData = {
  __typename?: 'CompanyResearchData';
  /** How company creates, delivers, and captures value */
  businessModel?: Maybe<Scalars['String']>;
  /** Overview of company values, work environment, and ethics */
  companyCulture?: Maybe<Scalars['String']>;
  /** Current company stage (e.g., startup, growth) */
  companyStage?: Maybe<Scalars['String']>;
  /** How company distinguishes itself from rivals */
  competitiveDifferentiation?: Maybe<Array<Scalars['String']>>;
  /** Fundamental value company promises to customers */
  coreValueProposition?: Maybe<Scalars['String']>;
  /** Date when research was last edited */
  dateEdited: Scalars['DateTime'];
  /** Date when research was generated */
  dateGenerated: Scalars['DateTime'];
  /** Summary of company's business and mission */
  description?: Maybe<Scalars['String']>;
  /** Other relevant company details (firmographics) */
  etcOtherFirmographics?: Maybe<Scalars['String']>;
  /** Description of various company departments */
  functionalDepartments?: Maybe<Scalars['String']>;
  /** Regions or countries where company does business */
  geographicAreasServed?: Maybe<Array<Scalars['String']>>;
  /** Metrics or signs pointing to company's growth */
  growthIndicators?: Maybe<Scalars['String']>;
  /** Primary industry company operates in */
  industry?: Maybe<Scalars['String']>;
  /** Information on key executives and leaders */
  leadershipTeam?: Maybe<Array<ILeadershipTeamMember>>;
  /** Specific market segments company targets */
  marketFocus?: Maybe<Scalars['String']>;
  /** Information on company's partners and alliances */
  partnerEcosystem?: Maybe<Scalars['String']>;
  /** Organizational structure of company teams */
  teamStructure?: Maybe<Scalars['String']>;
  /** Technologies and tools used by company */
  techStack?: Maybe<Scalars['String']>;
  /** What makes company's offerings unique */
  uniqueSellingPoints?: Maybe<Array<Scalars['String']>>;
};

/** Auto reply settings for a campaign connection. */
export type IConnectionAutoReplySettings = {
  __typename?: 'ConnectionAutoReplySettings';
  /** Whether auto reply is enabled for the campaign connection. */
  isEnabled: Scalars['Boolean'];
};

export const IConnectionStatus = {
  AlreadyPending: 'ALREADY_PENDING',
  CampaignError: 'CAMPAIGN_ERROR',
  Connected: 'CONNECTED',
  InviteError: 'INVITE_ERROR',
  InviteSent: 'INVITE_SENT',
  ManualOverride: 'MANUAL_OVERRIDE',
  OutOfNetwork: 'OUT_OF_NETWORK',
  Rejected: 'REJECTED',
  Stranger: 'STRANGER',
  Unknown: 'UNKNOWN',
  UserRejected: 'USER_REJECTED',
  Withdrawn: 'WITHDRAWN'
} as const;

export type IConnectionStatus = typeof IConnectionStatus[keyof typeof IConnectionStatus];
/** Input used for querying campaign connections */
export type IConnectionsByBlockedStatusInput = {
  /** Is Blocked Status */
  blockedStatus: IBlockedStatus;
  /** Campaign member ids to filter connections by */
  campaignMemberIds: Array<Scalars['ID']>;
  /** Pagination details */
  pagination: IPaginationInput;
  /** text search to filter connections by */
  searchText?: InputMaybe<Scalars['String']>;
};

/** Input used for querying campaign connections */
export type IConnectionsByConnectionStatusInput = {
  /** Campaign member ids to filter connections by */
  campaignMemberIds: Array<Scalars['ID']>;
  /** Whether or not to filter by open profile */
  isOpenProfile?: InputMaybe<Scalars['Boolean']>;
  /** Pagination details */
  pagination: IPaginationInput;
  /** text search to filter connections by */
  searchText?: InputMaybe<Scalars['String']>;
  /** Connection status to filter connections by. Currently only supports fetching one status */
  status: Array<IConnectionStatus>;
};

/** Input for querying connections by meeting status. */
export type IConnectionsByMeetingsInput = {
  /** IDs of campaigns the connection must be a part of */
  campaigns?: InputMaybe<Array<Scalars['ID']>>;
  /** Meeting statuses to match with */
  meeting: IMeetingInput;
  /** IDs of the org members the connection must be matched with */
  members?: InputMaybe<Array<Scalars['ID']>>;
  /** Pagination details */
  pagination: IPaginationInput;
};

/**
 * Input for querying connections by meeting user.
 * If no query filter is provided, results to all connections accessible by the user.
 */
export type IConnectionsByUserInput = {
  /** Pagination details */
  pagination: IPaginationInput;
};

/** Connections response with pagination context */
export type IConnectionsResponse = {
  __typename?: 'ConnectionsResponse';
  /** Connection results in the page */
  content: Array<ICampaignConnection>;
  /** Count of connections matching query */
  count: Scalars['Int'];
  /** Pagination context */
  pages: IPaginationContext;
};

/** ContactInfo to be embedded in Connection to surface OrgContact information that is still required */
export type IContactInfo = {
  __typename?: 'ContactInfo';
  /** Contact's Id */
  id: Scalars['ID'];
};

/** Input used for creating campaigns. */
export type ICreateCampaignInput = {
  /** The name of the campaign */
  name: Scalars['String'];
  /**
   * The org member id member we want to create the campaign for
   * (optional, if not provided the campaign will be created for the user making the request)
   */
  orgMemberId?: InputMaybe<Scalars['ID']>;
  /** The type of the campaign */
  type: ICampaignType;
};

/** Credits allocation for an organization */
export type ICredits = {
  __typename?: 'Credits';
  smartReply: Scalars['Int'];
};

/** Input for deactivating users */
export type IDeactivateUsersInput = {
  /** Account users belong to, only single account be updated at a time */
  accountId: Scalars['ID'];
  /** users to deactivate */
  users: Array<Scalars['ID']>;
};

/** Input used for duplicating campaigns. */
export type IDuplicateCampaignInput = {
  /** The ID of the campaign to duplicate */
  campaignId: Scalars['ID'];
  /** The name of the new campaign */
  name: Scalars['String'];
  /**
   * The orgMember who will own the created campaign
   * (optional, if not provided the campaign will be created for the user making the request)
   */
  orgMemberId?: InputMaybe<Scalars['ID']>;
};

/** Input for the editMessage query */
export type IEditMessageInput = {
  /** Instructions on how to edit the message */
  instruction: IEditMessageInstruction;
  /** The message to be edited */
  message: Scalars['String'];
};

/** Instruction for how to edit a message */
export type IEditMessageInstruction = {
  /** List of instructions on how to edit the message */
  instructions: Array<Scalars['String']>;
};

/** Response generated from the editMessage query */
export type IEditMessageResponse = IMessageResult | IModerationResult;

/** Input for generating an edited message with Smart Reply */
export type IEditSmartReplyInput = {
  /** The message to enhance */
  message: Scalars['String'];
  /** Prompt to use to enhance the provided message */
  prompt: ISmartReplyPrompt;
  /** The communication styles of the recipient */
  recipientCommunicationStyles?: InputMaybe<Array<Scalars['String']>>;
};

/** Input used for generating audience segment for a campaign */
export type IGenerateAudienceSegmentInput = {
  /** The campaign ID to generate audience segment for */
  campaignId: Scalars['ID'];
};

/** Response for starting audience segment generation */
export type IGenerateAudienceSegmentResponse = {
  __typename?: 'GenerateAudienceSegmentResponse';
  /** The LangGraph run ID */
  runId: Scalars['ID'];
  /** The run status of audience segment generation */
  status: IAudienceSegmentStatus;
  /** The LangGraph thread ID */
  threadId: Scalars['ID'];
};

/** Input used for generating business context for the given org member */
export type IGenerateBusinessContextInput = {
  orgMemberId: Scalars['ID'];
};

/** Input used for getting ai generated message/message edit for a campaign. */
export type IGenerateMessageInput = {
  /** The id of the campaign we want to get the ai generated sequence for */
  campaignId: Scalars['ID'];
  /** Description of message to generate or edit to make to the referenceMessage */
  description: Scalars['String'];
  /** The maximum number of characters the message can be */
  maxCharacterCount?: InputMaybe<Scalars['Int']>;
  /** The message to rephrase */
  referenceMessage?: InputMaybe<Scalars['String']>;
};

/** Input used for generating a message recommendation based on conversation history. */
export type IGenerateMessageRecommendationInput = {
  /** The org member id of the user (optional - if not provided, the org member id of the user making the request will be used) */
  orgMemberId?: InputMaybe<Scalars['ID']>;
  /** The id of the source profile (user) */
  sourceProfileId: Scalars['ID'];
  /** The id of the target profile (lead) */
  targetProfileId: Scalars['ID'];
};

/** Input used for getting ai generated sequence for a campaign. */
export type IGenerateMessageSequenceInput = {
  /** The id of the campaign we want to get the ai generated sequence for */
  campaignId: Scalars['ID'];
  /** Description of the user's business/etc */
  description: Scalars['String'];
  /** URL of the user's website */
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type IGenerateMessageSequenceResult = IGeneratedMessageSequence | IGeneratedMessageSequenceErrorResponse;

/** Input used for generating a preview of search list with the provided url */
export type IGenerateSearchListPreviewInput = {
  /** The audience segment name to use search criteria from */
  audienceSegmentName?: InputMaybe<Scalars['String']>;
  /** The id of the campaign this search list belongs to */
  campaignId: Scalars['ID'];
  /** The search list url to perform */
  searchListUrl?: InputMaybe<Scalars['String']>;
};

export type IGeneratedMessageSequence = {
  __typename?: 'GeneratedMessageSequence';
  /** The message sequence */
  messageSequence: Array<ISequenceNode>;
};

export type IGeneratedMessageSequenceErrorResponse = {
  __typename?: 'GeneratedMessageSequenceErrorResponse';
  /** The error message, can be used for display if need be */
  errorMessage: Scalars['String'];
  /** The error type, should not be used for display */
  errorType: Scalars['String'];
};

/** Input for getting user information */
export type IGetMemberInput = {
  /** Org Member's ID */
  orgMemberId?: InputMaybe<Scalars['ID']>;
};

/** An attention item for a user */
export type IIssue = IBaseAttentionItem & {
  __typename?: 'Issue';
  /** The priority of the issue */
  level: IAttentionLevel;
  /** The type of issue */
  type: IOrgMemberAttentionType;
};

/** Represents a key role performed by members of the target audience. */
export type IKeyRoleEntry = {
  __typename?: 'KeyRoleEntry';
  /** The label of the key role (e.g., "Strategic Advisor"). */
  label: Scalars['String'];
};

/** A dictionary entry for keys to values */
export type IKeyValueInput = {
  /** The key of the entry */
  key: Scalars['String'];
  /** The value of the entry */
  value: Scalars['String'];
};

/** Leadership team member information */
export type ILeadershipTeamMember = {
  __typename?: 'LeadershipTeamMember';
  /** Additional information about the leadership team member */
  bio?: Maybe<Scalars['String']>;
  /** Name of the leadership team member */
  name?: Maybe<Scalars['String']>;
  /** Role or position of the leadership team member */
  role?: Maybe<Scalars['String']>;
};

/** The DTO for a LinkedIn auth request */
export type ILinkedInAuthDto = {
  __typename?: 'LinkedInAuthDTO';
  /** The URL the user should be redirected to complete authentication */
  url: Scalars['String'];
};

/** The DTO for a LinkedIn auth error */
export type ILinkedInAuthError = {
  __typename?: 'LinkedInAuthError';
  /** The type of error experienced */
  type: ILinkedInAuthErrors;
};

/** Errors that can be encountered during LinkedIn authentication */
export const ILinkedInAuthErrors = {
  /** Could not find a custom domain for this user. */
  DomainNotFound: 'DOMAIN_NOT_FOUND',
  /** Authorization is already under way, please wait for it to complete */
  InProgress: 'IN_PROGRESS',
  /** An unexpected error was encountered */
  UnexpectedError: 'UNEXPECTED_ERROR'
} as const;

export type ILinkedInAuthErrors = typeof ILinkedInAuthErrors[keyof typeof ILinkedInAuthErrors];
/** Parameters required for initiate LinkedIn authentication */
export type ILinkedInAuthInput = {
  /** The URL to redirect to after a failed LinkedIn authentication */
  failureRedirectUrl: Scalars['String'];
  /** Org Member's ID */
  orgMemberId: Scalars['ID'];
  /** The URL to redirect to after a successful LinkedIn authentication */
  successRedirectUrl: Scalars['String'];
};

/** The response for a LinkedIn auth request */
export type ILinkedInAuthResponse = ILinkedInAuthDto | ILinkedInAuthError;

/** LinkedIn errors that can be exhibited by organization members */
export type ILinkedInErrors = {
  __typename?: 'LinkedInErrors';
  /** Member is blacklisted on linkedIn */
  blackListed: Scalars['Boolean'];
  /** Member has failed messages in the outbox */
  hasFailedMessages: Scalars['Boolean'];
  /** Member has their invitation allowance throttled */
  invitesThrottled: Scalars['Boolean'];
  /** Login is being retried */
  isBeingRetried: Scalars['Boolean'];
  /** Member is logged out of linkedIn */
  loggedOut: Scalars['Boolean'];
  /** Member has low number of inmail connections */
  lowInMails: Scalars['Boolean'];
  /** Member does not have a sales navigator subscription */
  salesNavMissing: Scalars['Boolean'];
};

export const ILinkedInLoginStatus = {
  LinkedinSyncInProgress: 'LINKEDIN_SYNC_IN_PROGRESS',
  LoggedInToLinkedin: 'LOGGED_IN_TO_LINKEDIN',
  LoggedOutOfLinkedin: 'LOGGED_OUT_OF_LINKEDIN'
} as const;

export type ILinkedInLoginStatus = typeof ILinkedInLoginStatus[keyof typeof ILinkedInLoginStatus];
/** LinkedIn parameter structure with ID and text */
export type ILinkedInParameter = {
  __typename?: 'LinkedInParameter';
  id: Scalars['String'];
  text: Scalars['String'];
};

/** Include/exclude filter for various LinkedIn parameters */
export type ILinkedInParameterFilter = {
  __typename?: 'LinkedInParameterFilter';
  exclude?: Maybe<Array<ILinkedInParameter>>;
  include?: Maybe<Array<ILinkedInParameter>>;
};

export type ILinkedInProfile = {
  __typename?: 'LinkedInProfile';
  /** The LinkedIn alias */
  alias?: Maybe<Scalars['String']>;
  /** Company name */
  company?: Maybe<Scalars['String']>;
  /** Number of connections */
  connectionCount: Scalars['Int'];
  /** Date the profile was created/first seen */
  dateCreated: Scalars['DateTime'];
  /** The LinkedIn Entity URN */
  entityUrn: Scalars['String'];
  /** First name */
  firstName: Scalars['String'];
  /** The ID of the linkedin profile. */
  id: Scalars['ID'];
  /** Industry */
  industry?: Maybe<Scalars['String']>;
  /** Whether this is an open profile */
  isOpenProfile: Scalars['Boolean'];
  /** Last name */
  lastName: Scalars['String'];
  /** Location */
  location?: Maybe<Scalars['String']>;
  /** The full name of the profile */
  name: Scalars['String'];
  /** Url to profile picture */
  profilePictureUrl?: Maybe<Scalars['String']>;
  /** Profile summary/about section */
  summary?: Maybe<Scalars['String']>;
  /** Job title */
  title?: Maybe<Scalars['String']>;
  /** The LinkedIn URN */
  urn: Scalars['String'];
};

/** Work experience from LinkedIn profile */
export type ILinkedInWorkExperience = {
  __typename?: 'LinkedInWorkExperience';
  /** LinkedIn Company ID */
  companyId?: Maybe<Scalars['String']>;
  /** Company name */
  companyName?: Maybe<Scalars['String']>;
  /** End date of the role */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Whether this is the current role */
  isCurrent: Scalars['Boolean'];
  /** Job title/position */
  role?: Maybe<Scalars['String']>;
  /** Start date of the role */
  startDate?: Maybe<Scalars['DateTime']>;
};

/** Input used for querying LinkedIn work experience for the given org member */
export type ILinkedInWorkExperienceQueryInput = {
  /** If true we will fetch profile directly from linkedin and skip cache */
  forceFreshProfileFetch?: InputMaybe<Scalars['Boolean']>;
  orgMemberId: Scalars['ID'];
};

/** A meeting with a campaign connection. */
export type IMeetingContext = {
  __typename?: 'MeetingContext';
  /**
   * Whether or not the meeting is currently booked.
   * @deprecated booked is deprecated. Use bookedDate instead
   */
  booked: Scalars['Boolean'];
  /** The date meeting is booked */
  bookedDate?: Maybe<Scalars['DateTime']>;
  /** The date meeting is detected */
  detectedDate?: Maybe<Scalars['DateTime']>;
  /** The status of meeting booked detection (undefined, true, false) */
  isDetectionAccurate?: Maybe<Scalars['Boolean']>;
};

/** Input used for matching meetings */
export type IMeetingInput = {
  /** Specifies the latest time of meetings queried */
  end?: InputMaybe<Scalars['DateTime']>;
  /** Specifies the earliest time of meetings queried */
  start?: InputMaybe<Scalars['DateTime']>;
  /** The status that should be searched for */
  status?: InputMaybe<IMeetingStatus>;
};

/** Input for desired status for a meeting */
export const IMeetingStatus = {
  /** A meeting is booked */
  Booked: 'BOOKED',
  /** A meeting is detected */
  Detected: 'DETECTED',
  /** A meeting is neither booked nor detected */
  None: 'NONE'
} as const;

export type IMeetingStatus = typeof IMeetingStatus[keyof typeof IMeetingStatus];
/** Input describing a message between two */
export type IMessageInput = {
  /** The message */
  message: Scalars['String'];
  /** Boolean indicating if the message was outbound (sent to the prospect) or inbound (received from the prospect) */
  outbound: Scalars['Boolean'];
};

/** Response type for message recommendation generation */
export type IMessageRecommendationResponse = {
  __typename?: 'MessageRecommendationResponse';
  /** The recommended message content */
  content: Scalars['String'];
  /** The unique id of the recommendation */
  id: Scalars['ID'];
  /** When the recommendation was last updated */
  lastUpdated: Scalars['DateTime'];
};

/** A response with a generated message */
export type IMessageResult = {
  __typename?: 'MessageResult';
  /** The generated message */
  message: Scalars['String'];
};

export type IModerationCategories = {
  __typename?: 'ModerationCategories';
  /** Whether the text contains hateful language */
  hate: Scalars['Boolean'];
  /** Whether the text contains threatening language */
  hateThreatening: Scalars['Boolean'];
  /** Whether the text contains self-hard language */
  selfHarm: Scalars['Boolean'];
  /** Whether the text contains sexual language */
  sexual: Scalars['Boolean'];
  /** Whether the text contains sexual language related to minors */
  sexualMinors: Scalars['Boolean'];
  /** Whether the text contains violent language */
  violence: Scalars['Boolean'];
  /** Whether the text contains violent language that is graphic */
  violenceGraphic: Scalars['Boolean'];
};

export type IModerationResult = {
  __typename?: 'ModerationResult';
  /** The categories that the text is flagged for */
  categories: IModerationCategories;
  /** Whether the text is flagged for moderation */
  flagged: Scalars['Boolean'];
};

export type IMutation = {
  __typename?: 'Mutation';
  /** Activate a regular account */
  activateRegularAccount: IAccount;
  /** Activate a set of users for a single account */
  activateUsers: Array<IUser>;
  /** Create an account */
  addAccount: IAccount;
  /** Create an organization */
  addOrganization: IOrganization;
  /** Analyze communication styles of the lead in a campaign connection */
  analyzeCommunicationStyles: ICampaignConnection;
  /**
   * Books a meeting with a campaign connection. Deprecated in favour of updateConnectionMeeting.
   * @deprecated Use 'updateConnectionMeeting'
   */
  bookMeeting: ICampaignConnection;
  /** Create a campaign */
  createCampaign: ICampaign;
  /** Deactivate a regular account */
  deactivateRegularAccount: IAccount;
  /** Deactivate a set of users for a single account */
  deactivateUsers: Array<IUser>;
  /** Duplicate a campaign with a new name and owner */
  duplicateCampaign: ICampaign;
  /** Generate audience segment for a campaign */
  generateAudienceSegment: IGenerateAudienceSegmentResponse;
  /** Generate business context based on user's current role */
  generateBusinessContext: Array<IBusinessContext>;
  /** Get ai generated inMail message sequence for a campaign */
  generateInMailMessageSequence: Array<ISequenceNode>;
  /** Kicks off the LinkedIn authentication process by generating a Hosted Auth URL */
  generateLinkedInAuth: ILinkedInAuthResponse;
  /** Get ai generated message/message edit for a campaign */
  generateMessage: ISequenceNode;
  /** Generate a message recommendation based on conversation history */
  generateMessageRecommendation: IMessageRecommendationResponse;
  /**
   * Get ai generated sequence for a campaign
   * @deprecated Use generateMessageSequenceV2 instead
   */
  generateMessageSequence: Array<ISequenceNode>;
  /** Get ai generated sequence for a campaign (with error handling) */
  generateMessageSequenceV2: IGenerateMessageSequenceResult;
  /** Generate a preview of a campaign audience from a search list URL */
  generateSearchListPreview: ISearchListPreviewResult;
  /** Rejects meeting booked detection in the meeting context of a campaign connection */
  rejectMeetingDetection: ICampaignConnection;
  /** stop automation for a campaign connection */
  stopAutomation: ICampaignConnection;
  /** Enable or disable a users warmup status */
  toggleWarmupStatus: IOrgMember;
  /** Records a messaging change for the provided campaign. */
  trackMessagingChange: ICampaignUsage;
  /** Records a search list update for the provided campaign member. */
  trackSearchListUpdate: ICampaignUsage;
  /** Update account owner by account id */
  updateAccountManagerByAccountId: IAccount;
  /** Update an accounts name */
  updateAccountName: IAccount;
  /** Update allocations for specific campaigns that belong to a user */
  updateCampaignAllocations: Array<ICampaign>;
  /** Update auto reply settings for a campaign */
  updateCampaignAutoReplySettings: ICampaign;
  /** Update the calendar link for a campaign */
  updateCampaignCalendarLink: ICampaign;
  /** Update auto reply settings for a campaign connection */
  updateCampaignConnectionAutoReplySettings: ICampaignConnection;
  /** Update campaign context (goal and business context ID) */
  updateCampaignContext: ICampaign;
  /** Update the name of a campaign */
  updateCampaignName: ICampaign;
  /** Update the status of a campaign. */
  updateCampaignStatus: ICampaign;
  /** Updates the meeting context of a campaign connection. */
  updateConnectionMeeting: ICampaignConnection;
  /** Update if inMail is enabled for a campaign */
  updateInMailEnabled: ICampaign;
  /** Update the message sequence for a campaign */
  updateInMailMessageSequence: Array<ISequenceNode>;
  /** Update the message sequence for a campaign */
  updateMessageSequence: Array<ISequenceNode>;
  /** Update OrgContact's company */
  updateOrgContactCompany: IOrgContact;
  /** Update OrgContact's email address */
  updateOrgContactEmail: IOrgContact;
  /** Update OrgContact's phone number */
  updateOrgContactPhoneNumber: IOrgContact;
  /** Update OrgContact's title */
  updateOrgContactTitle: IOrgContact;
  /** Update or create a service schedule for a campaign */
  updateServiceSchedule: IServiceSchedule;
  /** Update a tenant */
  updateTenant: ITenant;
  /** Update a users given names */
  updateUserGivenNames: IUser;
};


export type IMutationActivateRegularAccountArgs = {
  accountId: Scalars['ID'];
};


export type IMutationActivateUsersArgs = {
  input: IActivateUsersInput;
};


export type IMutationAddAccountArgs = {
  input: IAddAccountInput;
};


export type IMutationAddOrganizationArgs = {
  input: IAddOrganizationInput;
};


export type IMutationAnalyzeCommunicationStylesArgs = {
  campaignConnectionId: Scalars['ID'];
};


export type IMutationBookMeetingArgs = {
  campaignConnectionId: Scalars['ID'];
};


export type IMutationCreateCampaignArgs = {
  input: ICreateCampaignInput;
};


export type IMutationDeactivateRegularAccountArgs = {
  accountId: Scalars['ID'];
};


export type IMutationDeactivateUsersArgs = {
  input: IDeactivateUsersInput;
};


export type IMutationDuplicateCampaignArgs = {
  input: IDuplicateCampaignInput;
};


export type IMutationGenerateAudienceSegmentArgs = {
  campaignId: Scalars['ID'];
};


export type IMutationGenerateBusinessContextArgs = {
  input: IGenerateBusinessContextInput;
};


export type IMutationGenerateInMailMessageSequenceArgs = {
  input: IGenerateMessageSequenceInput;
};


export type IMutationGenerateLinkedInAuthArgs = {
  input: ILinkedInAuthInput;
};


export type IMutationGenerateMessageArgs = {
  input: IGenerateMessageInput;
};


export type IMutationGenerateMessageRecommendationArgs = {
  input: IGenerateMessageRecommendationInput;
};


export type IMutationGenerateMessageSequenceArgs = {
  input: IGenerateMessageSequenceInput;
};


export type IMutationGenerateMessageSequenceV2Args = {
  input: IGenerateMessageSequenceInput;
};


export type IMutationGenerateSearchListPreviewArgs = {
  input: IGenerateSearchListPreviewInput;
};


export type IMutationRejectMeetingDetectionArgs = {
  campaignConnectionId: Scalars['ID'];
};


export type IMutationStopAutomationArgs = {
  campaignConnectionId: Scalars['ID'];
};


export type IMutationToggleWarmupStatusArgs = {
  input: IToggleWarmupStatusInput;
};


export type IMutationTrackMessagingChangeArgs = {
  campaignId: Scalars['ID'];
  campaignMemberId?: InputMaybe<Scalars['ID']>;
};


export type IMutationTrackSearchListUpdateArgs = {
  campaignId: Scalars['ID'];
  campaignMemberId: Scalars['ID'];
};


export type IMutationUpdateAccountManagerByAccountIdArgs = {
  input: IUpdateAccountManagerByAccountIdInput;
};


export type IMutationUpdateAccountNameArgs = {
  input: IUpdateAccountNameInput;
};


export type IMutationUpdateCampaignAllocationsArgs = {
  input: IUpdateCampaignAllocationsInput;
};


export type IMutationUpdateCampaignAutoReplySettingsArgs = {
  input: IUpdateAutoReplySettingsInput;
};


export type IMutationUpdateCampaignCalendarLinkArgs = {
  input: IUpdateCampaignCalendarLinkInput;
};


export type IMutationUpdateCampaignConnectionAutoReplySettingsArgs = {
  input: IUpdateConnectionAutoReplySettingsInput;
};


export type IMutationUpdateCampaignContextArgs = {
  input: IUpdateCampaignContextInput;
};


export type IMutationUpdateCampaignNameArgs = {
  input: IUpdateCampaignNameInput;
};


export type IMutationUpdateCampaignStatusArgs = {
  campaignId: Scalars['ID'];
  status: ICampaignStatusInput;
};


export type IMutationUpdateConnectionMeetingArgs = {
  campaignConnectionId: Scalars['ID'];
  isBooked: Scalars['Boolean'];
};


export type IMutationUpdateInMailEnabledArgs = {
  input: IUpdateInMailEnabledInput;
};


export type IMutationUpdateInMailMessageSequenceArgs = {
  input: IUpdateMessageSequenceInput;
};


export type IMutationUpdateMessageSequenceArgs = {
  input: IUpdateMessageSequenceInput;
};


export type IMutationUpdateOrgContactCompanyArgs = {
  company: Scalars['String'];
  orgContactId: Scalars['ID'];
};


export type IMutationUpdateOrgContactEmailArgs = {
  email: Scalars['String'];
  orgContactId: Scalars['ID'];
};


export type IMutationUpdateOrgContactPhoneNumberArgs = {
  orgContactId: Scalars['ID'];
  phoneNumber: Scalars['String'];
};


export type IMutationUpdateOrgContactTitleArgs = {
  orgContactId: Scalars['ID'];
  title: Scalars['String'];
};


export type IMutationUpdateServiceScheduleArgs = {
  input: IUpdateServiceScheduleInput;
};


export type IMutationUpdateTenantArgs = {
  input: IUpdateTenantInput;
};


export type IMutationUpdateUserGivenNamesArgs = {
  input: IUpdateUserGivenNamesInput;
};

/** Network distance levels or group indicator */
export const INetworkDistance = {
  FirstDegree: 'FIRST_DEGREE',
  Group: 'GROUP',
  SecondDegree: 'SECOND_DEGREE',
  ThirdDegree: 'THIRD_DEGREE'
} as const;

export type INetworkDistance = typeof INetworkDistance[keyof typeof INetworkDistance];
/** Next node in the campaign automation sequence */
export type INextAutomationNode = {
  __typename?: 'NextAutomationNode';
  /** Id of automation */
  id: Scalars['ID'];
  /** The node's message, should it exist */
  message?: Maybe<Scalars['String']>;
  /** Name of automation node */
  name: Scalars['String'];
};

export type INurtureCampaignStats = IBaseCampaignStats & {
  __typename?: 'NurtureCampaignStats';
  /**
   * The end of the date range the stats were collected from.
   * Null or undefined if there is no end to the date range.
   */
  end?: Maybe<Scalars['DateTime']>;
  /** The number of interested replies from contacts in the target campaign */
  numInterestedReplies: Scalars['Int'];
  /** The number of meetings booked with LinkedIn users targeted by the campaign */
  numMeetingsBooked: Scalars['Int'];
  /** The number of messages sent out by the campaign. */
  numSendMessages: Scalars['Int'];
  /** The number of replies from LinkedIn users targeted by the campaign. */
  numUserReplies: Scalars['Int'];
  /** The ID of the owner of the stats (i.e. the campaign member or campaign they are for) */
  ownerId: Scalars['ID'];
  /** The type of the owner of the campaign. */
  ownerType: ICampaignStatsOwnerType;
  /** The percentage of replies that were categorized as an interested reply */
  percentInterestedReplied?: Maybe<Scalars['Float']>;
  /** The percentage of users contacted by the who've returned a message. */
  percentReplied?: Maybe<Scalars['Float']>;
  /**
   * The start of the date range the stats were collected from.
   * Null or undefined if there is no start to the date range.
   */
  start?: Maybe<Scalars['DateTime']>;
};

/** Org Contact Information */
export type IOrgContact = {
  __typename?: 'OrgContact';
  /**
   * Company of the organization contact.
   * Empty string if information is unknown.
   */
  company: Scalars['String'];
  /**
   * Email of the organization contact.
   * Empty string if information is unknown.
   */
  email: Scalars['String'];
  /** First name of the organization contact */
  firstName: Scalars['String'];
  /** Org Contact's ID */
  id: Scalars['ID'];
  /** Last name of the organization contact */
  lastName: Scalars['String'];
  /** ID of the organization the contact belongs to */
  organizationId: Scalars['ID'];
  /**
   * Phone number of the organization contact.
   * Empty string if information is unknown.
   */
  phoneNumber: Scalars['String'];
  /**
   * Title of the organization contact.
   * Empty string if information is unknown.
   */
  title: Scalars['String'];
};

/** Possible filters for orgContacts query */
export type IOrgContactsFilters = {
  /** Specific org contacts to get */
  orgContactIds: Array<Scalars['ID']>;
};

/** Possible filters for organization query */
export type IOrgFilters = {
  /** Whether to include individual organizations in the query */
  includeIndividuals?: InputMaybe<Scalars['Boolean']>;
  /** Specific organizations to get by tenant ids */
  tenantIds: Array<Scalars['ID']>;
};

/** OrgInfo to be embedded in Account to surface Organization information still required */
export type IOrgInfo = {
  __typename?: 'OrgInfo';
  /** Organization's ID */
  id: Scalars['ID'];
};

/** Org Member Information */
export type IOrgMember = {
  __typename?: 'OrgMember';
  /** Attention items associated with the org member */
  attentionItems: Array<IOrgMemberAttentionItem>;
  /** Org Member's ID */
  id: Scalars['ID'];
  /** Whether the organization member is active */
  isActive: Scalars['Boolean'];
  /** LinkedIn errors exhibited by the org member */
  linkedInErrors: ILinkedInErrors;
  /** Login status of the organization member */
  loginStatus: ILinkedInLoginStatus;
  /** ID of the organization the member belongs to */
  organizationId: Scalars['ID'];
  /** Org member's role */
  role: IOrganizationMemberRole;
  /** Org Member's  user */
  user: IUser;
  /** Org Member's user id */
  userId: Scalars['ID'];
  /** Org Member's user info */
  userInfo: IUserInfo;
  /** Warmup status information for the organization member */
  warmUpSettings: IWarmUpSettings;
};

/** Organization Member Attention item */
export type IOrgMemberAttentionItem = IBaseAttentionItem & {
  __typename?: 'OrgMemberAttentionItem';
  /** The attention item level */
  level: IAttentionLevel;
  /** The org member's ID */
  memberId: Scalars['ID'];
  /** The campaign attention item type */
  type: IOrgMemberAttentionType;
};

/** Org Member attention item's type */
export const IOrgMemberAttentionType = {
  /** Member is logged out of LinkedIn */
  LoggedOutOfLinkedin: 'LOGGED_OUT_OF_LINKEDIN',
  /** Member is missing sales nav connection */
  SalesNavMissing: 'SALES_NAV_MISSING'
} as const;

export type IOrgMemberAttentionType = typeof IOrgMemberAttentionType[keyof typeof IOrgMemberAttentionType];
/** OrgMemberInfo to be embedded in User to surface OrgMember information still required */
export type IOrgMemberInfo = {
  __typename?: 'OrgMemberInfo';
  /** Org Member's ID */
  id: Scalars['ID'];
  /** Org Member's role */
  role: IOrganizationMemberRole;
};

/** Possible filters for orgMembers query. All filters are ANDed if specified. */
export type IOrgMembersFilters = {
  /** Specific Org Members that belong in the provided organizations to be retrieved */
  orgMemberIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Organization IDs of the org members to be retrieved */
  organizationIds: Array<Scalars['ID']>;
};

/** Organization Information (to be deprecated) */
export type IOrganization = {
  __typename?: 'Organization';
  /** Organization's account manager */
  accountManager?: Maybe<IAccountManager>;
  /** Organization's credit allocation */
  credits: ICredits;
  /**
   * Organization's customer success owner
   * @deprecated Use `accountManager`
   */
  customerSuccessOwner?: Maybe<IUser>;
  /** Organization's ID */
  id: Scalars['ID'];
  /** Organization's members */
  members: Array<IOrgMember>;
  /** Monthly limit for LinkedIn open inmails */
  monthlyInMailLimit: Scalars['Int'];
  /** Monthly limit for LinkedIn invites */
  monthlyInviteLimit: Scalars['Int'];
  /** Monthly limit for LinkedIn messages */
  monthlyMessageLimit: Scalars['Int'];
  /** Organization's name */
  name: Scalars['String'];
  /** Organization's Tenant Id */
  tenantId: Scalars['ID'];
};

/** Represents an organization associated with the target audience. */
export type IOrganizationEntry = {
  __typename?: 'OrganizationEntry';
  /** The name of the organization (e.g., "SkyH2O"). */
  name: Scalars['String'];
};

export type IOrganizationFilter = {
  /** Organization Ids */
  id: Scalars['ID'];
  /** Sepcific org members in the organization */
  memberIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Possible filters for the organizations query */
export type IOrganizationFilters = {
  /** IDs of the organizations to fetch */
  organizationIds: Array<Scalars['ID']>;
};

export const IOrganizationMemberRole = {
  /** Admin role */
  Admin: 'ADMIN',
  /** Advanced user role */
  Advanced: 'ADVANCED',
  /** Basic role */
  Basic: 'BASIC'
} as const;

export type IOrganizationMemberRole = typeof IOrganizationMemberRole[keyof typeof IOrganizationMemberRole];
/** Defines pagination options for a given query, currently only includes offset based pagination */
export type IPagination = {
  /** The (0 based) page index of results to show */
  pageIndex: Scalars['Int'];
  /** Max number of entities to include in a page */
  pageSize: Scalars['Int'];
};

/** Pagination context */
export type IPaginationContext = {
  __typename?: 'PaginationContext';
  /** The current page */
  current: Scalars['Int'];
  /** The total number of pages */
  total: Scalars['Int'];
};

/** Input used to define pagination details */
export type IPaginationInput = {
  /** Starting page of the results queried */
  page?: InputMaybe<Scalars['Int']>;
  /** Number of items queried */
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Represents a job position and the number of target audience with that position. */
export type IPositionEntry = {
  __typename?: 'PositionEntry';
  /** The number of people in the preview with this position. */
  count: Scalars['Int'];
  /** The job title or position name (e.g., "CEO / Founder"). */
  title: Scalars['String'];
};

/** Prompt Information */
export type IPrompt = {
  __typename?: 'Prompt';
  /** The actions the prompt applies to */
  action: IPromptActions;
  /** Prompt ID */
  id: Scalars['ID'];
  /** Label of the prompt */
  label: Scalars['String'];
  /** The use case the prompt applies to */
  useCases?: Maybe<Array<IPromptUseCases>>;
};

/** Actions a prompt may apply to */
export const IPromptActions = {
  /** Action for editing an existing message */
  Edit: 'EDIT',
  /** Action for generating a new message */
  Write: 'WRITE'
} as const;

export type IPromptActions = typeof IPromptActions[keyof typeof IPromptActions];
/** Use cases a prompt may be intended for */
export const IPromptUseCases = {
  /** Use case for prompts intended to follow up with unresponsive prospects */
  FollowUp: 'FOLLOW_UP',
  /**
   * Use case for prompts intended to push the conversation forward with
   * interested prospects
   */
  Interested: 'INTERESTED',
  /**
   * Use case for prompts intended to politely close the conversation with a
   * prospect who is not interested
   */
  NotInterested: 'NOT_INTERESTED'
} as const;

export type IPromptUseCases = typeof IPromptUseCases[keyof typeof IPromptUseCases];
export type IProspectingCampaignStats = IBaseCampaignStats & {
  __typename?: 'ProspectingCampaignStats';
  /**
   * The end of the date range the stats were collected from.
   * Null or undefined if there is no end to the date range.
   */
  end?: Maybe<Scalars['DateTime']>;
  /** The number of replies to an InMail */
  numInMailReplies: Scalars['Int'];
  /** The number of InMail sent */
  numInMailSent: Scalars['Int'];
  /** The number of interested replies to an InMail */
  numInterestedInMailReplies: Scalars['Int'];
  /** The number of interested replies from contacts in the target campaign */
  numInterestedReplies: Scalars['Int'];
  /** The number of invites sent out through the campaign. */
  numInvitesSent: Scalars['Int'];
  /** The number of meetings booked with LinkedIn users targeted by the campaign */
  numMeetingsBooked: Scalars['Int'];
  /** The number of replies from LinkedIn users targeted by the campaign. */
  numUserReplies: Scalars['Int'];
  /** The number of LinkedIn users connected to by the campaign. */
  numUsersConnected: Scalars['Int'];
  /** The ID of the owner of the stats (i.e. the campaign member or campaign they are for) */
  ownerId: Scalars['ID'];
  /** The type of the owner of the campaign. */
  ownerType: ICampaignStatsOwnerType;
  /** The percentage of users contacted by the campaign who accepted a connection request. */
  percentConnected?: Maybe<Scalars['Float']>;
  /** The percentage of users contacted by InMail who've returned a message */
  percentInMailReplied?: Maybe<Scalars['Float']>;
  /** The percentage of InMail replies that were categorized as an interested reply */
  percentInterestedInMailReplied?: Maybe<Scalars['Float']>;
  /** The percentage of replies that were categorized as an interested reply */
  percentInterestedReplied?: Maybe<Scalars['Float']>;
  /** The percentage of users contacted by the who've returned a message. */
  percentReplied?: Maybe<Scalars['Float']>;
  /**
   * The start of the date range the stats were collected from.
   * Null or undefined if there is no start to the date range.
   */
  start?: Maybe<Scalars['DateTime']>;
};

export type IQuery = {
  __typename?: 'Query';
  _service: I_Service;
  /** Query for accounts by the given filters */
  account: IAccount;
  /** Query for getting account by id */
  admin_account: IAccount;
  /** Query for accounts by the given filters */
  admin_accounts: Array<IAccount>;
  /** Query for getting the count of accounts by the given filters */
  admin_num_accounts: Scalars['Int'];
  /** Query for organizations by the given filters */
  admin_organizations: Array<IOrganization>;
  /** Query for tenants by the given filters */
  admin_tenants: Array<ITenant>;
  /** Query for users by the given filters */
  admin_users: Array<IUser>;
  /** Query audience segment status and result */
  audienceSegment?: Maybe<IAudienceSegmentResult>;
  /** Query for business contexts */
  businessContexts: Array<IBusinessContext>;
  /** Query for campaign allocations */
  campaignAllocationsByOrgMember: Array<ICampaignAllocationListItem>;
  /** Query for campaign connection */
  campaignConnection: ICampaignConnection;
  /**
   * Query for campaign connections
   * @deprecated Use 'campaignConnectionsPaginated'
   */
  campaignConnections: Array<ICampaignConnection>;
  /**
   * Query for campaign connections by connection status
   * @deprecated Use 'campaignConnectionsPaginated'
   */
  campaignConnectionsByBlockedStatus: IConnectionsResponse;
  /**
   * Query for campaign connections by connection status
   * @deprecated Use 'campaignConnectionsPaginated'
   */
  campaignConnectionsByConnectionStatus: IConnectionsResponse;
  /** Query for detected or booked meetings */
  campaignConnectionsByMeetings: IConnectionsResponse;
  /**
   * Query for connections accessible by the authenticated user
   * @deprecated Use 'campaignConnectionsByMeetings'
   */
  campaignConnectionsByUser: IConnectionsResponse;
  /** Query for campaign connections paginated */
  campaignConnectionsPaginated: IConnectionsResponse;
  /** Query for events pertaining to a campaign member. */
  campaignMemberEvents: Array<ICampaignUsage>;
  /** Query for a campaign's stats between the start and end date grouped by the provided interval. */
  campaignStats: Array<ICampaignStats>;
  /**
   * Query for all campaigns, optionally filtering by a search term.
   * @deprecated campaignSummaries is deprecated. Use campaigns instead.
   */
  campaignSummaries: Array<ICampaign>;
  /** Query for campaigns by campaign id */
  campaignSummary: ICampaign;
  /** Query for campaigns */
  campaigns: Array<ICampaign>;
  /** Query for chat completion given messages and optional parameters. */
  chatCompletion: IChatCompletionOrModerationResult;
  /** Query for editing a message. */
  editMessage: IEditMessageResponse;
  /** Enhance a message with Smart Reply */
  editSmartReply: ISmartReplyResponse;
  /** Query for a specific orgMember by ID, or the current user's orgMember if no ID is provided */
  getMember: IOrgMember;
  /** Query for LinkedIn work experience for an org member */
  linkedInWorkExperience: Array<ILinkedInWorkExperience>;
  /** Query for org contacts by the given filters */
  orgContacts: Array<IOrgContact>;
  /** Query for org members by the given filters */
  orgMembers: Array<IOrgMember>;
  /** Query for organizations by the given filters */
  organizations: Array<IOrganization>;
  /** Get all Smart Reply Prompts */
  prompts: Array<IPrompt>;
  /** Query for generating text based off a prompt label and values to replace in that prompt */
  secureMessage: ISecureMessageResponse;
  /** Write a Smart Reply */
  writeSmartReply: ISmartReplyResponse;
};


export type IQueryAccountArgs = {
  input: IAccountFilter;
};


export type IQueryAdmin_AccountArgs = {
  id: Scalars['ID'];
};


export type IQueryAdmin_AccountsArgs = {
  input: IAccountFilters;
  pagination?: InputMaybe<IPagination>;
};


export type IQueryAdmin_Num_AccountsArgs = {
  input: IAccountFilters;
};


export type IQueryAdmin_OrganizationsArgs = {
  input: IOrgFilters;
};


export type IQueryAdmin_TenantsArgs = {
  input: ITenantFilters;
};


export type IQueryAdmin_UsersArgs = {
  input: IUserFilters;
};


export type IQueryAudienceSegmentArgs = {
  campaignId: Scalars['ID'];
};


export type IQueryBusinessContextsArgs = {
  input: IBusinessContextsQueryInput;
};


export type IQueryCampaignAllocationsByOrgMemberArgs = {
  input: ICampaignAllocationsByOrgMemberQueryInput;
};


export type IQueryCampaignConnectionArgs = {
  connectionId: Scalars['ID'];
};


export type IQueryCampaignConnectionsArgs = {
  input: ICampaignConnectionsInput;
};


export type IQueryCampaignConnectionsByBlockedStatusArgs = {
  input: IConnectionsByBlockedStatusInput;
};


export type IQueryCampaignConnectionsByConnectionStatusArgs = {
  input: IConnectionsByConnectionStatusInput;
};


export type IQueryCampaignConnectionsByMeetingsArgs = {
  input: IConnectionsByMeetingsInput;
};


export type IQueryCampaignConnectionsByUserArgs = {
  input: IConnectionsByUserInput;
};


export type IQueryCampaignConnectionsPaginatedArgs = {
  input: ICampaignConnectionsPaginatedInput;
};


export type IQueryCampaignMemberEventsArgs = {
  input: ICampaignMemberEventsInput;
};


export type IQueryCampaignStatsArgs = {
  input: ICampaignStatsInput;
};


export type IQueryCampaignSummariesArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type IQueryCampaignSummaryArgs = {
  campaignId: Scalars['ID'];
};


export type IQueryCampaignsArgs = {
  input: ICampaignInput;
};


export type IQueryChatCompletionArgs = {
  input: IChatCompletionInput;
};


export type IQueryEditMessageArgs = {
  input: IEditMessageInput;
};


export type IQueryEditSmartReplyArgs = {
  input: IEditSmartReplyInput;
};


export type IQueryGetMemberArgs = {
  input: IGetMemberInput;
};


export type IQueryLinkedInWorkExperienceArgs = {
  input: ILinkedInWorkExperienceQueryInput;
};


export type IQueryOrgContactsArgs = {
  input: IOrgContactsFilters;
};


export type IQueryOrgMembersArgs = {
  input: IOrgMembersFilters;
};


export type IQueryOrganizationsArgs = {
  input: IOrganizationFilters;
};


export type IQuerySecureMessageArgs = {
  input: ISecureMessageInput;
};


export type IQueryWriteSmartReplyArgs = {
  input: IWriteSmartReplyInput;
};

/** Sales Navigator People Search criteria */
export type ISalesNavigatorPeopleSearch = {
  __typename?: 'SalesNavigatorPeopleSearch';
  /** Company name filters */
  company?: Maybe<IStringFilter>;
  /** Company headcount ranges */
  companyHeadcount?: Maybe<Array<ICompanyHeadcountRange>>;
  /** Company location filters */
  companyLocation?: Maybe<ILinkedInParameterFilter>;
  /** Filter for people following your company */
  followingYourCompany?: Maybe<Scalars['Boolean']>;
  /** Job function filters */
  function?: Maybe<ILinkedInParameterFilter>;
  /** Industry filters */
  industry?: Maybe<ILinkedInParameterFilter>;
  /** Keyword search terms */
  keywords?: Maybe<Scalars['String']>;
  /** Location filters */
  location?: Maybe<ILinkedInParameterFilter>;
  /** Exclude recently messaged profiles */
  messagedRecently?: Maybe<Scalars['Boolean']>;
  /** Network distance preferences */
  networkDistance?: Maybe<Array<INetworkDistance>>;
  /** Profile language preferences */
  profileLanguage?: Maybe<Array<ILinkedInParameter>>;
  /** Job role filters */
  role?: Maybe<IStringFilter>;
  /** School/education filters */
  school?: Maybe<ILinkedInParameterFilter>;
  /** Seniority level filters */
  seniority?: Maybe<IStringFilter>;
  /** General tenure filters */
  tenure?: Maybe<Array<ITenureRange>>;
  /** Tenure at current company */
  tenureAtCompany?: Maybe<Array<ITenureRange>>;
  /** Tenure at current role */
  tenureAtRole?: Maybe<Array<ITenureRange>>;
  /** Filter for recently viewed profiles */
  viewedProfileRecently?: Maybe<Scalars['Boolean']>;
};

/** Error returned for search list preview operations */
export type ISearchListPreviewError = {
  __typename?: 'SearchListPreviewError';
  /** The type of error that occurred */
  errorType: ISearchListPreviewErrorType;
  /** The error message */
  message: Scalars['String'];
};

/** Enum for search list preview error types */
export const ISearchListPreviewErrorType = {
  /** LinkedIn account disconnected or credentials expired */
  AccountDisconnected: 'ACCOUNT_DISCONNECTED',
  /** The search list is empty */
  EmptySearchList: 'EMPTY_SEARCH_LIST',
  /** Sales nav feature is not subscribed */
  FeatureNotSubscribed: 'FEATURE_NOT_SUBSCRIBED',
  /** Invalid saved search resource identifier */
  InvalidSavedSearchResource: 'INVALID_SAVED_SEARCH_RESOURCE',
  /** Invalid search list URL format */
  InvalidSearchListUrlFormat: 'INVALID_SEARCH_LIST_URL_FORMAT',
  /** Rate limit exceeded for search list preview requests */
  RateLimitExceeded: 'RATE_LIMIT_EXCEEDED',
  /** Search list preview request timed out */
  RequestTimeout: 'REQUEST_TIMEOUT',
  /** Search list preview service unavailable */
  ServiceUnavailable: 'SERVICE_UNAVAILABLE'
} as const;

export type ISearchListPreviewErrorType = typeof ISearchListPreviewErrorType[keyof typeof ISearchListPreviewErrorType];
/** Details about the company and role highlighted in the preview list. */
export type ISearchListPreviewPosition = {
  __typename?: 'SearchListPreviewPosition';
  /** LinkedIn company identifier. */
  companyId: Scalars['String'];
  /** Display name of the company. */
  companyName: Scalars['String'];
  /** Public LinkedIn URL for the company, when available. */
  companyUrl?: Maybe<Scalars['String']>;
  /** Industries associated with the company. */
  industry: Array<Scalars['String']>;
  /** Title held by the prospect at this company. */
  position: Scalars['String'];
  /** Time spent in the position. */
  tenure?: Maybe<ISearchListPreviewTenure>;
};

/** Representative prospect included in the preview list. */
export type ISearchListPreviewProspect = {
  __typename?: 'SearchListPreviewProspect';
  /** Current role information for the prospect. */
  currentPosition?: Maybe<ISearchListPreviewPosition>;
  /** Headline shown on the prospect's LinkedIn profile. */
  headline: Scalars['String'];
  /** Primary location listed on the profile. */
  location: Scalars['String'];
  /** Prospect's full name. */
  name: Scalars['String'];
  /** Direct URL to the LinkedIn profile. */
  profileUrl: Scalars['String'];
};

/** Union type for search list preview result */
export type ISearchListPreviewResult = ISearchListPreviewError | ISearchListPreviewSummary;

/** Summary of a campaign search list preview, including key roles, positions, organizations, and sample prospects. */
export type ISearchListPreviewSummary = {
  __typename?: 'SearchListPreviewSummary';
  /** The key roles performed by members of the target search list. */
  keyRoles: Array<IKeyRoleEntry>;
  /** Locations where the target audience is commonly based (e.g., "San Francisco", "Berlin"). */
  locations: Array<Scalars['String']>;
  /** Sample organizations associated with the search list. */
  organizations: Array<IOrganizationEntry>;
  /** Representative prospects surfaced in the preview. */
  previewList: Array<ISearchListPreviewProspect>;
  /** A paragraph describing the target search list. */
  targetSearchList: Scalars['String'];
  /** The top job positions or titles in the search list, with counts. */
  topPositions: Array<IPositionEntry>;
  /** The total count of results the overall search list will contain. */
  totalCount: Scalars['Int'];
  /**
   * The search list url for the search list summary.
   * @deprecated No longer returned, do not use
   */
  url: Scalars['String'];
};

/** Tenure breakdown associated with a preview prospect's current position. */
export type ISearchListPreviewTenure = {
  __typename?: 'SearchListPreviewTenure';
  /** Additional months beyond the completed years. */
  months?: Maybe<Scalars['Int']>;
  /** Number of complete years spent in the position. */
  years?: Maybe<Scalars['Int']>;
};

/** Input for the secureMessage query */
export type ISecureMessageInput = {
  /** The prompt message label to lookup */
  promptLabel: Scalars['String'];
  /** The prompt message values to replace */
  promptValues?: InputMaybe<Array<IKeyValueInput>>;
};

/** Response generated from the secureMessage query */
export type ISecureMessageResponse = IMessageResult | IModerationResult;

/** Node in the campaign message sequence */
export type ISequenceNode = {
  __typename?: 'SequenceNode';
  id: Scalars['ID'];
  isAiGenerated: Scalars['Boolean'];
  message: Scalars['String'];
  order: Scalars['Int'];
  period?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
};

/** A service schedule. */
export type IServiceSchedule = {
  __typename?: 'ServiceSchedule';
  /**
   * Determines the ownerType of the schedule (System,Organization,OrganizationMember,Campaign,CampaignMember)
   * Note: going forward only Campaign (3) should be used.
   */
  hierarchyType: Scalars['Int'];
  /** The ID of the service schedule. */
  id: Scalars['ID'];
  /** The owner ID. */
  ownerId: Scalars['ID'];
  /** User preference for whether synchronization is enabled. This is used on F/E when updating/showing schedule. */
  synchronization: Scalars['Boolean'];
  /** The windows iana timezone code. */
  timezoneCode: Scalars['String'];
  /**
   * The weekly schedule. The array is indexed by day of week (0-6, Sunday to Saturday).
   * Each entry represents the schedule for that day.
   */
  weeklySchedule: Array<IWeeklyScheduleEntry>;
};

/** A Smart Reply */
export type ISmartReply = {
  __typename?: 'SmartReply';
  /** The Smart Reply's message */
  message: Scalars['String'];
};

/** A Smart Reply error */
export type ISmartReplyError = {
  __typename?: 'SmartReplyError';
  /** The error's message */
  message: Scalars['String'];
  /** The cause of the error */
  type: ISmartReplyErrorTypes;
};

/** Errors that can be encountered while writing Smart Replies */
export const ISmartReplyErrorTypes = {
  Connection: 'CONNECTION',
  Credit: 'CREDIT',
  Generation: 'GENERATION',
  Moderation: 'MODERATION',
  Parsing: 'PARSING',
  Prompt: 'PROMPT'
} as const;

export type ISmartReplyErrorTypes = typeof ISmartReplyErrorTypes[keyof typeof ISmartReplyErrorTypes];
/** Input describing a participant in a messaging thread */
export type ISmartReplyParticipant = {
  /** The organization member ID of the participant (sender only) */
  id?: InputMaybe<Scalars['String']>;
  /** The name of the participant */
  name: Scalars['String'];
  /** The URN of the participant (recipient only) */
  urn?: InputMaybe<Scalars['String']>;
};

/** Input describing a Smart Reply prompt */
export type ISmartReplyPrompt = {
  /** Additional directions to be included in the prompt */
  message?: InputMaybe<Scalars['String']>;
  /** The ID of the prompt to be used */
  promptId: Scalars['ID'];
};

/** Types provided in response to a generateSmartReply query */
export type ISmartReplyResponse = ISmartReply | ISmartReplyError;

/** Input for sorting */
export type ISortInput = {
  /** Field to sort by */
  field: Scalars['String'];
  /** Sort order */
  order: ISortOrder;
};

export const ISortOrder = {
  /** Ascending sort direction */
  Asc: 'ASC',
  /** Descending sort direction */
  Desc: 'DESC'
} as const;

export type ISortOrder = typeof ISortOrder[keyof typeof ISortOrder];
/** Include/exclude filter for string values */
export type IStringFilter = {
  __typename?: 'StringFilter';
  exclude?: Maybe<Array<Scalars['String']>>;
  include?: Maybe<Array<Scalars['String']>>;
};

/** Tenant Information */
export type ITenant = {
  __typename?: 'Tenant';
  /** Tenant's child tenants */
  childTenants: Array<ITenant>;
  /** Tenant's ID */
  id: Scalars['ID'];
  /** Tenant's name */
  name: Scalars['String'];
  /** Tenant's type */
  type: ITenantType;
};

/** Possible filters for tenant query */
export type ITenantFilters = {
  /** Specific tenants to get by tenant ids. Only one of tenantIds or tenantTypes should be used in a single query. */
  tenantIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Specific organizations to get by tenant types. Only one of tenantIds or tenantTypes should be used in a single query. */
  tenantTypes?: InputMaybe<Array<ITenantType>>;
};

/** Tenant type */
export const ITenantType = {
  /** Leaf Tenant */
  Leaf: 'LEAF',
  /** Tenant that is not a leaf */
  Node: 'NODE'
} as const;

export type ITenantType = typeof ITenantType[keyof typeof ITenantType];
/** Tenure range with minimum and maximum years */
export type ITenureRange = {
  __typename?: 'TenureRange';
  max: Scalars['Int'];
  min: Scalars['Int'];
};

/** ThreadInfo to be embedded in Connection to surface linkedin thread information that is still required */
export type IThreadInfo = {
  __typename?: 'ThreadInfo';
  /** Thread's Id */
  id: Scalars['ID'];
};

/** Possible intervals query for campaign stats by */
export const ITimeInterval = {
  /** Time interval of a week. */
  Week: 'WEEK'
} as const;

export type ITimeInterval = typeof ITimeInterval[keyof typeof ITimeInterval];
/** Input for toggling a users warmup status */
export type IToggleWarmupStatusInput = {
  /** Whether the warmup should be enabled or disabled */
  isEnabled: Scalars['Boolean'];
  /** Org Member's ID to toggle */
  orgMemberId: Scalars['ID'];
};

/** Input for updating account manager for an account */
export type IUpdateAccountManagerByAccountIdInput = {
  /** Account Id to update for */
  accountId: Scalars['ID'];
  /** Account manager user id */
  accountManagerUserId: Scalars['String'];
};

/** Input for updating an accounts name */
export type IUpdateAccountNameInput = {
  /** Account Id to update for */
  accountId: Scalars['ID'];
  /** Account name to update to */
  accountName: Scalars['String'];
};

/** Input for updating auto reply settings for a campaign */
export type IUpdateAutoReplySettingsInput = {
  /** The campaign ID */
  campaignId: Scalars['ID'];
  /** Whether auto reply is enabled for the campaign */
  isEnabled: Scalars['Boolean'];
};

/** Input used for updating allocations for specific campaigns that belong to a user */
export type IUpdateCampaignAllocationsInput = {
  /** The allocations for specific campaigns */
  campaignAllocations: Array<ICampaignAllocation>;
  /** The organization member ID for whom to update allocations */
  orgMemberId: Scalars['ID'];
};

/** Input for updating the calendar link for a campaign */
export type IUpdateCampaignCalendarLinkInput = {
  /** The calendar link for the campaign */
  calendarLink: Scalars['String'];
  /** The campaign ID */
  campaignId: Scalars['ID'];
};

/** Input for updating campaign context */
export type IUpdateCampaignContextInput = {
  /** The business context ID for the campaign */
  businessContextId?: InputMaybe<Scalars['ID']>;
  /** The campaign ID */
  campaignId: Scalars['ID'];
  /** The goal for the campaign */
  goal?: InputMaybe<Scalars['String']>;
};

/** Input for updating a campaign name */
export type IUpdateCampaignNameInput = {
  /** The ID of the campaign to update */
  campaignId: Scalars['ID'];
  /** The new name for the campaign */
  name: Scalars['String'];
};

/** Input for updating auto reply settings for a campaign connection */
export type IUpdateConnectionAutoReplySettingsInput = {
  /** The campaign connection ID */
  campaignConnectionId: Scalars['ID'];
  /** Whether auto reply is enabled for the campaign connection */
  isEnabled: Scalars['Boolean'];
};

/** Input for updating whether a campaign has inMail enabled */
export type IUpdateInMailEnabledInput = {
  /** The campaign ID */
  campaignId: Scalars['ID'];
  /** Whether the campaign has inMail enabled (open profiles only) */
  isOpenInMailEnabled: Scalars['Boolean'];
};

/** Input used for updating the message sequence for a campaign. */
export type IUpdateMessageSequenceInput = {
  /** The id of the campaign we want to update the message sequence for */
  campaignId: Scalars['ID'];
  /** The message sequence to update the campaign with */
  messageSequence: Array<IUpdateSequenceNodeInput>;
};

export type IUpdateSequenceNodeInput = {
  id: Scalars['ID'];
  isAiGenerated: Scalars['Boolean'];
  message: Scalars['String'];
  order: Scalars['Int'];
  period?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Int']>;
};

/** Input for updating or creating a service schedule for a campaign */
export type IUpdateServiceScheduleInput = {
  /** The campaign ID */
  campaignId: Scalars['ID'];
  /** Whether synchronization is enabled */
  synchronization: Scalars['Boolean'];
  /** The windows iana timezone code */
  timezoneCode: Scalars['String'];
  /** The weekly schedule */
  weeklySchedule: Array<IWeeklyScheduleEntryInput>;
};

/** Input for updating a tenant */
export type IUpdateTenantInput = {
  /** Tenant id */
  id: Scalars['ID'];
  /** Parent Tenant id to update to */
  parentTenantId: Scalars['ID'];
};

/** Input for updating a users given names */
export type IUpdateUserGivenNamesInput = {
  /** First name */
  firstName: Scalars['String'];
  /** User id */
  id: Scalars['ID'];
  /** Last name */
  lastName: Scalars['String'];
};

/** User Information */
export type IUser = {
  __typename?: 'User';
  /** Account's ID to which the user belongs */
  accountId: Scalars['ID'];
  /** User's first name */
  firstName: Scalars['String'];
  /** User's ID */
  id: Scalars['ID'];
  /** Whether or not the user is active */
  isActive: Scalars['Boolean'];
  /** The issues pertaining to the user */
  issues?: Maybe<Array<IIssue>>;
  /** User's last name */
  lastName: Scalars['String'];
  /** User's last seen on the platform */
  lastSeen?: Maybe<Scalars['Int']>;
  /** Information from deprecated OrgMember */
  orgMemberInfo?: Maybe<IOrgMemberInfo>;
  /** User's username */
  userName: Scalars['String'];
  /** Users configured vpn proxy port */
  vpnPort?: Maybe<Scalars['String']>;
};

/** Filters for the users query */
export type IUserFilters = {
  /** The master account of the users to fetch */
  masterAccountId?: InputMaybe<Scalars['String']>;
};

export type IUserInfo = {
  __typename?: 'UserInfo';
  /** Email of the organization member */
  email: Scalars['String'];
  /** First name of the organization member */
  firstName: Scalars['String'];
  /** Full name of the organization member */
  fullName: Scalars['String'];
  /** Last name of the organization member */
  lastName: Scalars['String'];
};

/** Warmup settings that are used for controlling activity limits during account warmup period */
export type IWarmUpSettings = {
  __typename?: 'WarmUpSettings';
  /** Whether warmup mode is currently enabled for this organization member */
  isEnabled: Scalars['Boolean'];
  /** The date when the warmup percentage was last increased */
  lastIncreaseDate: Scalars['DateTime'];
  /** Current warmup percentage affecting activity limits like invites. Float between 0 and 1 where 1 is 100%. */
  percentage: Scalars['Float'];
};

/** A weekly schedule entry for a service schedule. */
export type IWeeklyScheduleEntry = {
  __typename?: 'WeeklyScheduleEntry';
  /** Whether this entry is enabled. */
  enable: Scalars['Boolean'];
  /** The end time in minutes from midnight. */
  end: Scalars['Int'];
  /** The start time in minutes from midnight. */
  start: Scalars['Int'];
};

/** Input for a weekly schedule entry */
export type IWeeklyScheduleEntryInput = {
  /** Whether this entry is enabled */
  enable: Scalars['Boolean'];
  /** The end time in minutes from midnight */
  end: Scalars['Int'];
  /** The start time in minutes from midnight */
  start: Scalars['Int'];
};

/** Input for generating a smart reply */
export type IWriteSmartReplyInput = {
  /** The connection id between the sender and recipient */
  connectionId?: InputMaybe<Scalars['String']>;
  /** The existing messaging thread between the two participants */
  messageThread: Array<IMessageInput>;
  /** Prompt to use to write a Smart Reply */
  prompt: ISmartReplyPrompt;
  /** The participant to converse with */
  recipient: ISmartReplyParticipant;
  /** The communication styles of the recipient */
  recipientCommunicationStyles?: InputMaybe<Array<Scalars['String']>>;
  /** The participant to take the perspective of when writing the Smart Reply */
  sender: ISmartReplyParticipant;
};

export type I_Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']>;
};

export type ICampaignSummaryAttentionItemsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  organizationIds: Array<Scalars['ID']> | Scalars['ID'];
  orgMemberIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ICampaignSummaryAttentionItemsQuery = { __typename?: 'Query', campaignSummary: { __typename?: 'Campaign', name: string, attentionItems: Array<{ __typename?: 'CampaignAttentionItem', level: IAttentionLevel, memberId: string, type: ICampaignAttentionType }> }, orgMembers: Array<{ __typename?: 'OrgMember', id: string, organizationId: string, attentionItems: Array<{ __typename?: 'OrgMemberAttentionItem', level: IAttentionLevel, memberId: string, type: IOrgMemberAttentionType }> }> };

export type IUpdateConnectionMeetingMutationVariables = Exact<{
  connectionId: Scalars['ID'];
  isBooked: Scalars['Boolean'];
}>;


export type IUpdateConnectionMeetingMutation = { __typename?: 'Mutation', updateConnectionMeeting: { __typename?: 'CampaignConnection', id: string, meeting: { __typename?: 'MeetingContext', booked: boolean } } };

export type ICampaignMemberEventsAndStatsQueryVariables = Exact<{
  campaignMemberId: Scalars['ID'];
  end: Scalars['DateTime'];
  interval?: InputMaybe<ITimeInterval>;
  start?: InputMaybe<Scalars['DateTime']>;
  numDays: Scalars['Int'];
}>;


export type ICampaignMemberEventsAndStatsQuery = { __typename?: 'Query', campaignMemberEvents: Array<{ __typename?: 'CampaignUsage', action: ICampaignUsageAction, campaignId: string, campaignMemberId?: string | null, dateCreated: number }>, campaignStats: Array<{ __typename?: 'NurtureCampaignStats', ownerId: string, ownerType: ICampaignStatsOwnerType, start?: number | null, end?: number | null, numSendMessages: number, numUserReplies: number, numInterestedReplies: number, percentReplied?: number | null, percentInterestedReplied?: number | null } | { __typename?: 'ProspectingCampaignStats', ownerId: string, ownerType: ICampaignStatsOwnerType, start?: number | null, end?: number | null, numUserReplies: number, numUsersConnected: number, numInvitesSent: number, numInterestedReplies: number, percentConnected?: number | null, percentReplied?: number | null, percentInterestedReplied?: number | null }> };

export type ICampaignStatsQueryVariables = Exact<{
  input: ICampaignStatsInput;
}>;


export type ICampaignStatsQuery = { __typename?: 'Query', campaignStats: Array<{ __typename?: 'NurtureCampaignStats', ownerId: string, ownerType: ICampaignStatsOwnerType, start?: number | null, end?: number | null, numSendMessages: number, numUserReplies: number, numInterestedReplies: number, percentReplied?: number | null, percentInterestedReplied?: number | null } | { __typename?: 'ProspectingCampaignStats', ownerId: string, ownerType: ICampaignStatsOwnerType, start?: number | null, end?: number | null, numUserReplies: number, numUsersConnected: number, numInvitesSent: number, numInterestedReplies: number, numInMailSent: number, numInMailReplies: number, numInterestedInMailReplies: number, percentConnected?: number | null, percentReplied?: number | null, percentInterestedReplied?: number | null, percentInMailReplied?: number | null, percentInterestedInMailReplied?: number | null }> };

export type ICampaignSummariesQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  searchTerm?: InputMaybe<Scalars['String']>;
}>;


export type ICampaignSummariesQuery = { __typename?: 'Query', campaignSummaries: Array<{ __typename?: 'Campaign', id: string, name: string, numActiveMembers?: number | null, launchedAt?: number | null, status: ICampaignStatus, type: ICampaignType, members: Array<{ __typename?: 'CampaignMember', id: string, orgMemberId: string }>, stats?: { __typename?: 'NurtureCampaignStats', numUserReplies: number, numSendMessages: number, percentReplied?: number | null } | { __typename?: 'ProspectingCampaignStats', numUserReplies: number, numUsersConnected: number, numInvitesSent: number, percentConnected?: number | null, percentReplied?: number | null } | null }> };

export type ICampaignsWithOrgMemberQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  searchTerm?: InputMaybe<Scalars['String']>;
}>;


export type ICampaignsWithOrgMemberQuery = { __typename?: 'Query', campaignSummaries: Array<{ __typename?: 'Campaign', id: string, name: string, numActiveMembers?: number | null, launchedAt?: number | null, status: ICampaignStatus, type: ICampaignType, members: Array<{ __typename?: 'CampaignMember', id: string, orgMemberId: string }>, stats?: { __typename?: 'NurtureCampaignStats', numUserReplies: number, numSendMessages: number, percentReplied?: number | null } | { __typename?: 'ProspectingCampaignStats', numUserReplies: number, numUsersConnected: number, numInvitesSent: number, percentConnected?: number | null, percentReplied?: number | null } | null, orgMember: { __typename?: 'OrgMember', id: string, userInfo: { __typename?: 'UserInfo', fullName: string } } }> };

export type ICampaignConnectionsQueryVariables = Exact<{
  input: ICampaignConnectionsInput;
}>;


export type ICampaignConnectionsQuery = { __typename?: 'Query', campaignConnections: Array<{ __typename?: 'CampaignConnection', id: string, nextAutomationNode?: { __typename?: 'NextAutomationNode', id: string, name: string, message?: string | null } | null }> };

export type ICampaignAllocationsByUserQueryVariables = Exact<{
  input: ICampaignInput;
}>;


export type ICampaignAllocationsByUserQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', id: string, name: string, type: ICampaignType, members: Array<{ __typename?: 'CampaignMember', orgMemberId: string, dailyInvitesAllocated: number, dailyMessagesAllocated: number }> }> };

export type IOrganizationContactInformationQueryVariables = Exact<{
  contactId: Scalars['ID'];
}>;


export type IOrganizationContactInformationQuery = { __typename?: 'Query', campaignConnections: Array<{ __typename?: 'CampaignConnection', id: string, campaignId: string, campaignMember: { __typename?: 'CampaignMember', id: string, orgMemberId: string }, campaignHistory: Array<{ __typename?: 'CampaignHistory', start: number, end?: number | null, name: string }>, meeting: { __typename?: 'MeetingContext', bookedDate?: number | null }, communicationStyles?: { __typename?: 'CommunicationStylesAnalysis', lastUpdated: number, failureReason?: string | null, styles: Array<{ __typename?: 'CommunicationStyle', style: string }> } | null }>, orgContacts: Array<{ __typename?: 'OrgContact', id: string, firstName: string, lastName: string, organizationId: string, title: string, company: string, email: string, phoneNumber: string }> };

export type IContactFieldsFragment = { __typename?: 'OrgContact', id: string, firstName: string, lastName: string, organizationId: string, title: string, company: string, email: string, phoneNumber: string };

export type IUpdateOrgContactCompanyMutationVariables = Exact<{
  orgContactId: Scalars['ID'];
  company: Scalars['String'];
}>;


export type IUpdateOrgContactCompanyMutation = { __typename?: 'Mutation', updateOrgContactCompany: { __typename?: 'OrgContact', id: string, firstName: string, lastName: string, organizationId: string, title: string, company: string, email: string, phoneNumber: string } };

export type IUpdateOrgContactEmailMutationVariables = Exact<{
  orgContactId: Scalars['ID'];
  email: Scalars['String'];
}>;


export type IUpdateOrgContactEmailMutation = { __typename?: 'Mutation', updateOrgContactEmail: { __typename?: 'OrgContact', id: string, firstName: string, lastName: string, organizationId: string, title: string, company: string, email: string, phoneNumber: string } };

export type IUpdateOrgContactPhoneNumberMutationVariables = Exact<{
  orgContactId: Scalars['ID'];
  phoneNumber: Scalars['String'];
}>;


export type IUpdateOrgContactPhoneNumberMutation = { __typename?: 'Mutation', updateOrgContactPhoneNumber: { __typename?: 'OrgContact', id: string, firstName: string, lastName: string, organizationId: string, title: string, company: string, email: string, phoneNumber: string } };

export type IUpdateOrgContactTitleMutationVariables = Exact<{
  orgContactId: Scalars['ID'];
  title: Scalars['String'];
}>;


export type IUpdateOrgContactTitleMutation = { __typename?: 'Mutation', updateOrgContactTitle: { __typename?: 'OrgContact', id: string, firstName: string, lastName: string, organizationId: string, title: string, company: string, email: string, phoneNumber: string } };

export type IAnalyzeCommunicationStylesMutationVariables = Exact<{
  campaignConnectionId: Scalars['ID'];
}>;


export type IAnalyzeCommunicationStylesMutation = { __typename?: 'Mutation', analyzeCommunicationStyles: { __typename?: 'CampaignConnection', id: string, communicationStyles?: { __typename?: 'CommunicationStylesAnalysis', lastUpdated: number, styles: Array<{ __typename?: 'CommunicationStyle', style: string }> } | null } };

export type ICampaignFieldsFragment = { __typename?: 'Campaign', id: string, name: string, type: ICampaignType, status: ICampaignStatus, numActiveMembers?: number | null, members: Array<{ __typename?: 'CampaignMember', id: string, orgMemberId: string, dailyInvitesAllocated: number, dailyMessagesAllocated: number, dailyOpenInMailAllocated: number }>, attentionItems: Array<{ __typename?: 'CampaignAttentionItem', memberId: string, level: IAttentionLevel, type: ICampaignAttentionType }> };

export type ICreateCampaignMutationVariables = Exact<{
  name: Scalars['String'];
  type: ICampaignType;
  orgMemberId?: InputMaybe<Scalars['ID']>;
}>;


export type ICreateCampaignMutation = { __typename?: 'Mutation', createCampaign: { __typename?: 'Campaign', id: string, name: string, type: ICampaignType, status: ICampaignStatus, numActiveMembers?: number | null, members: Array<{ __typename?: 'CampaignMember', id: string, orgMemberId: string, dailyInvitesAllocated: number, dailyMessagesAllocated: number, dailyOpenInMailAllocated: number }>, attentionItems: Array<{ __typename?: 'CampaignAttentionItem', memberId: string, level: IAttentionLevel, type: ICampaignAttentionType }> } };

export type IDuplicateCampaignMutationVariables = Exact<{
  name: Scalars['String'];
  campaignId: Scalars['ID'];
  orgMemberId?: InputMaybe<Scalars['ID']>;
}>;


export type IDuplicateCampaignMutation = { __typename?: 'Mutation', duplicateCampaign: { __typename?: 'Campaign', id: string, name: string, type: ICampaignType, status: ICampaignStatus, numActiveMembers?: number | null, members: Array<{ __typename?: 'CampaignMember', id: string, orgMemberId: string, dailyInvitesAllocated: number, dailyMessagesAllocated: number, dailyOpenInMailAllocated: number }>, attentionItems: Array<{ __typename?: 'CampaignAttentionItem', memberId: string, level: IAttentionLevel, type: ICampaignAttentionType }> } };

export type IAddAccountMutationVariables = Exact<{
  input: IAddAccountInput;
}>;


export type IAddAccountMutation = { __typename?: 'Mutation', addAccount: { __typename?: 'Account', id: string, name: string, orgInfo?: { __typename?: 'OrgInfo', id: string } | null } };

export type IUpdateUserGivenNamesMutationVariables = Exact<{
  input: IUpdateUserGivenNamesInput;
}>;


export type IUpdateUserGivenNamesMutation = { __typename?: 'Mutation', updateUserGivenNames: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type IPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type IPromptsQuery = { __typename?: 'Query', prompts: Array<{ __typename?: 'Prompt', id: string, label: string, action: IPromptActions, useCases?: Array<IPromptUseCases> | null }> };

export type IUpdateConnectionAutoReplySettingsMutationVariables = Exact<{
  input: IUpdateConnectionAutoReplySettingsInput;
}>;


export type IUpdateConnectionAutoReplySettingsMutation = { __typename?: 'Mutation', updateCampaignConnectionAutoReplySettings: { __typename?: 'CampaignConnection', id: string, autoReplySettings: { __typename?: 'ConnectionAutoReplySettings', isEnabled: boolean } } };

export type IGetCampaignAndConnectionAutoReplySettingsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  campaignConnectionId: Scalars['ID'];
}>;


export type IGetCampaignAndConnectionAutoReplySettingsQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, autoReplySettings: { __typename?: 'AutoReplySettings', isEnabled: boolean, calendarLink?: string | null } }, campaignConnection: { __typename?: 'CampaignConnection', id: string, autoReplySettings: { __typename?: 'ConnectionAutoReplySettings', isEnabled: boolean } } };

export type IGenerateMessageRecommendationMutationVariables = Exact<{
  input: IGenerateMessageRecommendationInput;
}>;


export type IGenerateMessageRecommendationMutation = { __typename?: 'Mutation', generateMessageRecommendation: { __typename?: 'MessageRecommendationResponse', content: string, id: string } };

export type IEditSmartReplyQueryVariables = Exact<{
  input: IEditSmartReplyInput;
}>;


export type IEditSmartReplyQuery = { __typename?: 'Query', editSmartReply: { __typename?: 'SmartReply', message: string } | { __typename?: 'SmartReplyError', message: string, type: ISmartReplyErrorTypes } };

export type IWriteSmartReplyQueryVariables = Exact<{
  input: IWriteSmartReplyInput;
}>;


export type IWriteSmartReplyQuery = { __typename?: 'Query', writeSmartReply: { __typename?: 'SmartReply', message: string } | { __typename?: 'SmartReplyError', message: string, type: ISmartReplyErrorTypes } };

export type ISearchAccountsQueryVariables = Exact<{
  accountsFilter: IAccountFilters;
  pagination?: InputMaybe<IPagination>;
}>;


export type ISearchAccountsQuery = { __typename?: 'Query', admin_accounts: Array<{ __typename?: 'Account', id: string, name: string, isActive: boolean, type: IAccountType, logoUrl?: string | null, parentAccount?: { __typename?: 'Account', name: string } | null }> };

export type IAccountSummaryFragment = { __typename?: 'Account', id: string, name: string, isActive: boolean, type: IAccountType, logoUrl?: string | null, parentAccount?: { __typename?: 'Account', name: string } | null };

export type IAccountsQueryVariables = Exact<{
  accountsFilter: IAccountFilters;
  pagination?: InputMaybe<IPagination>;
}>;


export type IAccountsQuery = { __typename?: 'Query', admin_num_accounts: number, admin_accounts: Array<{ __typename?: 'Account', id: string, name: string, isActive: boolean, type: IAccountType, logoUrl?: string | null, dateCreated?: number | null, users: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, userName: string, lastSeen?: number | null, isActive: boolean, accountId: string, issues?: Array<{ __typename?: 'Issue', level: IAttentionLevel, type: IOrgMemberAttentionType }> | null }>, orgInfo?: { __typename?: 'OrgInfo', id: string } | null, primaryContact?: { __typename?: 'User', id: string } | null, accountManager?: { __typename?: 'AccountManager', firstName: string, lastName: string, id: string } | null }> };

export type IActivateRegularAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type IActivateRegularAccountMutation = { __typename?: 'Mutation', activateRegularAccount: { __typename?: 'Account', id: string } };

export type IDeactivateRegularAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type IDeactivateRegularAccountMutation = { __typename?: 'Mutation', deactivateRegularAccount: { __typename?: 'Account', id: string } };

export type IAccountQueryVariables = Exact<{
  adminAccountId: Scalars['ID'];
}>;


export type IAccountQuery = { __typename?: 'Query', admin_account: { __typename?: 'Account', id: string, isActive: boolean, name: string, type: IAccountType, logoUrl?: string | null, dateCreated?: number | null, orgInfo?: { __typename?: 'OrgInfo', id: string } | null, users: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, userName: string, lastSeen?: number | null, isActive: boolean, accountId: string, vpnPort?: string | null, issues?: Array<{ __typename?: 'Issue', level: IAttentionLevel, type: IOrgMemberAttentionType }> | null, orgMemberInfo?: { __typename?: 'OrgMemberInfo', id: string, role: IOrganizationMemberRole } | null }>, primaryContact?: { __typename?: 'User', id: string } | null, childAccountsSummary?: { __typename?: 'ChildAccountsSummary', totalUsers: number, totalActiveUsers: number, totalAccounts: number } | null } };

export type IUserDetailsFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, userName: string, lastSeen?: number | null, isActive: boolean, accountId: string, vpnPort?: string | null, issues?: Array<{ __typename?: 'Issue', level: IAttentionLevel, type: IOrgMemberAttentionType }> | null, orgMemberInfo?: { __typename?: 'OrgMemberInfo', id: string, role: IOrganizationMemberRole } | null };

export type IDeactivateUsersMutationVariables = Exact<{
  input: IDeactivateUsersInput;
}>;


export type IDeactivateUsersMutation = { __typename?: 'Mutation', deactivateUsers: Array<{ __typename?: 'User', id: string }> };

export type IActivateUsersMutationVariables = Exact<{
  input: IActivateUsersInput;
}>;


export type IActivateUsersMutation = { __typename?: 'Mutation', activateUsers: Array<{ __typename?: 'User', id: string }> };

export type IUpdateAccountNameMutationVariables = Exact<{
  input: IUpdateAccountNameInput;
}>;


export type IUpdateAccountNameMutation = { __typename?: 'Mutation', updateAccountName: { __typename?: 'Account', name: string } };

export type IUpdateAccountManagerMutationVariables = Exact<{
  input: IUpdateAccountManagerByAccountIdInput;
}>;


export type IUpdateAccountManagerMutation = { __typename?: 'Mutation', updateAccountManagerByAccountId: { __typename?: 'Account', id: string } };

export type IAccountCampaignsQueryVariables = Exact<{
  campaignsInput: ICampaignInput;
  adminOrganizationsInput: IOrgFilters;
}>;


export type IAccountCampaignsQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', status: ICampaignStatus, type: ICampaignType, name: string, numActiveMembers?: number | null, id: string, members: Array<{ __typename?: 'CampaignMember', orgMemberId: string, dailyInvitesAllocated: number, dailyMessagesAllocated: number, dailyOpenInMailAllocated: number, monthlyInvitesAllocated: number, monthlyMessagesAllocated: number, monthlyOpenInMailAllocated: number }>, attentionItems: Array<{ __typename?: 'CampaignAttentionItem', memberId: string, level: IAttentionLevel, type: ICampaignAttentionType }> }>, admin_organizations: Array<{ __typename?: 'Organization', members: Array<{ __typename?: 'OrgMember', attentionItems: Array<{ __typename?: 'OrgMemberAttentionItem', level: IAttentionLevel, memberId: string, type: IOrgMemberAttentionType }> }> }> };

export type ICampaignDetailsFragment = { __typename?: 'Campaign', status: ICampaignStatus, type: ICampaignType, name: string, numActiveMembers?: number | null, id: string, members: Array<{ __typename?: 'CampaignMember', orgMemberId: string, dailyInvitesAllocated: number, dailyMessagesAllocated: number, dailyOpenInMailAllocated: number, monthlyInvitesAllocated: number, monthlyMessagesAllocated: number, monthlyOpenInMailAllocated: number }>, attentionItems: Array<{ __typename?: 'CampaignAttentionItem', memberId: string, level: IAttentionLevel, type: ICampaignAttentionType }> };

export type IAccountCampaignStatsQueryVariables = Exact<{
  input: ICampaignStatsInput;
}>;


export type IAccountCampaignStatsQuery = { __typename?: 'Query', campaignStats: Array<{ __typename?: 'NurtureCampaignStats', ownerId: string, ownerType: ICampaignStatsOwnerType, start?: number | null, end?: number | null, numMeetingsBooked: number, percentReplied?: number | null, percentInterestedReplied?: number | null } | { __typename?: 'ProspectingCampaignStats', ownerId: string, ownerType: ICampaignStatsOwnerType, start?: number | null, end?: number | null, numMeetingsBooked: number, percentConnected?: number | null, percentReplied?: number | null, percentInterestedReplied?: number | null, percentInMailReplied?: number | null, percentInterestedInMailReplied?: number | null }> };

export type ITenantDataQueryVariables = Exact<{
  tenantFilter: ITenantFilters;
}>;


export type ITenantDataQuery = { __typename?: 'Query', admin_tenants: Array<{ __typename?: 'Tenant', id: string, name: string, childTenants: Array<{ __typename?: 'Tenant', id: string, name: string, type: ITenantType }> }> };

export type IAdminOrgDataQueryVariables = Exact<{
  orgFilter: IOrgFilters;
}>;


export type IAdminOrgDataQuery = { __typename?: 'Query', admin_organizations: Array<{ __typename?: 'Organization', id: string, name: string, members: Array<{ __typename?: 'OrgMember', id: string, userId: string, role: IOrganizationMemberRole, isActive: boolean }>, customerSuccessOwner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> };

export type ITwoLevelsTenantDataQueryVariables = Exact<{
  tenantFilter: ITenantFilters;
}>;


export type ITwoLevelsTenantDataQuery = { __typename?: 'Query', admin_tenants: Array<{ __typename?: 'Tenant', id: string, name: string, type: ITenantType, childTenants: Array<{ __typename?: 'Tenant', id: string, name: string, type: ITenantType, childTenants: Array<{ __typename?: 'Tenant', id: string, name: string, type: ITenantType }> }> }> };

export type IUpdateParentTenantMutationVariables = Exact<{
  updateTenantInput: IUpdateTenantInput;
}>;


export type IUpdateParentTenantMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'Tenant', id: string, name: string, type: ITenantType } };

export type IStopAutomationMutationVariables = Exact<{
  campaignConnectionId: Scalars['ID'];
}>;


export type IStopAutomationMutation = { __typename?: 'Mutation', stopAutomation: { __typename?: 'CampaignConnection', id: string } };

export type ICampaignsByUserQueryVariables = Exact<{
  input: ICampaignInput;
}>;


export type ICampaignsByUserQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', id: string, name: string, type: ICampaignType, members: Array<{ __typename?: 'CampaignMember', orgMemberId: string, dailyOpenInMailAllocated: number }> }> };

export type IConnectionsByConnectionStatusQueryVariables = Exact<{
  input: IConnectionsByConnectionStatusInput;
}>;


export type IConnectionsByConnectionStatusQuery = { __typename?: 'Query', campaignConnectionsByConnectionStatus: { __typename?: 'ConnectionsResponse', count: number, pages: { __typename?: 'PaginationContext', current: number, total: number }, content: Array<{ __typename?: 'CampaignConnection', id: string, campaignId: string, name: string, status: IConnectionStatus, title?: string | null, company?: string | null, location?: string | null, profileId: string, inviteUrl: string, replyPrediction?: number | null, isManualTermination?: boolean | null, dateCreated: number, campaignMember: { __typename?: 'CampaignMember', id: string, orgMemberId: string }, contactInfo?: { __typename?: 'ContactInfo', id: string } | null, nextAutomationNode?: { __typename?: 'NextAutomationNode', id: string, name: string } | null }> } };

export type ICampaignConnectionsByMeetingsQueryVariables = Exact<{
  input: IConnectionsByMeetingsInput;
}>;


export type ICampaignConnectionsByMeetingsQuery = { __typename?: 'Query', campaignConnectionsByMeetings: { __typename?: 'ConnectionsResponse', count: number, pages: { __typename?: 'PaginationContext', current: number, total: number }, content: Array<{ __typename?: 'CampaignConnection', id: string, name: string, title?: string | null, company?: string | null, profileId: string, meeting: { __typename?: 'MeetingContext', booked: boolean, bookedDate?: number | null, detectedDate?: number | null }, communicationStyles?: { __typename?: 'CommunicationStylesAnalysis', lastUpdated: number, failureReason?: string | null, styles: Array<{ __typename?: 'CommunicationStyle', style: string }> } | null, campaignMember: { __typename?: 'CampaignMember', id: string, orgMemberId: string, dailyOpenInMailAllocated: number, dailyInvitesAllocated: number, dailyMessagesAllocated: number }, campaignHistory: Array<{ __typename?: 'CampaignHistory', campaignId: string, name: string, start: number, end?: number | null }>, contactInfo?: { __typename?: 'ContactInfo', id: string } | null }> } };

export type IDetectedMeetingsCountQueryVariables = Exact<{
  input: IConnectionsByMeetingsInput;
}>;


export type IDetectedMeetingsCountQuery = { __typename?: 'Query', campaignConnectionsByMeetings: { __typename?: 'ConnectionsResponse', count: number } };

export type IRejectDetectionMutationVariables = Exact<{
  campaignConnectionId: Scalars['ID'];
}>;


export type IRejectDetectionMutation = { __typename?: 'Mutation', rejectMeetingDetection: { __typename?: 'CampaignConnection', id: string } };

export type IConfirmDetectionMutationVariables = Exact<{
  campaignConnectionId: Scalars['ID'];
  isBooked: Scalars['Boolean'];
}>;


export type IConfirmDetectionMutation = { __typename?: 'Mutation', updateConnectionMeeting: { __typename?: 'CampaignConnection', id: string } };

export type IOrganizationStatsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  orgMemberIds: Array<Scalars['ID']> | Scalars['ID'];
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
}>;


export type IOrganizationStatsQuery = { __typename?: 'Query', campaignStats: Array<{ __typename?: 'NurtureCampaignStats', ownerId: string, ownerType: ICampaignStatsOwnerType, start?: number | null, end?: number | null, numSendMessages: number, numUserReplies: number, numInterestedReplies: number, percentReplied?: number | null, percentInterestedReplied?: number | null, numMeetingsBooked: number } | { __typename?: 'ProspectingCampaignStats', ownerId: string, ownerType: ICampaignStatsOwnerType, start?: number | null, end?: number | null, numUserReplies: number, numUsersConnected: number, numInvitesSent: number, numInterestedReplies: number, percentConnected?: number | null, percentReplied?: number | null, percentInterestedReplied?: number | null, numMeetingsBooked: number }> };

export type IOrgMembersAndCampaignsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type IOrgMembersAndCampaignsQuery = { __typename?: 'Query', orgMembers: Array<{ __typename?: 'OrgMember', id: string, isActive: boolean, organizationId: string, attentionItems: Array<{ __typename?: 'OrgMemberAttentionItem', level: IAttentionLevel, memberId: string, type: IOrgMemberAttentionType }>, linkedInErrors: { __typename?: 'LinkedInErrors', loggedOut: boolean, blackListed: boolean, hasFailedMessages: boolean, invitesThrottled: boolean, salesNavMissing: boolean } }>, campaignSummaries: Array<{ __typename?: 'Campaign', id: string, name: string, attentionItems: Array<{ __typename?: 'CampaignAttentionItem', level: IAttentionLevel, memberId: string, type: ICampaignAttentionType }>, members: Array<{ __typename?: 'CampaignMember', id: string, orgMemberId: string }> }> };

export type IConnectionWithCommunicationStyleQueryVariables = Exact<{
  connectionId: Scalars['ID'];
}>;


export type IConnectionWithCommunicationStyleQuery = { __typename?: 'Query', campaignConnection: { __typename?: 'CampaignConnection', id: string, campaignId: string, name: string, status: IConnectionStatus, title?: string | null, company?: string | null, location?: string | null, dateCreated: number, communicationStyles?: { __typename?: 'CommunicationStylesAnalysis', lastUpdated: number, failureReason?: string | null, styles: Array<{ __typename?: 'CommunicationStyle', style: string }> } | null, linkedInProfile: { __typename?: 'LinkedInProfile', id: string, alias?: string | null, firstName: string, lastName: string, profilePictureUrl?: string | null, isOpenProfile: boolean, company?: string | null, location?: string | null, title?: string | null } } };

export type IGenerateLinkedInAuthMutationVariables = Exact<{
  input: ILinkedInAuthInput;
}>;


export type IGenerateLinkedInAuthMutation = { __typename?: 'Mutation', generateLinkedInAuth: { __typename?: 'LinkedInAuthDTO', url: string } | { __typename?: 'LinkedInAuthError', type: ILinkedInAuthErrors } };

export type IGenerateInMailMessageSequenceMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  websiteUrl?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
}>;


export type IGenerateInMailMessageSequenceMutation = { __typename?: 'Mutation', generateInMailMessageSequence: Array<{ __typename?: 'SequenceNode', id: string, subject?: string | null, message: string, isAiGenerated: boolean }> };

export type IUpdateInMailEnabledMutationVariables = Exact<{
  input: IUpdateInMailEnabledInput;
}>;


export type IUpdateInMailEnabledMutation = { __typename?: 'Mutation', updateInMailEnabled: { __typename?: 'Campaign', id: string, openInMailEnabled: boolean } };

export type IUpdateInMailMessageSequenceMutationVariables = Exact<{
  input: IUpdateMessageSequenceInput;
}>;


export type IUpdateInMailMessageSequenceMutation = { __typename?: 'Mutation', updateInMailMessageSequence: Array<{ __typename?: 'SequenceNode', id: string, subject?: string | null, message: string, isAiGenerated: boolean }> };

export type IGenerateMessageSequenceMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  websiteUrl?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
}>;


export type IGenerateMessageSequenceMutation = { __typename?: 'Mutation', generateMessageSequenceV2: { __typename: 'GeneratedMessageSequence', messageSequence: Array<{ __typename?: 'SequenceNode', id: string, message: string, subject?: string | null, isAiGenerated: boolean, order: number, period?: number | null, time?: number | null }> } | { __typename: 'GeneratedMessageSequenceErrorResponse', errorType: string, errorMessage: string } };

export type IUpdateMessageSequenceMutationVariables = Exact<{
  input: IUpdateMessageSequenceInput;
}>;


export type IUpdateMessageSequenceMutation = { __typename?: 'Mutation', updateMessageSequence: Array<{ __typename?: 'SequenceNode', id: string, message: string, isAiGenerated: boolean, order: number, period?: number | null, time?: number | null }> };

export type IGenerateAudienceSegmentMutationVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type IGenerateAudienceSegmentMutation = { __typename?: 'Mutation', generateAudienceSegment: { __typename?: 'GenerateAudienceSegmentResponse', threadId: string, runId: string, status: IAudienceSegmentStatus } };

export type IGenerateBusinessContextMutationVariables = Exact<{
  input: IGenerateBusinessContextInput;
}>;


export type IGenerateBusinessContextMutation = { __typename?: 'Mutation', generateBusinessContext: Array<{ __typename?: 'BusinessContext', id: string, processingState: IBusinessContextProcessingState, name: string, orgMemberId: string, companyId: string, website: string, role: string, roleStartTime?: number | null, roleEndTime?: number | null, research?: { __typename?: 'CompanyResearchData', coreValueProposition?: string | null } | null }> };

export type IGetAudiencePreviewMutationVariables = Exact<{
  input: IGenerateSearchListPreviewInput;
}>;


export type IGetAudiencePreviewMutation = { __typename?: 'Mutation', generateSearchListPreview: { __typename?: 'SearchListPreviewError', errorType: ISearchListPreviewErrorType, message: string } | { __typename?: 'SearchListPreviewSummary', url: string, targetSearchList: string, totalCount: number, locations: Array<string>, previewList: Array<{ __typename?: 'SearchListPreviewProspect', name: string, headline: string, location: string, profileUrl: string, currentPosition?: { __typename?: 'SearchListPreviewPosition', companyId: string, companyName: string, industry: Array<string>, position: string, tenure?: { __typename?: 'SearchListPreviewTenure', years?: number | null, months?: number | null } | null } | null }>, topPositions: Array<{ __typename?: 'PositionEntry', title: string, count: number }>, keyRoles: Array<{ __typename?: 'KeyRoleEntry', label: string }>, organizations: Array<{ __typename?: 'OrganizationEntry', name: string }> } };

export type IGetAudienceSegmentQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type IGetAudienceSegmentQuery = { __typename?: 'Query', audienceSegment?: { __typename?: 'AudienceSegmentResult', status: IAudienceSegmentStatus, error?: string | null, segment?: { __typename?: 'AudienceSegment', name: string, description: string, rationale: string, searchCriteria: { __typename?: 'SalesNavigatorPeopleSearch', networkDistance?: Array<INetworkDistance> | null, followingYourCompany?: boolean | null, keywords?: string | null, messagedRecently?: boolean | null, viewedProfileRecently?: boolean | null, location?: { __typename?: 'LinkedInParameterFilter', include?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null, exclude?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null } | null, industry?: { __typename?: 'LinkedInParameterFilter', include?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null, exclude?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null } | null, seniority?: { __typename?: 'StringFilter', include?: Array<string> | null, exclude?: Array<string> | null } | null, companyHeadcount?: Array<{ __typename?: 'CompanyHeadcountRange', min: number, max: number }> | null, role?: { __typename?: 'StringFilter', include?: Array<string> | null, exclude?: Array<string> | null } | null, function?: { __typename?: 'LinkedInParameterFilter', include?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null, exclude?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null } | null, tenureAtCompany?: Array<{ __typename?: 'TenureRange', min: number, max: number }> | null, tenureAtRole?: Array<{ __typename?: 'TenureRange', min: number, max: number }> | null, companyLocation?: { __typename?: 'LinkedInParameterFilter', include?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null, exclude?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null } | null, profileLanguage?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null, tenure?: Array<{ __typename?: 'TenureRange', min: number, max: number }> | null, school?: { __typename?: 'LinkedInParameterFilter', include?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null, exclude?: Array<{ __typename?: 'LinkedInParameter', id: string, text: string }> | null } | null, company?: { __typename?: 'StringFilter', include?: Array<string> | null, exclude?: Array<string> | null } | null } } | null } | null };

export type IGetBusinessContextsQueryVariables = Exact<{
  input: IBusinessContextsQueryInput;
}>;


export type IGetBusinessContextsQuery = { __typename?: 'Query', businessContexts: Array<{ __typename?: 'BusinessContext', id: string, processingState: IBusinessContextProcessingState, orgMemberId: string, companyId: string, name: string, website: string, role: string, roleStartTime?: number | null, roleEndTime?: number | null, research?: { __typename?: 'CompanyResearchData', description?: string | null, businessModel?: string | null, companyCulture?: string | null, companyStage?: string | null, competitiveDifferentiation?: Array<string> | null, coreValueProposition?: string | null, industry?: string | null } | null }> };

export type IGetCampaignDetailsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type IGetCampaignDetailsQuery = { __typename?: 'Query', campaignSummary: { __typename?: 'Campaign', id: string, name: string, type: ICampaignType, status: ICampaignStatus, openInMailEnabled: boolean, searchUrl?: string | null, searchUrlLastUpdated?: number | null, launchedAt?: number | null, goal?: string | null, businessContext?: { __typename?: 'BusinessContext', id: string, name: string, orgMemberId: string, companyId: string, website: string, role: string, roleStartTime?: number | null, roleEndTime?: number | null } | null, members: Array<{ __typename?: 'CampaignMember', id: string, orgMemberId: string, monthlyInvitesAllocated: number, monthlyMessagesAllocated: number, monthlyOpenInMailAllocated: number }>, messageSequence: Array<{ __typename?: 'SequenceNode', id: string, message: string, isAiGenerated: boolean, order: number, period?: number | null, time?: number | null }>, inMailMessageSequence: Array<{ __typename?: 'SequenceNode', id: string, subject?: string | null, message: string, isAiGenerated: boolean }>, serviceSchedule?: { __typename?: 'ServiceSchedule', id: string, hierarchyType: number, ownerId: string, synchronization: boolean, timezoneCode: string, weeklySchedule: Array<{ __typename?: 'WeeklyScheduleEntry', enable: boolean, start: number, end: number }> } | null, orgMember: { __typename?: 'OrgMember', id: string, loginStatus: ILinkedInLoginStatus, userInfo: { __typename?: 'UserInfo', fullName: string }, warmUpSettings: { __typename?: 'WarmUpSettings', isEnabled: boolean, percentage: number, lastIncreaseDate: number } }, autoReplySettings: { __typename?: 'AutoReplySettings', isEnabled: boolean, calendarLink?: string | null } } };

export type IGetCampaignsQueryVariables = Exact<{
  campaignsInput: ICampaignInput;
}>;


export type IGetCampaignsQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', id: string, name: string }> };

export type ILinkedInWorkExperienceQueryVariables = Exact<{
  input: ILinkedInWorkExperienceQueryInput;
}>;


export type ILinkedInWorkExperienceQuery = { __typename?: 'Query', linkedInWorkExperience: Array<{ __typename?: 'LinkedInWorkExperience', companyId?: string | null, companyName?: string | null, role?: string | null, startDate?: number | null, endDate?: number | null, isCurrent: boolean }> };

export type IUpdateCampaignContextMutationVariables = Exact<{
  input: IUpdateCampaignContextInput;
}>;


export type IUpdateCampaignContextMutation = { __typename?: 'Mutation', updateCampaignContext: { __typename?: 'Campaign', id: string, goal?: string | null, businessContext?: { __typename?: 'BusinessContext', id: string, name: string, orgMemberId: string, processingState: IBusinessContextProcessingState, companyId: string, website: string, role: string, roleStartTime?: number | null, roleEndTime?: number | null } | null } };

export type IGetCampaignAllocationsQueryVariables = Exact<{
  organizationsInput: IOrganizationFilters;
  campaignAllocationsInput: ICampaignAllocationsByOrgMemberQueryInput;
}>;


export type IGetCampaignAllocationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string, monthlyInviteLimit: number, monthlyMessageLimit: number, monthlyInMailLimit: number }>, campaignAllocationsByOrgMember: Array<{ __typename?: 'CampaignAllocationListItem', campaignId: string, campaignName: string, campaignType: ICampaignType, monthlyInvitesAllocated?: number | null, monthlyMessagesAllocated?: number | null, monthlyOpenInMailAllocated?: number | null }> };

export type IUpdateCampaignAllocationsMutationVariables = Exact<{
  input: IUpdateCampaignAllocationsInput;
}>;


export type IUpdateCampaignAllocationsMutation = { __typename?: 'Mutation', updateCampaignAllocations: Array<{ __typename?: 'Campaign', id: string, name: string, type: ICampaignType, members: Array<{ __typename?: 'CampaignMember', orgMemberId: string, monthlyInvitesAllocated: number, monthlyMessagesAllocated: number, monthlyOpenInMailAllocated: number }> }> };

export type IUpdateAutoReplySettingsMutationVariables = Exact<{
  input: IUpdateAutoReplySettingsInput;
}>;


export type IUpdateAutoReplySettingsMutation = { __typename?: 'Mutation', updateCampaignAutoReplySettings: { __typename?: 'Campaign', id: string, autoReplySettings: { __typename?: 'AutoReplySettings', isEnabled: boolean } } };

export type IUpdateCampaignCalendarLinkMutationVariables = Exact<{
  input: IUpdateCampaignCalendarLinkInput;
}>;


export type IUpdateCampaignCalendarLinkMutation = { __typename?: 'Mutation', updateCampaignCalendarLink: { __typename?: 'Campaign', id: string, autoReplySettings: { __typename?: 'AutoReplySettings', calendarLink?: string | null } } };

export type IToggleWarmupStatusMutationVariables = Exact<{
  input: IToggleWarmupStatusInput;
}>;


export type IToggleWarmupStatusMutation = { __typename?: 'Mutation', toggleWarmupStatus: { __typename?: 'OrgMember', id: string, warmUpSettings: { __typename?: 'WarmUpSettings', isEnabled: boolean, percentage: number, lastIncreaseDate: number } } };

export type IUpdateCampaignNameMutationVariables = Exact<{
  input: IUpdateCampaignNameInput;
}>;


export type IUpdateCampaignNameMutation = { __typename?: 'Mutation', updateCampaignName: { __typename?: 'Campaign', id: string, name: string } };

export type IUpdateCampaignStatusMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  status: ICampaignStatusInput;
}>;


export type IUpdateCampaignStatusMutation = { __typename?: 'Mutation', updateCampaignStatus: { __typename?: 'Campaign', id: string, status: ICampaignStatus } };

export type IGetCampaignIssuesQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  orgMemberId: Scalars['ID'];
  organizationId: Scalars['ID'];
}>;


export type IGetCampaignIssuesQuery = { __typename?: 'Query', campaignSummary: { __typename?: 'Campaign', name: string, attentionItems: Array<{ __typename?: 'CampaignAttentionItem', level: IAttentionLevel, memberId: string, type: ICampaignAttentionType }> }, orgMembers: Array<{ __typename?: 'OrgMember', id: string, organizationId: string, attentionItems: Array<{ __typename?: 'OrgMemberAttentionItem', level: IAttentionLevel, memberId: string, type: IOrgMemberAttentionType }> }> };

export type IUpdateCampaignServiceScheduleMutationVariables = Exact<{
  input: IUpdateServiceScheduleInput;
}>;


export type IUpdateCampaignServiceScheduleMutation = { __typename?: 'Mutation', updateServiceSchedule: { __typename?: 'ServiceSchedule', id: string, hierarchyType: number, ownerId: string, synchronization: boolean, timezoneCode: string, weeklySchedule: Array<{ __typename?: 'WeeklyScheduleEntry', enable: boolean, start: number, end: number }> } };

export const ContactFieldsFragmentDoc = gql`
    fragment ContactFields on OrgContact {
  id
  firstName
  lastName
  organizationId
  title
  company
  email
  phoneNumber
}
    `;
export const CampaignFieldsFragmentDoc = gql`
    fragment CampaignFields on Campaign {
  id
  name
  type
  members {
    id
    orgMemberId
    dailyInvitesAllocated
    dailyMessagesAllocated
    dailyOpenInMailAllocated
  }
  status
  numActiveMembers
  attentionItems {
    memberId
    level
    type
  }
}
    `;
export const AccountSummaryFragmentDoc = gql`
    fragment AccountSummary on Account {
  id
  name
  isActive
  type
  logoUrl
  parentAccount {
    name
  }
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on User {
  id
  firstName
  lastName
  userName
  lastSeen
  isActive
  accountId
  vpnPort
  issues {
    level
    type
  }
  orgMemberInfo {
    id
    role
  }
}
    `;
export const CampaignDetailsFragmentDoc = gql`
    fragment CampaignDetails on Campaign {
  status
  type
  name
  numActiveMembers
  members {
    orgMemberId
    dailyInvitesAllocated
    dailyMessagesAllocated
    dailyOpenInMailAllocated
    monthlyInvitesAllocated
    monthlyMessagesAllocated
    monthlyOpenInMailAllocated
  }
  id
  attentionItems {
    memberId
    level
    type
  }
}
    `;
export const CampaignSummaryAttentionItemsDocument = gql`
    query CampaignSummaryAttentionItems($campaignId: ID!, $organizationIds: [ID!]!, $orgMemberIds: [ID!]) {
  campaignSummary(campaignId: $campaignId) {
    name
    attentionItems {
      level
      memberId
      type
    }
  }
  orgMembers(
    input: {organizationIds: $organizationIds, orgMemberIds: $orgMemberIds}
  ) {
    id
    organizationId
    attentionItems {
      level
      memberId
      type
    }
  }
}
    `;

/**
 * __useCampaignSummaryAttentionItemsQuery__
 *
 * To run a query within a React component, call `useCampaignSummaryAttentionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignSummaryAttentionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignSummaryAttentionItemsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      organizationIds: // value for 'organizationIds'
 *      orgMemberIds: // value for 'orgMemberIds'
 *   },
 * });
 */
export function useCampaignSummaryAttentionItemsQuery(baseOptions: Apollo.QueryHookOptions<ICampaignSummaryAttentionItemsQuery, ICampaignSummaryAttentionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICampaignSummaryAttentionItemsQuery, ICampaignSummaryAttentionItemsQueryVariables>(CampaignSummaryAttentionItemsDocument, options);
      }
export function useCampaignSummaryAttentionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICampaignSummaryAttentionItemsQuery, ICampaignSummaryAttentionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICampaignSummaryAttentionItemsQuery, ICampaignSummaryAttentionItemsQueryVariables>(CampaignSummaryAttentionItemsDocument, options);
        }
export type CampaignSummaryAttentionItemsQueryHookResult = ReturnType<typeof useCampaignSummaryAttentionItemsQuery>;
export type CampaignSummaryAttentionItemsLazyQueryHookResult = ReturnType<typeof useCampaignSummaryAttentionItemsLazyQuery>;
export type CampaignSummaryAttentionItemsQueryResult = Apollo.QueryResult<ICampaignSummaryAttentionItemsQuery, ICampaignSummaryAttentionItemsQueryVariables>;
export function refetchCampaignSummaryAttentionItemsQuery(variables: ICampaignSummaryAttentionItemsQueryVariables) {
      return { query: CampaignSummaryAttentionItemsDocument, variables: variables }
    }
export const UpdateConnectionMeetingDocument = gql`
    mutation UpdateConnectionMeeting($connectionId: ID!, $isBooked: Boolean!) {
  updateConnectionMeeting(
    campaignConnectionId: $connectionId
    isBooked: $isBooked
  ) {
    ... on CampaignConnection {
      id
      meeting {
        booked
      }
    }
  }
}
    `;
export type IUpdateConnectionMeetingMutationFn = Apollo.MutationFunction<IUpdateConnectionMeetingMutation, IUpdateConnectionMeetingMutationVariables>;

/**
 * __useUpdateConnectionMeetingMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionMeetingMutation, { data, loading, error }] = useUpdateConnectionMeetingMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      isBooked: // value for 'isBooked'
 *   },
 * });
 */
export function useUpdateConnectionMeetingMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateConnectionMeetingMutation, IUpdateConnectionMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateConnectionMeetingMutation, IUpdateConnectionMeetingMutationVariables>(UpdateConnectionMeetingDocument, options);
      }
export type UpdateConnectionMeetingMutationHookResult = ReturnType<typeof useUpdateConnectionMeetingMutation>;
export type UpdateConnectionMeetingMutationResult = Apollo.MutationResult<IUpdateConnectionMeetingMutation>;
export type UpdateConnectionMeetingMutationOptions = Apollo.BaseMutationOptions<IUpdateConnectionMeetingMutation, IUpdateConnectionMeetingMutationVariables>;
export const CampaignMemberEventsAndStatsDocument = gql`
    query CampaignMemberEventsAndStats($campaignMemberId: ID!, $end: DateTime!, $interval: TimeInterval, $start: DateTime, $numDays: Int!) {
  campaignMemberEvents(
    input: {campaignMemberId: $campaignMemberId, end: $end, numDays: $numDays}
  ) {
    ... on CampaignUsage {
      action
      campaignId
      campaignMemberId
      dateCreated
    }
  }
  campaignStats(
    input: {filter: {campaignMemberIds: [$campaignMemberId], interval: $interval, end: $end, start: $start}}
  ) {
    ... on NurtureCampaignStats {
      ownerId
      ownerType
      start
      end
      numSendMessages
      numUserReplies
      numInterestedReplies
      percentReplied
      percentInterestedReplied
    }
    ... on ProspectingCampaignStats {
      ownerId
      ownerType
      start
      end
      numUserReplies
      numUsersConnected
      numInvitesSent
      numInterestedReplies
      percentConnected
      percentReplied
      percentInterestedReplied
    }
  }
}
    `;

/**
 * __useCampaignMemberEventsAndStatsQuery__
 *
 * To run a query within a React component, call `useCampaignMemberEventsAndStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignMemberEventsAndStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignMemberEventsAndStatsQuery({
 *   variables: {
 *      campaignMemberId: // value for 'campaignMemberId'
 *      end: // value for 'end'
 *      interval: // value for 'interval'
 *      start: // value for 'start'
 *      numDays: // value for 'numDays'
 *   },
 * });
 */
export function useCampaignMemberEventsAndStatsQuery(baseOptions: Apollo.QueryHookOptions<ICampaignMemberEventsAndStatsQuery, ICampaignMemberEventsAndStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICampaignMemberEventsAndStatsQuery, ICampaignMemberEventsAndStatsQueryVariables>(CampaignMemberEventsAndStatsDocument, options);
      }
export function useCampaignMemberEventsAndStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICampaignMemberEventsAndStatsQuery, ICampaignMemberEventsAndStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICampaignMemberEventsAndStatsQuery, ICampaignMemberEventsAndStatsQueryVariables>(CampaignMemberEventsAndStatsDocument, options);
        }
export type CampaignMemberEventsAndStatsQueryHookResult = ReturnType<typeof useCampaignMemberEventsAndStatsQuery>;
export type CampaignMemberEventsAndStatsLazyQueryHookResult = ReturnType<typeof useCampaignMemberEventsAndStatsLazyQuery>;
export type CampaignMemberEventsAndStatsQueryResult = Apollo.QueryResult<ICampaignMemberEventsAndStatsQuery, ICampaignMemberEventsAndStatsQueryVariables>;
export function refetchCampaignMemberEventsAndStatsQuery(variables: ICampaignMemberEventsAndStatsQueryVariables) {
      return { query: CampaignMemberEventsAndStatsDocument, variables: variables }
    }
export const CampaignStatsDocument = gql`
    query CampaignStats($input: CampaignStatsInput!) {
  campaignStats(input: $input) {
    ... on NurtureCampaignStats {
      ownerId
      ownerType
      start
      end
      numSendMessages
      numUserReplies
      numInterestedReplies
      percentReplied
      percentInterestedReplied
    }
    ... on ProspectingCampaignStats {
      ownerId
      ownerType
      start
      end
      numUserReplies
      numUsersConnected
      numInvitesSent
      numInterestedReplies
      numInMailSent
      numInMailReplies
      numInterestedInMailReplies
      percentConnected
      percentReplied
      percentInterestedReplied
      percentInMailReplied
      percentInterestedInMailReplied
    }
  }
}
    `;

/**
 * __useCampaignStatsQuery__
 *
 * To run a query within a React component, call `useCampaignStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignStatsQuery(baseOptions: Apollo.QueryHookOptions<ICampaignStatsQuery, ICampaignStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICampaignStatsQuery, ICampaignStatsQueryVariables>(CampaignStatsDocument, options);
      }
export function useCampaignStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICampaignStatsQuery, ICampaignStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICampaignStatsQuery, ICampaignStatsQueryVariables>(CampaignStatsDocument, options);
        }
export type CampaignStatsQueryHookResult = ReturnType<typeof useCampaignStatsQuery>;
export type CampaignStatsLazyQueryHookResult = ReturnType<typeof useCampaignStatsLazyQuery>;
export type CampaignStatsQueryResult = Apollo.QueryResult<ICampaignStatsQuery, ICampaignStatsQueryVariables>;
export function refetchCampaignStatsQuery(variables: ICampaignStatsQueryVariables) {
      return { query: CampaignStatsDocument, variables: variables }
    }
export const CampaignSummariesDocument = gql`
    query CampaignSummaries($start: DateTime, $end: DateTime, $searchTerm: String) {
  campaignSummaries(searchTerm: $searchTerm) {
    id
    members {
      id
      orgMemberId
    }
    name
    numActiveMembers
    launchedAt
    stats(start: $start, end: $end) {
      ... on NurtureCampaignStats {
        numUserReplies
        numSendMessages
        percentReplied
      }
      ... on ProspectingCampaignStats {
        numUserReplies
        numUsersConnected
        numInvitesSent
        percentConnected
        percentReplied
      }
    }
    status
    type
  }
}
    `;

/**
 * __useCampaignSummariesQuery__
 *
 * To run a query within a React component, call `useCampaignSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignSummariesQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useCampaignSummariesQuery(baseOptions?: Apollo.QueryHookOptions<ICampaignSummariesQuery, ICampaignSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICampaignSummariesQuery, ICampaignSummariesQueryVariables>(CampaignSummariesDocument, options);
      }
export function useCampaignSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICampaignSummariesQuery, ICampaignSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICampaignSummariesQuery, ICampaignSummariesQueryVariables>(CampaignSummariesDocument, options);
        }
export type CampaignSummariesQueryHookResult = ReturnType<typeof useCampaignSummariesQuery>;
export type CampaignSummariesLazyQueryHookResult = ReturnType<typeof useCampaignSummariesLazyQuery>;
export type CampaignSummariesQueryResult = Apollo.QueryResult<ICampaignSummariesQuery, ICampaignSummariesQueryVariables>;
export function refetchCampaignSummariesQuery(variables?: ICampaignSummariesQueryVariables) {
      return { query: CampaignSummariesDocument, variables: variables }
    }
export const CampaignsWithOrgMemberDocument = gql`
    query CampaignsWithOrgMember($start: DateTime, $end: DateTime, $searchTerm: String) {
  campaignSummaries(searchTerm: $searchTerm) {
    id
    members {
      id
      orgMemberId
    }
    name
    numActiveMembers
    launchedAt
    stats(start: $start, end: $end) {
      ... on NurtureCampaignStats {
        numUserReplies
        numSendMessages
        percentReplied
      }
      ... on ProspectingCampaignStats {
        numUserReplies
        numUsersConnected
        numInvitesSent
        percentConnected
        percentReplied
      }
    }
    status
    type
    orgMember {
      id
      userInfo {
        fullName
      }
    }
  }
}
    `;

/**
 * __useCampaignsWithOrgMemberQuery__
 *
 * To run a query within a React component, call `useCampaignsWithOrgMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsWithOrgMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsWithOrgMemberQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useCampaignsWithOrgMemberQuery(baseOptions?: Apollo.QueryHookOptions<ICampaignsWithOrgMemberQuery, ICampaignsWithOrgMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICampaignsWithOrgMemberQuery, ICampaignsWithOrgMemberQueryVariables>(CampaignsWithOrgMemberDocument, options);
      }
export function useCampaignsWithOrgMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICampaignsWithOrgMemberQuery, ICampaignsWithOrgMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICampaignsWithOrgMemberQuery, ICampaignsWithOrgMemberQueryVariables>(CampaignsWithOrgMemberDocument, options);
        }
export type CampaignsWithOrgMemberQueryHookResult = ReturnType<typeof useCampaignsWithOrgMemberQuery>;
export type CampaignsWithOrgMemberLazyQueryHookResult = ReturnType<typeof useCampaignsWithOrgMemberLazyQuery>;
export type CampaignsWithOrgMemberQueryResult = Apollo.QueryResult<ICampaignsWithOrgMemberQuery, ICampaignsWithOrgMemberQueryVariables>;
export function refetchCampaignsWithOrgMemberQuery(variables?: ICampaignsWithOrgMemberQueryVariables) {
      return { query: CampaignsWithOrgMemberDocument, variables: variables }
    }
export const CampaignConnectionsDocument = gql`
    query CampaignConnections($input: CampaignConnectionsInput!) {
  campaignConnections(input: $input) {
    id
    nextAutomationNode {
      id
      name
      message
    }
  }
}
    `;

/**
 * __useCampaignConnectionsQuery__
 *
 * To run a query within a React component, call `useCampaignConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignConnectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ICampaignConnectionsQuery, ICampaignConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICampaignConnectionsQuery, ICampaignConnectionsQueryVariables>(CampaignConnectionsDocument, options);
      }
export function useCampaignConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICampaignConnectionsQuery, ICampaignConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICampaignConnectionsQuery, ICampaignConnectionsQueryVariables>(CampaignConnectionsDocument, options);
        }
export type CampaignConnectionsQueryHookResult = ReturnType<typeof useCampaignConnectionsQuery>;
export type CampaignConnectionsLazyQueryHookResult = ReturnType<typeof useCampaignConnectionsLazyQuery>;
export type CampaignConnectionsQueryResult = Apollo.QueryResult<ICampaignConnectionsQuery, ICampaignConnectionsQueryVariables>;
export function refetchCampaignConnectionsQuery(variables: ICampaignConnectionsQueryVariables) {
      return { query: CampaignConnectionsDocument, variables: variables }
    }
export const CampaignAllocationsByUserDocument = gql`
    query campaignAllocationsByUser($input: CampaignInput!) {
  campaigns(input: $input) {
    id
    name
    type
    members {
      orgMemberId
      dailyInvitesAllocated
      dailyMessagesAllocated
    }
  }
}
    `;

/**
 * __useCampaignAllocationsByUserQuery__
 *
 * To run a query within a React component, call `useCampaignAllocationsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAllocationsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAllocationsByUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignAllocationsByUserQuery(baseOptions: Apollo.QueryHookOptions<ICampaignAllocationsByUserQuery, ICampaignAllocationsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICampaignAllocationsByUserQuery, ICampaignAllocationsByUserQueryVariables>(CampaignAllocationsByUserDocument, options);
      }
export function useCampaignAllocationsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICampaignAllocationsByUserQuery, ICampaignAllocationsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICampaignAllocationsByUserQuery, ICampaignAllocationsByUserQueryVariables>(CampaignAllocationsByUserDocument, options);
        }
export type CampaignAllocationsByUserQueryHookResult = ReturnType<typeof useCampaignAllocationsByUserQuery>;
export type CampaignAllocationsByUserLazyQueryHookResult = ReturnType<typeof useCampaignAllocationsByUserLazyQuery>;
export type CampaignAllocationsByUserQueryResult = Apollo.QueryResult<ICampaignAllocationsByUserQuery, ICampaignAllocationsByUserQueryVariables>;
export function refetchCampaignAllocationsByUserQuery(variables: ICampaignAllocationsByUserQueryVariables) {
      return { query: CampaignAllocationsByUserDocument, variables: variables }
    }
export const OrganizationContactInformationDocument = gql`
    query OrganizationContactInformation($contactId: ID!) {
  campaignConnections(input: {contactId: $contactId}) {
    id
    campaignId
    campaignMember {
      id
      orgMemberId
    }
    campaignHistory {
      start
      end
      name
    }
    meeting {
      bookedDate
    }
    communicationStyles {
      styles {
        style
      }
      lastUpdated
      failureReason
    }
  }
  orgContacts(input: {orgContactIds: [$contactId]}) {
    id
    firstName
    lastName
    organizationId
    title
    company
    email
    phoneNumber
  }
}
    `;

/**
 * __useOrganizationContactInformationQuery__
 *
 * To run a query within a React component, call `useOrganizationContactInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationContactInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationContactInformationQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useOrganizationContactInformationQuery(baseOptions: Apollo.QueryHookOptions<IOrganizationContactInformationQuery, IOrganizationContactInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOrganizationContactInformationQuery, IOrganizationContactInformationQueryVariables>(OrganizationContactInformationDocument, options);
      }
export function useOrganizationContactInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOrganizationContactInformationQuery, IOrganizationContactInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOrganizationContactInformationQuery, IOrganizationContactInformationQueryVariables>(OrganizationContactInformationDocument, options);
        }
export type OrganizationContactInformationQueryHookResult = ReturnType<typeof useOrganizationContactInformationQuery>;
export type OrganizationContactInformationLazyQueryHookResult = ReturnType<typeof useOrganizationContactInformationLazyQuery>;
export type OrganizationContactInformationQueryResult = Apollo.QueryResult<IOrganizationContactInformationQuery, IOrganizationContactInformationQueryVariables>;
export function refetchOrganizationContactInformationQuery(variables: IOrganizationContactInformationQueryVariables) {
      return { query: OrganizationContactInformationDocument, variables: variables }
    }
export const UpdateOrgContactCompanyDocument = gql`
    mutation UpdateOrgContactCompany($orgContactId: ID!, $company: String!) {
  updateOrgContactCompany(orgContactId: $orgContactId, company: $company) {
    ...ContactFields
  }
}
    ${ContactFieldsFragmentDoc}`;
export type IUpdateOrgContactCompanyMutationFn = Apollo.MutationFunction<IUpdateOrgContactCompanyMutation, IUpdateOrgContactCompanyMutationVariables>;

/**
 * __useUpdateOrgContactCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateOrgContactCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgContactCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgContactCompanyMutation, { data, loading, error }] = useUpdateOrgContactCompanyMutation({
 *   variables: {
 *      orgContactId: // value for 'orgContactId'
 *      company: // value for 'company'
 *   },
 * });
 */
export function useUpdateOrgContactCompanyMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateOrgContactCompanyMutation, IUpdateOrgContactCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateOrgContactCompanyMutation, IUpdateOrgContactCompanyMutationVariables>(UpdateOrgContactCompanyDocument, options);
      }
export type UpdateOrgContactCompanyMutationHookResult = ReturnType<typeof useUpdateOrgContactCompanyMutation>;
export type UpdateOrgContactCompanyMutationResult = Apollo.MutationResult<IUpdateOrgContactCompanyMutation>;
export type UpdateOrgContactCompanyMutationOptions = Apollo.BaseMutationOptions<IUpdateOrgContactCompanyMutation, IUpdateOrgContactCompanyMutationVariables>;
export const UpdateOrgContactEmailDocument = gql`
    mutation UpdateOrgContactEmail($orgContactId: ID!, $email: String!) {
  updateOrgContactEmail(orgContactId: $orgContactId, email: $email) {
    ...ContactFields
  }
}
    ${ContactFieldsFragmentDoc}`;
export type IUpdateOrgContactEmailMutationFn = Apollo.MutationFunction<IUpdateOrgContactEmailMutation, IUpdateOrgContactEmailMutationVariables>;

/**
 * __useUpdateOrgContactEmailMutation__
 *
 * To run a mutation, you first call `useUpdateOrgContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgContactEmailMutation, { data, loading, error }] = useUpdateOrgContactEmailMutation({
 *   variables: {
 *      orgContactId: // value for 'orgContactId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateOrgContactEmailMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateOrgContactEmailMutation, IUpdateOrgContactEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateOrgContactEmailMutation, IUpdateOrgContactEmailMutationVariables>(UpdateOrgContactEmailDocument, options);
      }
export type UpdateOrgContactEmailMutationHookResult = ReturnType<typeof useUpdateOrgContactEmailMutation>;
export type UpdateOrgContactEmailMutationResult = Apollo.MutationResult<IUpdateOrgContactEmailMutation>;
export type UpdateOrgContactEmailMutationOptions = Apollo.BaseMutationOptions<IUpdateOrgContactEmailMutation, IUpdateOrgContactEmailMutationVariables>;
export const UpdateOrgContactPhoneNumberDocument = gql`
    mutation UpdateOrgContactPhoneNumber($orgContactId: ID!, $phoneNumber: String!) {
  updateOrgContactPhoneNumber(
    orgContactId: $orgContactId
    phoneNumber: $phoneNumber
  ) {
    ...ContactFields
  }
}
    ${ContactFieldsFragmentDoc}`;
export type IUpdateOrgContactPhoneNumberMutationFn = Apollo.MutationFunction<IUpdateOrgContactPhoneNumberMutation, IUpdateOrgContactPhoneNumberMutationVariables>;

/**
 * __useUpdateOrgContactPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdateOrgContactPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgContactPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgContactPhoneNumberMutation, { data, loading, error }] = useUpdateOrgContactPhoneNumberMutation({
 *   variables: {
 *      orgContactId: // value for 'orgContactId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateOrgContactPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateOrgContactPhoneNumberMutation, IUpdateOrgContactPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateOrgContactPhoneNumberMutation, IUpdateOrgContactPhoneNumberMutationVariables>(UpdateOrgContactPhoneNumberDocument, options);
      }
export type UpdateOrgContactPhoneNumberMutationHookResult = ReturnType<typeof useUpdateOrgContactPhoneNumberMutation>;
export type UpdateOrgContactPhoneNumberMutationResult = Apollo.MutationResult<IUpdateOrgContactPhoneNumberMutation>;
export type UpdateOrgContactPhoneNumberMutationOptions = Apollo.BaseMutationOptions<IUpdateOrgContactPhoneNumberMutation, IUpdateOrgContactPhoneNumberMutationVariables>;
export const UpdateOrgContactTitleDocument = gql`
    mutation UpdateOrgContactTitle($orgContactId: ID!, $title: String!) {
  updateOrgContactTitle(orgContactId: $orgContactId, title: $title) {
    ...ContactFields
  }
}
    ${ContactFieldsFragmentDoc}`;
export type IUpdateOrgContactTitleMutationFn = Apollo.MutationFunction<IUpdateOrgContactTitleMutation, IUpdateOrgContactTitleMutationVariables>;

/**
 * __useUpdateOrgContactTitleMutation__
 *
 * To run a mutation, you first call `useUpdateOrgContactTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgContactTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgContactTitleMutation, { data, loading, error }] = useUpdateOrgContactTitleMutation({
 *   variables: {
 *      orgContactId: // value for 'orgContactId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateOrgContactTitleMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateOrgContactTitleMutation, IUpdateOrgContactTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateOrgContactTitleMutation, IUpdateOrgContactTitleMutationVariables>(UpdateOrgContactTitleDocument, options);
      }
export type UpdateOrgContactTitleMutationHookResult = ReturnType<typeof useUpdateOrgContactTitleMutation>;
export type UpdateOrgContactTitleMutationResult = Apollo.MutationResult<IUpdateOrgContactTitleMutation>;
export type UpdateOrgContactTitleMutationOptions = Apollo.BaseMutationOptions<IUpdateOrgContactTitleMutation, IUpdateOrgContactTitleMutationVariables>;
export const AnalyzeCommunicationStylesDocument = gql`
    mutation analyzeCommunicationStyles($campaignConnectionId: ID!) {
  analyzeCommunicationStyles(campaignConnectionId: $campaignConnectionId) {
    id
    communicationStyles {
      styles {
        style
      }
      lastUpdated
    }
  }
}
    `;
export type IAnalyzeCommunicationStylesMutationFn = Apollo.MutationFunction<IAnalyzeCommunicationStylesMutation, IAnalyzeCommunicationStylesMutationVariables>;

/**
 * __useAnalyzeCommunicationStylesMutation__
 *
 * To run a mutation, you first call `useAnalyzeCommunicationStylesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeCommunicationStylesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzeCommunicationStylesMutation, { data, loading, error }] = useAnalyzeCommunicationStylesMutation({
 *   variables: {
 *      campaignConnectionId: // value for 'campaignConnectionId'
 *   },
 * });
 */
export function useAnalyzeCommunicationStylesMutation(baseOptions?: Apollo.MutationHookOptions<IAnalyzeCommunicationStylesMutation, IAnalyzeCommunicationStylesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAnalyzeCommunicationStylesMutation, IAnalyzeCommunicationStylesMutationVariables>(AnalyzeCommunicationStylesDocument, options);
      }
export type AnalyzeCommunicationStylesMutationHookResult = ReturnType<typeof useAnalyzeCommunicationStylesMutation>;
export type AnalyzeCommunicationStylesMutationResult = Apollo.MutationResult<IAnalyzeCommunicationStylesMutation>;
export type AnalyzeCommunicationStylesMutationOptions = Apollo.BaseMutationOptions<IAnalyzeCommunicationStylesMutation, IAnalyzeCommunicationStylesMutationVariables>;
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($name: String!, $type: CampaignType!, $orgMemberId: ID) {
  createCampaign(input: {name: $name, type: $type, orgMemberId: $orgMemberId}) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type ICreateCampaignMutationFn = Apollo.MutationFunction<ICreateCampaignMutation, ICreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      orgMemberId: // value for 'orgMemberId'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ICreateCampaignMutation, ICreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateCampaignMutation, ICreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<ICreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<ICreateCampaignMutation, ICreateCampaignMutationVariables>;
export const DuplicateCampaignDocument = gql`
    mutation DuplicateCampaign($name: String!, $campaignId: ID!, $orgMemberId: ID) {
  duplicateCampaign(
    input: {name: $name, campaignId: $campaignId, orgMemberId: $orgMemberId}
  ) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type IDuplicateCampaignMutationFn = Apollo.MutationFunction<IDuplicateCampaignMutation, IDuplicateCampaignMutationVariables>;

/**
 * __useDuplicateCampaignMutation__
 *
 * To run a mutation, you first call `useDuplicateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCampaignMutation, { data, loading, error }] = useDuplicateCampaignMutation({
 *   variables: {
 *      name: // value for 'name'
 *      campaignId: // value for 'campaignId'
 *      orgMemberId: // value for 'orgMemberId'
 *   },
 * });
 */
export function useDuplicateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<IDuplicateCampaignMutation, IDuplicateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDuplicateCampaignMutation, IDuplicateCampaignMutationVariables>(DuplicateCampaignDocument, options);
      }
export type DuplicateCampaignMutationHookResult = ReturnType<typeof useDuplicateCampaignMutation>;
export type DuplicateCampaignMutationResult = Apollo.MutationResult<IDuplicateCampaignMutation>;
export type DuplicateCampaignMutationOptions = Apollo.BaseMutationOptions<IDuplicateCampaignMutation, IDuplicateCampaignMutationVariables>;
export const AddAccountDocument = gql`
    mutation addAccount($input: AddAccountInput!) {
  addAccount(input: $input) {
    id
    name
    orgInfo {
      id
    }
  }
}
    `;
export type IAddAccountMutationFn = Apollo.MutationFunction<IAddAccountMutation, IAddAccountMutationVariables>;

/**
 * __useAddAccountMutation__
 *
 * To run a mutation, you first call `useAddAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountMutation, { data, loading, error }] = useAddAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAccountMutation(baseOptions?: Apollo.MutationHookOptions<IAddAccountMutation, IAddAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddAccountMutation, IAddAccountMutationVariables>(AddAccountDocument, options);
      }
export type AddAccountMutationHookResult = ReturnType<typeof useAddAccountMutation>;
export type AddAccountMutationResult = Apollo.MutationResult<IAddAccountMutation>;
export type AddAccountMutationOptions = Apollo.BaseMutationOptions<IAddAccountMutation, IAddAccountMutationVariables>;
export const UpdateUserGivenNamesDocument = gql`
    mutation updateUserGivenNames($input: UpdateUserGivenNamesInput!) {
  updateUserGivenNames(input: $input) {
    id
    firstName
    lastName
  }
}
    `;
export type IUpdateUserGivenNamesMutationFn = Apollo.MutationFunction<IUpdateUserGivenNamesMutation, IUpdateUserGivenNamesMutationVariables>;

/**
 * __useUpdateUserGivenNamesMutation__
 *
 * To run a mutation, you first call `useUpdateUserGivenNamesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGivenNamesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGivenNamesMutation, { data, loading, error }] = useUpdateUserGivenNamesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserGivenNamesMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateUserGivenNamesMutation, IUpdateUserGivenNamesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateUserGivenNamesMutation, IUpdateUserGivenNamesMutationVariables>(UpdateUserGivenNamesDocument, options);
      }
export type UpdateUserGivenNamesMutationHookResult = ReturnType<typeof useUpdateUserGivenNamesMutation>;
export type UpdateUserGivenNamesMutationResult = Apollo.MutationResult<IUpdateUserGivenNamesMutation>;
export type UpdateUserGivenNamesMutationOptions = Apollo.BaseMutationOptions<IUpdateUserGivenNamesMutation, IUpdateUserGivenNamesMutationVariables>;
export const PromptsDocument = gql`
    query prompts {
  prompts {
    id
    label
    action
    useCases
  }
}
    `;

/**
 * __usePromptsQuery__
 *
 * To run a query within a React component, call `usePromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePromptsQuery(baseOptions?: Apollo.QueryHookOptions<IPromptsQuery, IPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPromptsQuery, IPromptsQueryVariables>(PromptsDocument, options);
      }
export function usePromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPromptsQuery, IPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPromptsQuery, IPromptsQueryVariables>(PromptsDocument, options);
        }
export type PromptsQueryHookResult = ReturnType<typeof usePromptsQuery>;
export type PromptsLazyQueryHookResult = ReturnType<typeof usePromptsLazyQuery>;
export type PromptsQueryResult = Apollo.QueryResult<IPromptsQuery, IPromptsQueryVariables>;
export function refetchPromptsQuery(variables?: IPromptsQueryVariables) {
      return { query: PromptsDocument, variables: variables }
    }
export const UpdateConnectionAutoReplySettingsDocument = gql`
    mutation UpdateConnectionAutoReplySettings($input: UpdateConnectionAutoReplySettingsInput!) {
  updateCampaignConnectionAutoReplySettings(input: $input) {
    id
    autoReplySettings {
      isEnabled
    }
  }
}
    `;
export type IUpdateConnectionAutoReplySettingsMutationFn = Apollo.MutationFunction<IUpdateConnectionAutoReplySettingsMutation, IUpdateConnectionAutoReplySettingsMutationVariables>;

/**
 * __useUpdateConnectionAutoReplySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionAutoReplySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionAutoReplySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionAutoReplySettingsMutation, { data, loading, error }] = useUpdateConnectionAutoReplySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConnectionAutoReplySettingsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateConnectionAutoReplySettingsMutation, IUpdateConnectionAutoReplySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateConnectionAutoReplySettingsMutation, IUpdateConnectionAutoReplySettingsMutationVariables>(UpdateConnectionAutoReplySettingsDocument, options);
      }
export type UpdateConnectionAutoReplySettingsMutationHookResult = ReturnType<typeof useUpdateConnectionAutoReplySettingsMutation>;
export type UpdateConnectionAutoReplySettingsMutationResult = Apollo.MutationResult<IUpdateConnectionAutoReplySettingsMutation>;
export type UpdateConnectionAutoReplySettingsMutationOptions = Apollo.BaseMutationOptions<IUpdateConnectionAutoReplySettingsMutation, IUpdateConnectionAutoReplySettingsMutationVariables>;
export const GetCampaignAndConnectionAutoReplySettingsDocument = gql`
    query GetCampaignAndConnectionAutoReplySettings($campaignId: ID!, $campaignConnectionId: ID!) {
  campaign: campaignSummary(campaignId: $campaignId) {
    id
    autoReplySettings {
      isEnabled
      calendarLink
    }
  }
  campaignConnection: campaignConnection(connectionId: $campaignConnectionId) {
    id
    autoReplySettings {
      isEnabled
    }
  }
}
    `;

/**
 * __useGetCampaignAndConnectionAutoReplySettingsQuery__
 *
 * To run a query within a React component, call `useGetCampaignAndConnectionAutoReplySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignAndConnectionAutoReplySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignAndConnectionAutoReplySettingsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      campaignConnectionId: // value for 'campaignConnectionId'
 *   },
 * });
 */
export function useGetCampaignAndConnectionAutoReplySettingsQuery(baseOptions: Apollo.QueryHookOptions<IGetCampaignAndConnectionAutoReplySettingsQuery, IGetCampaignAndConnectionAutoReplySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCampaignAndConnectionAutoReplySettingsQuery, IGetCampaignAndConnectionAutoReplySettingsQueryVariables>(GetCampaignAndConnectionAutoReplySettingsDocument, options);
      }
export function useGetCampaignAndConnectionAutoReplySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCampaignAndConnectionAutoReplySettingsQuery, IGetCampaignAndConnectionAutoReplySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCampaignAndConnectionAutoReplySettingsQuery, IGetCampaignAndConnectionAutoReplySettingsQueryVariables>(GetCampaignAndConnectionAutoReplySettingsDocument, options);
        }
export type GetCampaignAndConnectionAutoReplySettingsQueryHookResult = ReturnType<typeof useGetCampaignAndConnectionAutoReplySettingsQuery>;
export type GetCampaignAndConnectionAutoReplySettingsLazyQueryHookResult = ReturnType<typeof useGetCampaignAndConnectionAutoReplySettingsLazyQuery>;
export type GetCampaignAndConnectionAutoReplySettingsQueryResult = Apollo.QueryResult<IGetCampaignAndConnectionAutoReplySettingsQuery, IGetCampaignAndConnectionAutoReplySettingsQueryVariables>;
export function refetchGetCampaignAndConnectionAutoReplySettingsQuery(variables: IGetCampaignAndConnectionAutoReplySettingsQueryVariables) {
      return { query: GetCampaignAndConnectionAutoReplySettingsDocument, variables: variables }
    }
export const GenerateMessageRecommendationDocument = gql`
    mutation GenerateMessageRecommendation($input: GenerateMessageRecommendationInput!) {
  generateMessageRecommendation(input: $input) {
    content
    id
  }
}
    `;
export type IGenerateMessageRecommendationMutationFn = Apollo.MutationFunction<IGenerateMessageRecommendationMutation, IGenerateMessageRecommendationMutationVariables>;

/**
 * __useGenerateMessageRecommendationMutation__
 *
 * To run a mutation, you first call `useGenerateMessageRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMessageRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMessageRecommendationMutation, { data, loading, error }] = useGenerateMessageRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateMessageRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<IGenerateMessageRecommendationMutation, IGenerateMessageRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGenerateMessageRecommendationMutation, IGenerateMessageRecommendationMutationVariables>(GenerateMessageRecommendationDocument, options);
      }
export type GenerateMessageRecommendationMutationHookResult = ReturnType<typeof useGenerateMessageRecommendationMutation>;
export type GenerateMessageRecommendationMutationResult = Apollo.MutationResult<IGenerateMessageRecommendationMutation>;
export type GenerateMessageRecommendationMutationOptions = Apollo.BaseMutationOptions<IGenerateMessageRecommendationMutation, IGenerateMessageRecommendationMutationVariables>;
export const EditSmartReplyDocument = gql`
    query EditSmartReply($input: EditSmartReplyInput!) {
  editSmartReply(input: $input) {
    ... on SmartReply {
      message
    }
    ... on SmartReplyError {
      message
      type
    }
  }
}
    `;

/**
 * __useEditSmartReplyQuery__
 *
 * To run a query within a React component, call `useEditSmartReplyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSmartReplyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSmartReplyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSmartReplyQuery(baseOptions: Apollo.QueryHookOptions<IEditSmartReplyQuery, IEditSmartReplyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IEditSmartReplyQuery, IEditSmartReplyQueryVariables>(EditSmartReplyDocument, options);
      }
export function useEditSmartReplyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IEditSmartReplyQuery, IEditSmartReplyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IEditSmartReplyQuery, IEditSmartReplyQueryVariables>(EditSmartReplyDocument, options);
        }
export type EditSmartReplyQueryHookResult = ReturnType<typeof useEditSmartReplyQuery>;
export type EditSmartReplyLazyQueryHookResult = ReturnType<typeof useEditSmartReplyLazyQuery>;
export type EditSmartReplyQueryResult = Apollo.QueryResult<IEditSmartReplyQuery, IEditSmartReplyQueryVariables>;
export function refetchEditSmartReplyQuery(variables: IEditSmartReplyQueryVariables) {
      return { query: EditSmartReplyDocument, variables: variables }
    }
export const WriteSmartReplyDocument = gql`
    query WriteSmartReply($input: WriteSmartReplyInput!) {
  writeSmartReply(input: $input) {
    ... on SmartReply {
      message
    }
    ... on SmartReplyError {
      message
      type
    }
  }
}
    `;

/**
 * __useWriteSmartReplyQuery__
 *
 * To run a query within a React component, call `useWriteSmartReplyQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriteSmartReplyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriteSmartReplyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWriteSmartReplyQuery(baseOptions: Apollo.QueryHookOptions<IWriteSmartReplyQuery, IWriteSmartReplyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWriteSmartReplyQuery, IWriteSmartReplyQueryVariables>(WriteSmartReplyDocument, options);
      }
export function useWriteSmartReplyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWriteSmartReplyQuery, IWriteSmartReplyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWriteSmartReplyQuery, IWriteSmartReplyQueryVariables>(WriteSmartReplyDocument, options);
        }
export type WriteSmartReplyQueryHookResult = ReturnType<typeof useWriteSmartReplyQuery>;
export type WriteSmartReplyLazyQueryHookResult = ReturnType<typeof useWriteSmartReplyLazyQuery>;
export type WriteSmartReplyQueryResult = Apollo.QueryResult<IWriteSmartReplyQuery, IWriteSmartReplyQueryVariables>;
export function refetchWriteSmartReplyQuery(variables: IWriteSmartReplyQueryVariables) {
      return { query: WriteSmartReplyDocument, variables: variables }
    }
export const SearchAccountsDocument = gql`
    query searchAccounts($accountsFilter: AccountFilters!, $pagination: Pagination) {
  admin_accounts(input: $accountsFilter, pagination: $pagination) {
    ...AccountSummary
  }
}
    ${AccountSummaryFragmentDoc}`;

/**
 * __useSearchAccountsQuery__
 *
 * To run a query within a React component, call `useSearchAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAccountsQuery({
 *   variables: {
 *      accountsFilter: // value for 'accountsFilter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchAccountsQuery(baseOptions: Apollo.QueryHookOptions<ISearchAccountsQuery, ISearchAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISearchAccountsQuery, ISearchAccountsQueryVariables>(SearchAccountsDocument, options);
      }
export function useSearchAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISearchAccountsQuery, ISearchAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISearchAccountsQuery, ISearchAccountsQueryVariables>(SearchAccountsDocument, options);
        }
export type SearchAccountsQueryHookResult = ReturnType<typeof useSearchAccountsQuery>;
export type SearchAccountsLazyQueryHookResult = ReturnType<typeof useSearchAccountsLazyQuery>;
export type SearchAccountsQueryResult = Apollo.QueryResult<ISearchAccountsQuery, ISearchAccountsQueryVariables>;
export function refetchSearchAccountsQuery(variables: ISearchAccountsQueryVariables) {
      return { query: SearchAccountsDocument, variables: variables }
    }
export const AccountsDocument = gql`
    query accounts($accountsFilter: AccountFilters!, $pagination: Pagination) {
  admin_num_accounts(input: $accountsFilter)
  admin_accounts(input: $accountsFilter, pagination: $pagination) {
    id
    name
    isActive
    type
    logoUrl
    dateCreated
    users {
      id
      firstName
      lastName
      userName
      lastSeen
      isActive
      accountId
      issues {
        level
        type
      }
    }
    orgInfo {
      id
    }
    primaryContact {
      id
    }
    accountManager {
      firstName
      lastName
      id
    }
  }
}
    `;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      accountsFilter: // value for 'accountsFilter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAccountsQuery(baseOptions: Apollo.QueryHookOptions<IAccountsQuery, IAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAccountsQuery, IAccountsQueryVariables>(AccountsDocument, options);
      }
export function useAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAccountsQuery, IAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAccountsQuery, IAccountsQueryVariables>(AccountsDocument, options);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsQueryResult = Apollo.QueryResult<IAccountsQuery, IAccountsQueryVariables>;
export function refetchAccountsQuery(variables: IAccountsQueryVariables) {
      return { query: AccountsDocument, variables: variables }
    }
export const ActivateRegularAccountDocument = gql`
    mutation activateRegularAccount($accountId: ID!) {
  activateRegularAccount(accountId: $accountId) {
    id
  }
}
    `;
export type IActivateRegularAccountMutationFn = Apollo.MutationFunction<IActivateRegularAccountMutation, IActivateRegularAccountMutationVariables>;

/**
 * __useActivateRegularAccountMutation__
 *
 * To run a mutation, you first call `useActivateRegularAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateRegularAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateRegularAccountMutation, { data, loading, error }] = useActivateRegularAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useActivateRegularAccountMutation(baseOptions?: Apollo.MutationHookOptions<IActivateRegularAccountMutation, IActivateRegularAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IActivateRegularAccountMutation, IActivateRegularAccountMutationVariables>(ActivateRegularAccountDocument, options);
      }
export type ActivateRegularAccountMutationHookResult = ReturnType<typeof useActivateRegularAccountMutation>;
export type ActivateRegularAccountMutationResult = Apollo.MutationResult<IActivateRegularAccountMutation>;
export type ActivateRegularAccountMutationOptions = Apollo.BaseMutationOptions<IActivateRegularAccountMutation, IActivateRegularAccountMutationVariables>;
export const DeactivateRegularAccountDocument = gql`
    mutation deactivateRegularAccount($accountId: ID!) {
  deactivateRegularAccount(accountId: $accountId) {
    id
  }
}
    `;
export type IDeactivateRegularAccountMutationFn = Apollo.MutationFunction<IDeactivateRegularAccountMutation, IDeactivateRegularAccountMutationVariables>;

/**
 * __useDeactivateRegularAccountMutation__
 *
 * To run a mutation, you first call `useDeactivateRegularAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateRegularAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateRegularAccountMutation, { data, loading, error }] = useDeactivateRegularAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeactivateRegularAccountMutation(baseOptions?: Apollo.MutationHookOptions<IDeactivateRegularAccountMutation, IDeactivateRegularAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeactivateRegularAccountMutation, IDeactivateRegularAccountMutationVariables>(DeactivateRegularAccountDocument, options);
      }
export type DeactivateRegularAccountMutationHookResult = ReturnType<typeof useDeactivateRegularAccountMutation>;
export type DeactivateRegularAccountMutationResult = Apollo.MutationResult<IDeactivateRegularAccountMutation>;
export type DeactivateRegularAccountMutationOptions = Apollo.BaseMutationOptions<IDeactivateRegularAccountMutation, IDeactivateRegularAccountMutationVariables>;
export const AccountDocument = gql`
    query account($adminAccountId: ID!) {
  admin_account(id: $adminAccountId) {
    id
    isActive
    name
    orgInfo {
      id
    }
    users {
      ...UserDetails
    }
    primaryContact {
      id
    }
    type
    logoUrl
    dateCreated
    childAccountsSummary {
      totalUsers
      totalActiveUsers
      totalAccounts
    }
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      adminAccountId: // value for 'adminAccountId'
 *   },
 * });
 */
export function useAccountQuery(baseOptions: Apollo.QueryHookOptions<IAccountQuery, IAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAccountQuery, IAccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAccountQuery, IAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAccountQuery, IAccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = Apollo.QueryResult<IAccountQuery, IAccountQueryVariables>;
export function refetchAccountQuery(variables: IAccountQueryVariables) {
      return { query: AccountDocument, variables: variables }
    }
export const DeactivateUsersDocument = gql`
    mutation deactivateUsers($input: DeactivateUsersInput!) {
  deactivateUsers(input: $input) {
    id
  }
}
    `;
export type IDeactivateUsersMutationFn = Apollo.MutationFunction<IDeactivateUsersMutation, IDeactivateUsersMutationVariables>;

/**
 * __useDeactivateUsersMutation__
 *
 * To run a mutation, you first call `useDeactivateUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUsersMutation, { data, loading, error }] = useDeactivateUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateUsersMutation(baseOptions?: Apollo.MutationHookOptions<IDeactivateUsersMutation, IDeactivateUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeactivateUsersMutation, IDeactivateUsersMutationVariables>(DeactivateUsersDocument, options);
      }
export type DeactivateUsersMutationHookResult = ReturnType<typeof useDeactivateUsersMutation>;
export type DeactivateUsersMutationResult = Apollo.MutationResult<IDeactivateUsersMutation>;
export type DeactivateUsersMutationOptions = Apollo.BaseMutationOptions<IDeactivateUsersMutation, IDeactivateUsersMutationVariables>;
export const ActivateUsersDocument = gql`
    mutation activateUsers($input: ActivateUsersInput!) {
  activateUsers(input: $input) {
    id
  }
}
    `;
export type IActivateUsersMutationFn = Apollo.MutationFunction<IActivateUsersMutation, IActivateUsersMutationVariables>;

/**
 * __useActivateUsersMutation__
 *
 * To run a mutation, you first call `useActivateUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUsersMutation, { data, loading, error }] = useActivateUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateUsersMutation(baseOptions?: Apollo.MutationHookOptions<IActivateUsersMutation, IActivateUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IActivateUsersMutation, IActivateUsersMutationVariables>(ActivateUsersDocument, options);
      }
export type ActivateUsersMutationHookResult = ReturnType<typeof useActivateUsersMutation>;
export type ActivateUsersMutationResult = Apollo.MutationResult<IActivateUsersMutation>;
export type ActivateUsersMutationOptions = Apollo.BaseMutationOptions<IActivateUsersMutation, IActivateUsersMutationVariables>;
export const UpdateAccountNameDocument = gql`
    mutation updateAccountName($input: UpdateAccountNameInput!) {
  updateAccountName(input: $input) {
    name
  }
}
    `;
export type IUpdateAccountNameMutationFn = Apollo.MutationFunction<IUpdateAccountNameMutation, IUpdateAccountNameMutationVariables>;

/**
 * __useUpdateAccountNameMutation__
 *
 * To run a mutation, you first call `useUpdateAccountNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountNameMutation, { data, loading, error }] = useUpdateAccountNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountNameMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAccountNameMutation, IUpdateAccountNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAccountNameMutation, IUpdateAccountNameMutationVariables>(UpdateAccountNameDocument, options);
      }
export type UpdateAccountNameMutationHookResult = ReturnType<typeof useUpdateAccountNameMutation>;
export type UpdateAccountNameMutationResult = Apollo.MutationResult<IUpdateAccountNameMutation>;
export type UpdateAccountNameMutationOptions = Apollo.BaseMutationOptions<IUpdateAccountNameMutation, IUpdateAccountNameMutationVariables>;
export const UpdateAccountManagerDocument = gql`
    mutation updateAccountManager($input: UpdateAccountManagerByAccountIdInput!) {
  updateAccountManagerByAccountId(input: $input) {
    id
  }
}
    `;
export type IUpdateAccountManagerMutationFn = Apollo.MutationFunction<IUpdateAccountManagerMutation, IUpdateAccountManagerMutationVariables>;

/**
 * __useUpdateAccountManagerMutation__
 *
 * To run a mutation, you first call `useUpdateAccountManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountManagerMutation, { data, loading, error }] = useUpdateAccountManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountManagerMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAccountManagerMutation, IUpdateAccountManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAccountManagerMutation, IUpdateAccountManagerMutationVariables>(UpdateAccountManagerDocument, options);
      }
export type UpdateAccountManagerMutationHookResult = ReturnType<typeof useUpdateAccountManagerMutation>;
export type UpdateAccountManagerMutationResult = Apollo.MutationResult<IUpdateAccountManagerMutation>;
export type UpdateAccountManagerMutationOptions = Apollo.BaseMutationOptions<IUpdateAccountManagerMutation, IUpdateAccountManagerMutationVariables>;
export const AccountCampaignsDocument = gql`
    query accountCampaigns($campaignsInput: CampaignInput!, $adminOrganizationsInput: OrgFilters!) {
  campaigns(input: $campaignsInput) {
    ...CampaignDetails
  }
  admin_organizations(input: $adminOrganizationsInput) {
    members {
      attentionItems {
        level
        memberId
        type
      }
    }
  }
}
    ${CampaignDetailsFragmentDoc}`;

/**
 * __useAccountCampaignsQuery__
 *
 * To run a query within a React component, call `useAccountCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountCampaignsQuery({
 *   variables: {
 *      campaignsInput: // value for 'campaignsInput'
 *      adminOrganizationsInput: // value for 'adminOrganizationsInput'
 *   },
 * });
 */
export function useAccountCampaignsQuery(baseOptions: Apollo.QueryHookOptions<IAccountCampaignsQuery, IAccountCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAccountCampaignsQuery, IAccountCampaignsQueryVariables>(AccountCampaignsDocument, options);
      }
export function useAccountCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAccountCampaignsQuery, IAccountCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAccountCampaignsQuery, IAccountCampaignsQueryVariables>(AccountCampaignsDocument, options);
        }
export type AccountCampaignsQueryHookResult = ReturnType<typeof useAccountCampaignsQuery>;
export type AccountCampaignsLazyQueryHookResult = ReturnType<typeof useAccountCampaignsLazyQuery>;
export type AccountCampaignsQueryResult = Apollo.QueryResult<IAccountCampaignsQuery, IAccountCampaignsQueryVariables>;
export function refetchAccountCampaignsQuery(variables: IAccountCampaignsQueryVariables) {
      return { query: AccountCampaignsDocument, variables: variables }
    }
export const AccountCampaignStatsDocument = gql`
    query accountCampaignStats($input: CampaignStatsInput!) {
  campaignStats(input: $input) {
    ... on NurtureCampaignStats {
      ownerId
      ownerType
      start
      end
      numMeetingsBooked
      percentReplied
      percentInterestedReplied
    }
    ... on ProspectingCampaignStats {
      ownerId
      ownerType
      start
      end
      numMeetingsBooked
      percentConnected
      percentReplied
      percentInterestedReplied
      percentInMailReplied
      percentInterestedInMailReplied
    }
  }
}
    `;

/**
 * __useAccountCampaignStatsQuery__
 *
 * To run a query within a React component, call `useAccountCampaignStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountCampaignStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountCampaignStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountCampaignStatsQuery(baseOptions: Apollo.QueryHookOptions<IAccountCampaignStatsQuery, IAccountCampaignStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAccountCampaignStatsQuery, IAccountCampaignStatsQueryVariables>(AccountCampaignStatsDocument, options);
      }
export function useAccountCampaignStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAccountCampaignStatsQuery, IAccountCampaignStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAccountCampaignStatsQuery, IAccountCampaignStatsQueryVariables>(AccountCampaignStatsDocument, options);
        }
export type AccountCampaignStatsQueryHookResult = ReturnType<typeof useAccountCampaignStatsQuery>;
export type AccountCampaignStatsLazyQueryHookResult = ReturnType<typeof useAccountCampaignStatsLazyQuery>;
export type AccountCampaignStatsQueryResult = Apollo.QueryResult<IAccountCampaignStatsQuery, IAccountCampaignStatsQueryVariables>;
export function refetchAccountCampaignStatsQuery(variables: IAccountCampaignStatsQueryVariables) {
      return { query: AccountCampaignStatsDocument, variables: variables }
    }
export const TenantDataDocument = gql`
    query tenantData($tenantFilter: TenantFilters!) {
  admin_tenants(input: $tenantFilter) {
    id
    name
    childTenants {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useTenantDataQuery__
 *
 * To run a query within a React component, call `useTenantDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantDataQuery({
 *   variables: {
 *      tenantFilter: // value for 'tenantFilter'
 *   },
 * });
 */
export function useTenantDataQuery(baseOptions: Apollo.QueryHookOptions<ITenantDataQuery, ITenantDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ITenantDataQuery, ITenantDataQueryVariables>(TenantDataDocument, options);
      }
export function useTenantDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ITenantDataQuery, ITenantDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ITenantDataQuery, ITenantDataQueryVariables>(TenantDataDocument, options);
        }
export type TenantDataQueryHookResult = ReturnType<typeof useTenantDataQuery>;
export type TenantDataLazyQueryHookResult = ReturnType<typeof useTenantDataLazyQuery>;
export type TenantDataQueryResult = Apollo.QueryResult<ITenantDataQuery, ITenantDataQueryVariables>;
export function refetchTenantDataQuery(variables: ITenantDataQueryVariables) {
      return { query: TenantDataDocument, variables: variables }
    }
export const AdminOrgDataDocument = gql`
    query adminOrgData($orgFilter: OrgFilters!) {
  admin_organizations(input: $orgFilter) {
    id
    name
    members {
      id
      userId
      role
      isActive
    }
    customerSuccessOwner {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useAdminOrgDataQuery__
 *
 * To run a query within a React component, call `useAdminOrgDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrgDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrgDataQuery({
 *   variables: {
 *      orgFilter: // value for 'orgFilter'
 *   },
 * });
 */
export function useAdminOrgDataQuery(baseOptions: Apollo.QueryHookOptions<IAdminOrgDataQuery, IAdminOrgDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAdminOrgDataQuery, IAdminOrgDataQueryVariables>(AdminOrgDataDocument, options);
      }
export function useAdminOrgDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAdminOrgDataQuery, IAdminOrgDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAdminOrgDataQuery, IAdminOrgDataQueryVariables>(AdminOrgDataDocument, options);
        }
export type AdminOrgDataQueryHookResult = ReturnType<typeof useAdminOrgDataQuery>;
export type AdminOrgDataLazyQueryHookResult = ReturnType<typeof useAdminOrgDataLazyQuery>;
export type AdminOrgDataQueryResult = Apollo.QueryResult<IAdminOrgDataQuery, IAdminOrgDataQueryVariables>;
export function refetchAdminOrgDataQuery(variables: IAdminOrgDataQueryVariables) {
      return { query: AdminOrgDataDocument, variables: variables }
    }
export const TwoLevelsTenantDataDocument = gql`
    query twoLevelsTenantData($tenantFilter: TenantFilters!) {
  admin_tenants(input: $tenantFilter) {
    id
    name
    type
    childTenants {
      id
      name
      type
      childTenants {
        id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useTwoLevelsTenantDataQuery__
 *
 * To run a query within a React component, call `useTwoLevelsTenantDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwoLevelsTenantDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwoLevelsTenantDataQuery({
 *   variables: {
 *      tenantFilter: // value for 'tenantFilter'
 *   },
 * });
 */
export function useTwoLevelsTenantDataQuery(baseOptions: Apollo.QueryHookOptions<ITwoLevelsTenantDataQuery, ITwoLevelsTenantDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ITwoLevelsTenantDataQuery, ITwoLevelsTenantDataQueryVariables>(TwoLevelsTenantDataDocument, options);
      }
export function useTwoLevelsTenantDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ITwoLevelsTenantDataQuery, ITwoLevelsTenantDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ITwoLevelsTenantDataQuery, ITwoLevelsTenantDataQueryVariables>(TwoLevelsTenantDataDocument, options);
        }
export type TwoLevelsTenantDataQueryHookResult = ReturnType<typeof useTwoLevelsTenantDataQuery>;
export type TwoLevelsTenantDataLazyQueryHookResult = ReturnType<typeof useTwoLevelsTenantDataLazyQuery>;
export type TwoLevelsTenantDataQueryResult = Apollo.QueryResult<ITwoLevelsTenantDataQuery, ITwoLevelsTenantDataQueryVariables>;
export function refetchTwoLevelsTenantDataQuery(variables: ITwoLevelsTenantDataQueryVariables) {
      return { query: TwoLevelsTenantDataDocument, variables: variables }
    }
export const UpdateParentTenantDocument = gql`
    mutation updateParentTenant($updateTenantInput: UpdateTenantInput!) {
  updateTenant(input: $updateTenantInput) {
    id
    name
    type
  }
}
    `;
export type IUpdateParentTenantMutationFn = Apollo.MutationFunction<IUpdateParentTenantMutation, IUpdateParentTenantMutationVariables>;

/**
 * __useUpdateParentTenantMutation__
 *
 * To run a mutation, you first call `useUpdateParentTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParentTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParentTenantMutation, { data, loading, error }] = useUpdateParentTenantMutation({
 *   variables: {
 *      updateTenantInput: // value for 'updateTenantInput'
 *   },
 * });
 */
export function useUpdateParentTenantMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateParentTenantMutation, IUpdateParentTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateParentTenantMutation, IUpdateParentTenantMutationVariables>(UpdateParentTenantDocument, options);
      }
export type UpdateParentTenantMutationHookResult = ReturnType<typeof useUpdateParentTenantMutation>;
export type UpdateParentTenantMutationResult = Apollo.MutationResult<IUpdateParentTenantMutation>;
export type UpdateParentTenantMutationOptions = Apollo.BaseMutationOptions<IUpdateParentTenantMutation, IUpdateParentTenantMutationVariables>;
export const StopAutomationDocument = gql`
    mutation StopAutomation($campaignConnectionId: ID!) {
  stopAutomation(campaignConnectionId: $campaignConnectionId) {
    id
  }
}
    `;
export type IStopAutomationMutationFn = Apollo.MutationFunction<IStopAutomationMutation, IStopAutomationMutationVariables>;

/**
 * __useStopAutomationMutation__
 *
 * To run a mutation, you first call `useStopAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopAutomationMutation, { data, loading, error }] = useStopAutomationMutation({
 *   variables: {
 *      campaignConnectionId: // value for 'campaignConnectionId'
 *   },
 * });
 */
export function useStopAutomationMutation(baseOptions?: Apollo.MutationHookOptions<IStopAutomationMutation, IStopAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IStopAutomationMutation, IStopAutomationMutationVariables>(StopAutomationDocument, options);
      }
export type StopAutomationMutationHookResult = ReturnType<typeof useStopAutomationMutation>;
export type StopAutomationMutationResult = Apollo.MutationResult<IStopAutomationMutation>;
export type StopAutomationMutationOptions = Apollo.BaseMutationOptions<IStopAutomationMutation, IStopAutomationMutationVariables>;
export const CampaignsByUserDocument = gql`
    query campaignsByUser($input: CampaignInput!) {
  campaigns(input: $input) {
    id
    name
    type
    members {
      orgMemberId
      dailyOpenInMailAllocated
    }
  }
}
    `;

/**
 * __useCampaignsByUserQuery__
 *
 * To run a query within a React component, call `useCampaignsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsByUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignsByUserQuery(baseOptions: Apollo.QueryHookOptions<ICampaignsByUserQuery, ICampaignsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICampaignsByUserQuery, ICampaignsByUserQueryVariables>(CampaignsByUserDocument, options);
      }
export function useCampaignsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICampaignsByUserQuery, ICampaignsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICampaignsByUserQuery, ICampaignsByUserQueryVariables>(CampaignsByUserDocument, options);
        }
export type CampaignsByUserQueryHookResult = ReturnType<typeof useCampaignsByUserQuery>;
export type CampaignsByUserLazyQueryHookResult = ReturnType<typeof useCampaignsByUserLazyQuery>;
export type CampaignsByUserQueryResult = Apollo.QueryResult<ICampaignsByUserQuery, ICampaignsByUserQueryVariables>;
export function refetchCampaignsByUserQuery(variables: ICampaignsByUserQueryVariables) {
      return { query: CampaignsByUserDocument, variables: variables }
    }
export const ConnectionsByConnectionStatusDocument = gql`
    query ConnectionsByConnectionStatus($input: ConnectionsByConnectionStatusInput!) {
  campaignConnectionsByConnectionStatus(input: $input) {
    count
    pages {
      current
      total
    }
    content {
      id
      campaignId
      campaignMember {
        id
        orgMemberId
      }
      contactInfo {
        id
      }
      name
      status
      title
      company
      location
      profileId
      inviteUrl
      replyPrediction
      isManualTermination
      nextAutomationNode {
        id
        name
      }
      dateCreated
    }
  }
}
    `;

/**
 * __useConnectionsByConnectionStatusQuery__
 *
 * To run a query within a React component, call `useConnectionsByConnectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionsByConnectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionsByConnectionStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectionsByConnectionStatusQuery(baseOptions: Apollo.QueryHookOptions<IConnectionsByConnectionStatusQuery, IConnectionsByConnectionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IConnectionsByConnectionStatusQuery, IConnectionsByConnectionStatusQueryVariables>(ConnectionsByConnectionStatusDocument, options);
      }
export function useConnectionsByConnectionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IConnectionsByConnectionStatusQuery, IConnectionsByConnectionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IConnectionsByConnectionStatusQuery, IConnectionsByConnectionStatusQueryVariables>(ConnectionsByConnectionStatusDocument, options);
        }
export type ConnectionsByConnectionStatusQueryHookResult = ReturnType<typeof useConnectionsByConnectionStatusQuery>;
export type ConnectionsByConnectionStatusLazyQueryHookResult = ReturnType<typeof useConnectionsByConnectionStatusLazyQuery>;
export type ConnectionsByConnectionStatusQueryResult = Apollo.QueryResult<IConnectionsByConnectionStatusQuery, IConnectionsByConnectionStatusQueryVariables>;
export function refetchConnectionsByConnectionStatusQuery(variables: IConnectionsByConnectionStatusQueryVariables) {
      return { query: ConnectionsByConnectionStatusDocument, variables: variables }
    }
export const CampaignConnectionsByMeetingsDocument = gql`
    query CampaignConnectionsByMeetings($input: ConnectionsByMeetingsInput!) {
  campaignConnectionsByMeetings(input: $input) {
    count
    pages {
      current
      total
    }
    content {
      id
      meeting {
        booked
        bookedDate
        detectedDate
      }
      communicationStyles {
        styles {
          style
        }
        lastUpdated
        failureReason
      }
      campaignMember {
        id
        orgMemberId
        dailyOpenInMailAllocated
        dailyInvitesAllocated
        dailyMessagesAllocated
      }
      campaignHistory {
        campaignId
        name
        start
        end
      }
      contactInfo {
        id
      }
      name
      title
      company
      profileId
    }
  }
}
    `;

/**
 * __useCampaignConnectionsByMeetingsQuery__
 *
 * To run a query within a React component, call `useCampaignConnectionsByMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignConnectionsByMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignConnectionsByMeetingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignConnectionsByMeetingsQuery(baseOptions: Apollo.QueryHookOptions<ICampaignConnectionsByMeetingsQuery, ICampaignConnectionsByMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICampaignConnectionsByMeetingsQuery, ICampaignConnectionsByMeetingsQueryVariables>(CampaignConnectionsByMeetingsDocument, options);
      }
export function useCampaignConnectionsByMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICampaignConnectionsByMeetingsQuery, ICampaignConnectionsByMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICampaignConnectionsByMeetingsQuery, ICampaignConnectionsByMeetingsQueryVariables>(CampaignConnectionsByMeetingsDocument, options);
        }
export type CampaignConnectionsByMeetingsQueryHookResult = ReturnType<typeof useCampaignConnectionsByMeetingsQuery>;
export type CampaignConnectionsByMeetingsLazyQueryHookResult = ReturnType<typeof useCampaignConnectionsByMeetingsLazyQuery>;
export type CampaignConnectionsByMeetingsQueryResult = Apollo.QueryResult<ICampaignConnectionsByMeetingsQuery, ICampaignConnectionsByMeetingsQueryVariables>;
export function refetchCampaignConnectionsByMeetingsQuery(variables: ICampaignConnectionsByMeetingsQueryVariables) {
      return { query: CampaignConnectionsByMeetingsDocument, variables: variables }
    }
export const DetectedMeetingsCountDocument = gql`
    query DetectedMeetingsCount($input: ConnectionsByMeetingsInput!) {
  campaignConnectionsByMeetings(input: $input) {
    count
  }
}
    `;

/**
 * __useDetectedMeetingsCountQuery__
 *
 * To run a query within a React component, call `useDetectedMeetingsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectedMeetingsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectedMeetingsCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetectedMeetingsCountQuery(baseOptions: Apollo.QueryHookOptions<IDetectedMeetingsCountQuery, IDetectedMeetingsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IDetectedMeetingsCountQuery, IDetectedMeetingsCountQueryVariables>(DetectedMeetingsCountDocument, options);
      }
export function useDetectedMeetingsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IDetectedMeetingsCountQuery, IDetectedMeetingsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IDetectedMeetingsCountQuery, IDetectedMeetingsCountQueryVariables>(DetectedMeetingsCountDocument, options);
        }
export type DetectedMeetingsCountQueryHookResult = ReturnType<typeof useDetectedMeetingsCountQuery>;
export type DetectedMeetingsCountLazyQueryHookResult = ReturnType<typeof useDetectedMeetingsCountLazyQuery>;
export type DetectedMeetingsCountQueryResult = Apollo.QueryResult<IDetectedMeetingsCountQuery, IDetectedMeetingsCountQueryVariables>;
export function refetchDetectedMeetingsCountQuery(variables: IDetectedMeetingsCountQueryVariables) {
      return { query: DetectedMeetingsCountDocument, variables: variables }
    }
export const RejectDetectionDocument = gql`
    mutation RejectDetection($campaignConnectionId: ID!) {
  rejectMeetingDetection(campaignConnectionId: $campaignConnectionId) {
    id
  }
}
    `;
export type IRejectDetectionMutationFn = Apollo.MutationFunction<IRejectDetectionMutation, IRejectDetectionMutationVariables>;

/**
 * __useRejectDetectionMutation__
 *
 * To run a mutation, you first call `useRejectDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectDetectionMutation, { data, loading, error }] = useRejectDetectionMutation({
 *   variables: {
 *      campaignConnectionId: // value for 'campaignConnectionId'
 *   },
 * });
 */
export function useRejectDetectionMutation(baseOptions?: Apollo.MutationHookOptions<IRejectDetectionMutation, IRejectDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRejectDetectionMutation, IRejectDetectionMutationVariables>(RejectDetectionDocument, options);
      }
export type RejectDetectionMutationHookResult = ReturnType<typeof useRejectDetectionMutation>;
export type RejectDetectionMutationResult = Apollo.MutationResult<IRejectDetectionMutation>;
export type RejectDetectionMutationOptions = Apollo.BaseMutationOptions<IRejectDetectionMutation, IRejectDetectionMutationVariables>;
export const ConfirmDetectionDocument = gql`
    mutation ConfirmDetection($campaignConnectionId: ID!, $isBooked: Boolean!) {
  updateConnectionMeeting(
    campaignConnectionId: $campaignConnectionId
    isBooked: $isBooked
  ) {
    id
  }
}
    `;
export type IConfirmDetectionMutationFn = Apollo.MutationFunction<IConfirmDetectionMutation, IConfirmDetectionMutationVariables>;

/**
 * __useConfirmDetectionMutation__
 *
 * To run a mutation, you first call `useConfirmDetectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDetectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDetectionMutation, { data, loading, error }] = useConfirmDetectionMutation({
 *   variables: {
 *      campaignConnectionId: // value for 'campaignConnectionId'
 *      isBooked: // value for 'isBooked'
 *   },
 * });
 */
export function useConfirmDetectionMutation(baseOptions?: Apollo.MutationHookOptions<IConfirmDetectionMutation, IConfirmDetectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IConfirmDetectionMutation, IConfirmDetectionMutationVariables>(ConfirmDetectionDocument, options);
      }
export type ConfirmDetectionMutationHookResult = ReturnType<typeof useConfirmDetectionMutation>;
export type ConfirmDetectionMutationResult = Apollo.MutationResult<IConfirmDetectionMutation>;
export type ConfirmDetectionMutationOptions = Apollo.BaseMutationOptions<IConfirmDetectionMutation, IConfirmDetectionMutationVariables>;
export const OrganizationStatsDocument = gql`
    query OrganizationStats($organizationId: ID!, $orgMemberIds: [ID!]!, $start: DateTime, $end: DateTime) {
  campaignStats(
    input: {filter: {organizationFilters: [{id: $organizationId, memberIds: $orgMemberIds}], start: $start, end: $end, campaignTypes: [PROSPECTING]}}
  ) {
    ... on NurtureCampaignStats {
      ownerId
      ownerType
      start
      end
      numSendMessages
      numUserReplies
      numInterestedReplies
      percentReplied
      percentInterestedReplied
      numMeetingsBooked
    }
    ... on ProspectingCampaignStats {
      ownerId
      ownerType
      start
      end
      numUserReplies
      numUsersConnected
      numInvitesSent
      numInterestedReplies
      percentConnected
      percentReplied
      percentInterestedReplied
      numMeetingsBooked
    }
  }
}
    `;

/**
 * __useOrganizationStatsQuery__
 *
 * To run a query within a React component, call `useOrganizationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStatsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      orgMemberIds: // value for 'orgMemberIds'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useOrganizationStatsQuery(baseOptions: Apollo.QueryHookOptions<IOrganizationStatsQuery, IOrganizationStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOrganizationStatsQuery, IOrganizationStatsQueryVariables>(OrganizationStatsDocument, options);
      }
export function useOrganizationStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOrganizationStatsQuery, IOrganizationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOrganizationStatsQuery, IOrganizationStatsQueryVariables>(OrganizationStatsDocument, options);
        }
export type OrganizationStatsQueryHookResult = ReturnType<typeof useOrganizationStatsQuery>;
export type OrganizationStatsLazyQueryHookResult = ReturnType<typeof useOrganizationStatsLazyQuery>;
export type OrganizationStatsQueryResult = Apollo.QueryResult<IOrganizationStatsQuery, IOrganizationStatsQueryVariables>;
export function refetchOrganizationStatsQuery(variables: IOrganizationStatsQueryVariables) {
      return { query: OrganizationStatsDocument, variables: variables }
    }
export const OrgMembersAndCampaignsDocument = gql`
    query OrgMembersAndCampaigns($organizationId: ID!) {
  orgMembers(input: {organizationIds: [$organizationId]}) {
    id
    isActive
    organizationId
    attentionItems {
      level
      memberId
      type
    }
    linkedInErrors {
      loggedOut
      blackListed
      hasFailedMessages
      invitesThrottled
      salesNavMissing
    }
  }
  campaignSummaries {
    id
    attentionItems {
      level
      memberId
      type
    }
    members {
      id
      orgMemberId
    }
    name
  }
}
    `;

/**
 * __useOrgMembersAndCampaignsQuery__
 *
 * To run a query within a React component, call `useOrgMembersAndCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgMembersAndCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgMembersAndCampaignsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrgMembersAndCampaignsQuery(baseOptions: Apollo.QueryHookOptions<IOrgMembersAndCampaignsQuery, IOrgMembersAndCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOrgMembersAndCampaignsQuery, IOrgMembersAndCampaignsQueryVariables>(OrgMembersAndCampaignsDocument, options);
      }
export function useOrgMembersAndCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOrgMembersAndCampaignsQuery, IOrgMembersAndCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOrgMembersAndCampaignsQuery, IOrgMembersAndCampaignsQueryVariables>(OrgMembersAndCampaignsDocument, options);
        }
export type OrgMembersAndCampaignsQueryHookResult = ReturnType<typeof useOrgMembersAndCampaignsQuery>;
export type OrgMembersAndCampaignsLazyQueryHookResult = ReturnType<typeof useOrgMembersAndCampaignsLazyQuery>;
export type OrgMembersAndCampaignsQueryResult = Apollo.QueryResult<IOrgMembersAndCampaignsQuery, IOrgMembersAndCampaignsQueryVariables>;
export function refetchOrgMembersAndCampaignsQuery(variables: IOrgMembersAndCampaignsQueryVariables) {
      return { query: OrgMembersAndCampaignsDocument, variables: variables }
    }
export const ConnectionWithCommunicationStyleDocument = gql`
    query connectionWithCommunicationStyle($connectionId: ID!) {
  campaignConnection(connectionId: $connectionId) {
    id
    campaignId
    name
    status
    title
    company
    location
    dateCreated
    communicationStyles {
      styles {
        style
      }
      lastUpdated
      failureReason
    }
    linkedInProfile {
      id
      alias
      firstName
      lastName
      profilePictureUrl
      isOpenProfile
      company
      location
      title
    }
  }
}
    `;

/**
 * __useConnectionWithCommunicationStyleQuery__
 *
 * To run a query within a React component, call `useConnectionWithCommunicationStyleQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionWithCommunicationStyleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionWithCommunicationStyleQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useConnectionWithCommunicationStyleQuery(baseOptions: Apollo.QueryHookOptions<IConnectionWithCommunicationStyleQuery, IConnectionWithCommunicationStyleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IConnectionWithCommunicationStyleQuery, IConnectionWithCommunicationStyleQueryVariables>(ConnectionWithCommunicationStyleDocument, options);
      }
export function useConnectionWithCommunicationStyleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IConnectionWithCommunicationStyleQuery, IConnectionWithCommunicationStyleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IConnectionWithCommunicationStyleQuery, IConnectionWithCommunicationStyleQueryVariables>(ConnectionWithCommunicationStyleDocument, options);
        }
export type ConnectionWithCommunicationStyleQueryHookResult = ReturnType<typeof useConnectionWithCommunicationStyleQuery>;
export type ConnectionWithCommunicationStyleLazyQueryHookResult = ReturnType<typeof useConnectionWithCommunicationStyleLazyQuery>;
export type ConnectionWithCommunicationStyleQueryResult = Apollo.QueryResult<IConnectionWithCommunicationStyleQuery, IConnectionWithCommunicationStyleQueryVariables>;
export function refetchConnectionWithCommunicationStyleQuery(variables: IConnectionWithCommunicationStyleQueryVariables) {
      return { query: ConnectionWithCommunicationStyleDocument, variables: variables }
    }
export const GenerateLinkedInAuthDocument = gql`
    mutation GenerateLinkedInAuth($input: LinkedInAuthInput!) {
  generateLinkedInAuth(input: $input) {
    ... on LinkedInAuthDTO {
      url
    }
    ... on LinkedInAuthError {
      type
    }
  }
}
    `;
export type IGenerateLinkedInAuthMutationFn = Apollo.MutationFunction<IGenerateLinkedInAuthMutation, IGenerateLinkedInAuthMutationVariables>;

/**
 * __useGenerateLinkedInAuthMutation__
 *
 * To run a mutation, you first call `useGenerateLinkedInAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLinkedInAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLinkedInAuthMutation, { data, loading, error }] = useGenerateLinkedInAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLinkedInAuthMutation(baseOptions?: Apollo.MutationHookOptions<IGenerateLinkedInAuthMutation, IGenerateLinkedInAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGenerateLinkedInAuthMutation, IGenerateLinkedInAuthMutationVariables>(GenerateLinkedInAuthDocument, options);
      }
export type GenerateLinkedInAuthMutationHookResult = ReturnType<typeof useGenerateLinkedInAuthMutation>;
export type GenerateLinkedInAuthMutationResult = Apollo.MutationResult<IGenerateLinkedInAuthMutation>;
export type GenerateLinkedInAuthMutationOptions = Apollo.BaseMutationOptions<IGenerateLinkedInAuthMutation, IGenerateLinkedInAuthMutationVariables>;
export const GenerateInMailMessageSequenceDocument = gql`
    mutation GenerateInMailMessageSequence($campaignId: ID!, $websiteUrl: String, $description: String!) {
  generateInMailMessageSequence(
    input: {campaignId: $campaignId, websiteUrl: $websiteUrl, description: $description}
  ) {
    id
    subject
    message
    isAiGenerated
  }
}
    `;
export type IGenerateInMailMessageSequenceMutationFn = Apollo.MutationFunction<IGenerateInMailMessageSequenceMutation, IGenerateInMailMessageSequenceMutationVariables>;

/**
 * __useGenerateInMailMessageSequenceMutation__
 *
 * To run a mutation, you first call `useGenerateInMailMessageSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInMailMessageSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInMailMessageSequenceMutation, { data, loading, error }] = useGenerateInMailMessageSequenceMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      websiteUrl: // value for 'websiteUrl'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useGenerateInMailMessageSequenceMutation(baseOptions?: Apollo.MutationHookOptions<IGenerateInMailMessageSequenceMutation, IGenerateInMailMessageSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGenerateInMailMessageSequenceMutation, IGenerateInMailMessageSequenceMutationVariables>(GenerateInMailMessageSequenceDocument, options);
      }
export type GenerateInMailMessageSequenceMutationHookResult = ReturnType<typeof useGenerateInMailMessageSequenceMutation>;
export type GenerateInMailMessageSequenceMutationResult = Apollo.MutationResult<IGenerateInMailMessageSequenceMutation>;
export type GenerateInMailMessageSequenceMutationOptions = Apollo.BaseMutationOptions<IGenerateInMailMessageSequenceMutation, IGenerateInMailMessageSequenceMutationVariables>;
export const UpdateInMailEnabledDocument = gql`
    mutation UpdateInMailEnabled($input: UpdateInMailEnabledInput!) {
  updateInMailEnabled(input: $input) {
    id
    openInMailEnabled
  }
}
    `;
export type IUpdateInMailEnabledMutationFn = Apollo.MutationFunction<IUpdateInMailEnabledMutation, IUpdateInMailEnabledMutationVariables>;

/**
 * __useUpdateInMailEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateInMailEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInMailEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInMailEnabledMutation, { data, loading, error }] = useUpdateInMailEnabledMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInMailEnabledMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateInMailEnabledMutation, IUpdateInMailEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateInMailEnabledMutation, IUpdateInMailEnabledMutationVariables>(UpdateInMailEnabledDocument, options);
      }
export type UpdateInMailEnabledMutationHookResult = ReturnType<typeof useUpdateInMailEnabledMutation>;
export type UpdateInMailEnabledMutationResult = Apollo.MutationResult<IUpdateInMailEnabledMutation>;
export type UpdateInMailEnabledMutationOptions = Apollo.BaseMutationOptions<IUpdateInMailEnabledMutation, IUpdateInMailEnabledMutationVariables>;
export const UpdateInMailMessageSequenceDocument = gql`
    mutation UpdateInMailMessageSequence($input: UpdateMessageSequenceInput!) {
  updateInMailMessageSequence(input: $input) {
    id
    subject
    message
    isAiGenerated
  }
}
    `;
export type IUpdateInMailMessageSequenceMutationFn = Apollo.MutationFunction<IUpdateInMailMessageSequenceMutation, IUpdateInMailMessageSequenceMutationVariables>;

/**
 * __useUpdateInMailMessageSequenceMutation__
 *
 * To run a mutation, you first call `useUpdateInMailMessageSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInMailMessageSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInMailMessageSequenceMutation, { data, loading, error }] = useUpdateInMailMessageSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInMailMessageSequenceMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateInMailMessageSequenceMutation, IUpdateInMailMessageSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateInMailMessageSequenceMutation, IUpdateInMailMessageSequenceMutationVariables>(UpdateInMailMessageSequenceDocument, options);
      }
export type UpdateInMailMessageSequenceMutationHookResult = ReturnType<typeof useUpdateInMailMessageSequenceMutation>;
export type UpdateInMailMessageSequenceMutationResult = Apollo.MutationResult<IUpdateInMailMessageSequenceMutation>;
export type UpdateInMailMessageSequenceMutationOptions = Apollo.BaseMutationOptions<IUpdateInMailMessageSequenceMutation, IUpdateInMailMessageSequenceMutationVariables>;
export const GenerateMessageSequenceDocument = gql`
    mutation GenerateMessageSequence($campaignId: ID!, $websiteUrl: String, $description: String!) {
  generateMessageSequenceV2(
    input: {campaignId: $campaignId, websiteUrl: $websiteUrl, description: $description}
  ) {
    __typename
    ... on GeneratedMessageSequence {
      messageSequence {
        id
        message
        subject
        isAiGenerated
        order
        period
        time
      }
    }
    ... on GeneratedMessageSequenceErrorResponse {
      errorType
      errorMessage
    }
  }
}
    `;
export type IGenerateMessageSequenceMutationFn = Apollo.MutationFunction<IGenerateMessageSequenceMutation, IGenerateMessageSequenceMutationVariables>;

/**
 * __useGenerateMessageSequenceMutation__
 *
 * To run a mutation, you first call `useGenerateMessageSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMessageSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMessageSequenceMutation, { data, loading, error }] = useGenerateMessageSequenceMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      websiteUrl: // value for 'websiteUrl'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useGenerateMessageSequenceMutation(baseOptions?: Apollo.MutationHookOptions<IGenerateMessageSequenceMutation, IGenerateMessageSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGenerateMessageSequenceMutation, IGenerateMessageSequenceMutationVariables>(GenerateMessageSequenceDocument, options);
      }
export type GenerateMessageSequenceMutationHookResult = ReturnType<typeof useGenerateMessageSequenceMutation>;
export type GenerateMessageSequenceMutationResult = Apollo.MutationResult<IGenerateMessageSequenceMutation>;
export type GenerateMessageSequenceMutationOptions = Apollo.BaseMutationOptions<IGenerateMessageSequenceMutation, IGenerateMessageSequenceMutationVariables>;
export const UpdateMessageSequenceDocument = gql`
    mutation UpdateMessageSequence($input: UpdateMessageSequenceInput!) {
  updateMessageSequence(input: $input) {
    id
    message
    isAiGenerated
    order
    period
    time
  }
}
    `;
export type IUpdateMessageSequenceMutationFn = Apollo.MutationFunction<IUpdateMessageSequenceMutation, IUpdateMessageSequenceMutationVariables>;

/**
 * __useUpdateMessageSequenceMutation__
 *
 * To run a mutation, you first call `useUpdateMessageSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageSequenceMutation, { data, loading, error }] = useUpdateMessageSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessageSequenceMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateMessageSequenceMutation, IUpdateMessageSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateMessageSequenceMutation, IUpdateMessageSequenceMutationVariables>(UpdateMessageSequenceDocument, options);
      }
export type UpdateMessageSequenceMutationHookResult = ReturnType<typeof useUpdateMessageSequenceMutation>;
export type UpdateMessageSequenceMutationResult = Apollo.MutationResult<IUpdateMessageSequenceMutation>;
export type UpdateMessageSequenceMutationOptions = Apollo.BaseMutationOptions<IUpdateMessageSequenceMutation, IUpdateMessageSequenceMutationVariables>;
export const GenerateAudienceSegmentDocument = gql`
    mutation GenerateAudienceSegment($campaignId: ID!) {
  generateAudienceSegment(campaignId: $campaignId) {
    threadId
    runId
    status
  }
}
    `;
export type IGenerateAudienceSegmentMutationFn = Apollo.MutationFunction<IGenerateAudienceSegmentMutation, IGenerateAudienceSegmentMutationVariables>;

/**
 * __useGenerateAudienceSegmentMutation__
 *
 * To run a mutation, you first call `useGenerateAudienceSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAudienceSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAudienceSegmentMutation, { data, loading, error }] = useGenerateAudienceSegmentMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGenerateAudienceSegmentMutation(baseOptions?: Apollo.MutationHookOptions<IGenerateAudienceSegmentMutation, IGenerateAudienceSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGenerateAudienceSegmentMutation, IGenerateAudienceSegmentMutationVariables>(GenerateAudienceSegmentDocument, options);
      }
export type GenerateAudienceSegmentMutationHookResult = ReturnType<typeof useGenerateAudienceSegmentMutation>;
export type GenerateAudienceSegmentMutationResult = Apollo.MutationResult<IGenerateAudienceSegmentMutation>;
export type GenerateAudienceSegmentMutationOptions = Apollo.BaseMutationOptions<IGenerateAudienceSegmentMutation, IGenerateAudienceSegmentMutationVariables>;
export const GenerateBusinessContextDocument = gql`
    mutation GenerateBusinessContext($input: GenerateBusinessContextInput!) {
  generateBusinessContext(input: $input) {
    id
    processingState
    name
    orgMemberId
    companyId
    name
    website
    role
    roleStartTime
    roleEndTime
    research {
      coreValueProposition
    }
  }
}
    `;
export type IGenerateBusinessContextMutationFn = Apollo.MutationFunction<IGenerateBusinessContextMutation, IGenerateBusinessContextMutationVariables>;

/**
 * __useGenerateBusinessContextMutation__
 *
 * To run a mutation, you first call `useGenerateBusinessContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBusinessContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBusinessContextMutation, { data, loading, error }] = useGenerateBusinessContextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateBusinessContextMutation(baseOptions?: Apollo.MutationHookOptions<IGenerateBusinessContextMutation, IGenerateBusinessContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGenerateBusinessContextMutation, IGenerateBusinessContextMutationVariables>(GenerateBusinessContextDocument, options);
      }
export type GenerateBusinessContextMutationHookResult = ReturnType<typeof useGenerateBusinessContextMutation>;
export type GenerateBusinessContextMutationResult = Apollo.MutationResult<IGenerateBusinessContextMutation>;
export type GenerateBusinessContextMutationOptions = Apollo.BaseMutationOptions<IGenerateBusinessContextMutation, IGenerateBusinessContextMutationVariables>;
export const GetAudiencePreviewDocument = gql`
    mutation GetAudiencePreview($input: GenerateSearchListPreviewInput!) {
  generateSearchListPreview(input: $input) {
    ... on SearchListPreviewSummary {
      url
      previewList {
        name
        headline
        location
        profileUrl
        currentPosition {
          companyId
          companyName
          industry
          position
          tenure {
            years
            months
          }
        }
      }
      targetSearchList
      topPositions {
        title
        count
      }
      keyRoles {
        label
      }
      organizations {
        name
      }
      totalCount
      locations
    }
    ... on SearchListPreviewError {
      errorType
      message
    }
  }
}
    `;
export type IGetAudiencePreviewMutationFn = Apollo.MutationFunction<IGetAudiencePreviewMutation, IGetAudiencePreviewMutationVariables>;

/**
 * __useGetAudiencePreviewMutation__
 *
 * To run a mutation, you first call `useGetAudiencePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAudiencePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAudiencePreviewMutation, { data, loading, error }] = useGetAudiencePreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAudiencePreviewMutation(baseOptions?: Apollo.MutationHookOptions<IGetAudiencePreviewMutation, IGetAudiencePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGetAudiencePreviewMutation, IGetAudiencePreviewMutationVariables>(GetAudiencePreviewDocument, options);
      }
export type GetAudiencePreviewMutationHookResult = ReturnType<typeof useGetAudiencePreviewMutation>;
export type GetAudiencePreviewMutationResult = Apollo.MutationResult<IGetAudiencePreviewMutation>;
export type GetAudiencePreviewMutationOptions = Apollo.BaseMutationOptions<IGetAudiencePreviewMutation, IGetAudiencePreviewMutationVariables>;
export const GetAudienceSegmentDocument = gql`
    query GetAudienceSegment($campaignId: ID!) {
  audienceSegment(campaignId: $campaignId) {
    status
    error
    segment {
      name
      description
      rationale
      searchCriteria {
        location {
          include {
            id
            text
          }
          exclude {
            id
            text
          }
        }
        industry {
          include {
            id
            text
          }
          exclude {
            id
            text
          }
        }
        seniority {
          include
          exclude
        }
        companyHeadcount {
          min
          max
        }
        networkDistance
        role {
          include
          exclude
        }
        function {
          include {
            id
            text
          }
          exclude {
            id
            text
          }
        }
        tenureAtCompany {
          min
          max
        }
        tenureAtRole {
          min
          max
        }
        companyLocation {
          include {
            id
            text
          }
          exclude {
            id
            text
          }
        }
        profileLanguage {
          id
          text
        }
        followingYourCompany
        tenure {
          min
          max
        }
        school {
          include {
            id
            text
          }
          exclude {
            id
            text
          }
        }
        company {
          include
          exclude
        }
        keywords
        messagedRecently
        viewedProfileRecently
      }
    }
  }
}
    `;

/**
 * __useGetAudienceSegmentQuery__
 *
 * To run a query within a React component, call `useGetAudienceSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceSegmentQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetAudienceSegmentQuery(baseOptions: Apollo.QueryHookOptions<IGetAudienceSegmentQuery, IGetAudienceSegmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAudienceSegmentQuery, IGetAudienceSegmentQueryVariables>(GetAudienceSegmentDocument, options);
      }
export function useGetAudienceSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAudienceSegmentQuery, IGetAudienceSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAudienceSegmentQuery, IGetAudienceSegmentQueryVariables>(GetAudienceSegmentDocument, options);
        }
export type GetAudienceSegmentQueryHookResult = ReturnType<typeof useGetAudienceSegmentQuery>;
export type GetAudienceSegmentLazyQueryHookResult = ReturnType<typeof useGetAudienceSegmentLazyQuery>;
export type GetAudienceSegmentQueryResult = Apollo.QueryResult<IGetAudienceSegmentQuery, IGetAudienceSegmentQueryVariables>;
export function refetchGetAudienceSegmentQuery(variables: IGetAudienceSegmentQueryVariables) {
      return { query: GetAudienceSegmentDocument, variables: variables }
    }
export const GetBusinessContextsDocument = gql`
    query GetBusinessContexts($input: BusinessContextsQueryInput!) {
  businessContexts(input: $input) {
    id
    processingState
    orgMemberId
    companyId
    name
    website
    role
    roleStartTime
    roleEndTime
    research {
      description
      businessModel
      companyCulture
      companyStage
      competitiveDifferentiation
      coreValueProposition
      industry
    }
  }
}
    `;

/**
 * __useGetBusinessContextsQuery__
 *
 * To run a query within a React component, call `useGetBusinessContextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessContextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessContextsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBusinessContextsQuery(baseOptions: Apollo.QueryHookOptions<IGetBusinessContextsQuery, IGetBusinessContextsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetBusinessContextsQuery, IGetBusinessContextsQueryVariables>(GetBusinessContextsDocument, options);
      }
export function useGetBusinessContextsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetBusinessContextsQuery, IGetBusinessContextsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetBusinessContextsQuery, IGetBusinessContextsQueryVariables>(GetBusinessContextsDocument, options);
        }
export type GetBusinessContextsQueryHookResult = ReturnType<typeof useGetBusinessContextsQuery>;
export type GetBusinessContextsLazyQueryHookResult = ReturnType<typeof useGetBusinessContextsLazyQuery>;
export type GetBusinessContextsQueryResult = Apollo.QueryResult<IGetBusinessContextsQuery, IGetBusinessContextsQueryVariables>;
export function refetchGetBusinessContextsQuery(variables: IGetBusinessContextsQueryVariables) {
      return { query: GetBusinessContextsDocument, variables: variables }
    }
export const GetCampaignDetailsDocument = gql`
    query GetCampaignDetails($campaignId: ID!) {
  campaignSummary(campaignId: $campaignId) {
    id
    name
    type
    status
    openInMailEnabled
    searchUrl
    searchUrlLastUpdated
    launchedAt
    goal
    businessContext {
      id
      name
      orgMemberId
      companyId
      name
      website
      role
      roleStartTime
      roleEndTime
    }
    members {
      id
      orgMemberId
      monthlyInvitesAllocated
      monthlyMessagesAllocated
      monthlyOpenInMailAllocated
    }
    messageSequence {
      id
      message
      isAiGenerated
      order
      period
      time
    }
    inMailMessageSequence {
      id
      subject
      message
      isAiGenerated
    }
    serviceSchedule {
      id
      hierarchyType
      ownerId
      synchronization
      timezoneCode
      weeklySchedule {
        enable
        start
        end
      }
    }
    orgMember {
      id
      loginStatus
      userInfo {
        fullName
      }
      warmUpSettings {
        isEnabled
        percentage
        lastIncreaseDate
      }
    }
    autoReplySettings {
      isEnabled
      calendarLink
    }
  }
}
    `;

/**
 * __useGetCampaignDetailsQuery__
 *
 * To run a query within a React component, call `useGetCampaignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDetailsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignDetailsQuery(baseOptions: Apollo.QueryHookOptions<IGetCampaignDetailsQuery, IGetCampaignDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCampaignDetailsQuery, IGetCampaignDetailsQueryVariables>(GetCampaignDetailsDocument, options);
      }
export function useGetCampaignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCampaignDetailsQuery, IGetCampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCampaignDetailsQuery, IGetCampaignDetailsQueryVariables>(GetCampaignDetailsDocument, options);
        }
export type GetCampaignDetailsQueryHookResult = ReturnType<typeof useGetCampaignDetailsQuery>;
export type GetCampaignDetailsLazyQueryHookResult = ReturnType<typeof useGetCampaignDetailsLazyQuery>;
export type GetCampaignDetailsQueryResult = Apollo.QueryResult<IGetCampaignDetailsQuery, IGetCampaignDetailsQueryVariables>;
export function refetchGetCampaignDetailsQuery(variables: IGetCampaignDetailsQueryVariables) {
      return { query: GetCampaignDetailsDocument, variables: variables }
    }
export const GetCampaignsDocument = gql`
    query GetCampaigns($campaignsInput: CampaignInput!) {
  campaigns(input: $campaignsInput) {
    id
    name
  }
}
    `;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *      campaignsInput: // value for 'campaignsInput'
 *   },
 * });
 */
export function useGetCampaignsQuery(baseOptions: Apollo.QueryHookOptions<IGetCampaignsQuery, IGetCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCampaignsQuery, IGetCampaignsQueryVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCampaignsQuery, IGetCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCampaignsQuery, IGetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<IGetCampaignsQuery, IGetCampaignsQueryVariables>;
export function refetchGetCampaignsQuery(variables: IGetCampaignsQueryVariables) {
      return { query: GetCampaignsDocument, variables: variables }
    }
export const LinkedInWorkExperienceDocument = gql`
    query LinkedInWorkExperience($input: LinkedInWorkExperienceQueryInput!) {
  linkedInWorkExperience(input: $input) {
    companyId
    companyName
    role
    startDate
    endDate
    isCurrent
  }
}
    `;

/**
 * __useLinkedInWorkExperienceQuery__
 *
 * To run a query within a React component, call `useLinkedInWorkExperienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedInWorkExperienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedInWorkExperienceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkedInWorkExperienceQuery(baseOptions: Apollo.QueryHookOptions<ILinkedInWorkExperienceQuery, ILinkedInWorkExperienceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILinkedInWorkExperienceQuery, ILinkedInWorkExperienceQueryVariables>(LinkedInWorkExperienceDocument, options);
      }
export function useLinkedInWorkExperienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILinkedInWorkExperienceQuery, ILinkedInWorkExperienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILinkedInWorkExperienceQuery, ILinkedInWorkExperienceQueryVariables>(LinkedInWorkExperienceDocument, options);
        }
export type LinkedInWorkExperienceQueryHookResult = ReturnType<typeof useLinkedInWorkExperienceQuery>;
export type LinkedInWorkExperienceLazyQueryHookResult = ReturnType<typeof useLinkedInWorkExperienceLazyQuery>;
export type LinkedInWorkExperienceQueryResult = Apollo.QueryResult<ILinkedInWorkExperienceQuery, ILinkedInWorkExperienceQueryVariables>;
export function refetchLinkedInWorkExperienceQuery(variables: ILinkedInWorkExperienceQueryVariables) {
      return { query: LinkedInWorkExperienceDocument, variables: variables }
    }
export const UpdateCampaignContextDocument = gql`
    mutation UpdateCampaignContext($input: UpdateCampaignContextInput!) {
  updateCampaignContext(input: $input) {
    id
    goal
    businessContext {
      id
      name
      orgMemberId
      processingState
      companyId
      name
      website
      role
      roleStartTime
      roleEndTime
    }
  }
}
    `;
export type IUpdateCampaignContextMutationFn = Apollo.MutationFunction<IUpdateCampaignContextMutation, IUpdateCampaignContextMutationVariables>;

/**
 * __useUpdateCampaignContextMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignContextMutation, { data, loading, error }] = useUpdateCampaignContextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignContextMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCampaignContextMutation, IUpdateCampaignContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCampaignContextMutation, IUpdateCampaignContextMutationVariables>(UpdateCampaignContextDocument, options);
      }
export type UpdateCampaignContextMutationHookResult = ReturnType<typeof useUpdateCampaignContextMutation>;
export type UpdateCampaignContextMutationResult = Apollo.MutationResult<IUpdateCampaignContextMutation>;
export type UpdateCampaignContextMutationOptions = Apollo.BaseMutationOptions<IUpdateCampaignContextMutation, IUpdateCampaignContextMutationVariables>;
export const GetCampaignAllocationsDocument = gql`
    query GetCampaignAllocations($organizationsInput: OrganizationFilters!, $campaignAllocationsInput: CampaignAllocationsByOrgMemberQueryInput!) {
  organizations(input: $organizationsInput) {
    id
    name
    monthlyInviteLimit
    monthlyMessageLimit
    monthlyInMailLimit
  }
  campaignAllocationsByOrgMember(input: $campaignAllocationsInput) {
    campaignId
    campaignName
    campaignType
    monthlyInvitesAllocated
    monthlyMessagesAllocated
    monthlyOpenInMailAllocated
  }
}
    `;

/**
 * __useGetCampaignAllocationsQuery__
 *
 * To run a query within a React component, call `useGetCampaignAllocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignAllocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignAllocationsQuery({
 *   variables: {
 *      organizationsInput: // value for 'organizationsInput'
 *      campaignAllocationsInput: // value for 'campaignAllocationsInput'
 *   },
 * });
 */
export function useGetCampaignAllocationsQuery(baseOptions: Apollo.QueryHookOptions<IGetCampaignAllocationsQuery, IGetCampaignAllocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCampaignAllocationsQuery, IGetCampaignAllocationsQueryVariables>(GetCampaignAllocationsDocument, options);
      }
export function useGetCampaignAllocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCampaignAllocationsQuery, IGetCampaignAllocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCampaignAllocationsQuery, IGetCampaignAllocationsQueryVariables>(GetCampaignAllocationsDocument, options);
        }
export type GetCampaignAllocationsQueryHookResult = ReturnType<typeof useGetCampaignAllocationsQuery>;
export type GetCampaignAllocationsLazyQueryHookResult = ReturnType<typeof useGetCampaignAllocationsLazyQuery>;
export type GetCampaignAllocationsQueryResult = Apollo.QueryResult<IGetCampaignAllocationsQuery, IGetCampaignAllocationsQueryVariables>;
export function refetchGetCampaignAllocationsQuery(variables: IGetCampaignAllocationsQueryVariables) {
      return { query: GetCampaignAllocationsDocument, variables: variables }
    }
export const UpdateCampaignAllocationsDocument = gql`
    mutation UpdateCampaignAllocations($input: UpdateCampaignAllocationsInput!) {
  updateCampaignAllocations(input: $input) {
    id
    name
    type
    members {
      orgMemberId
      monthlyInvitesAllocated
      monthlyMessagesAllocated
      monthlyOpenInMailAllocated
    }
  }
}
    `;
export type IUpdateCampaignAllocationsMutationFn = Apollo.MutationFunction<IUpdateCampaignAllocationsMutation, IUpdateCampaignAllocationsMutationVariables>;

/**
 * __useUpdateCampaignAllocationsMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignAllocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignAllocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignAllocationsMutation, { data, loading, error }] = useUpdateCampaignAllocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignAllocationsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCampaignAllocationsMutation, IUpdateCampaignAllocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCampaignAllocationsMutation, IUpdateCampaignAllocationsMutationVariables>(UpdateCampaignAllocationsDocument, options);
      }
export type UpdateCampaignAllocationsMutationHookResult = ReturnType<typeof useUpdateCampaignAllocationsMutation>;
export type UpdateCampaignAllocationsMutationResult = Apollo.MutationResult<IUpdateCampaignAllocationsMutation>;
export type UpdateCampaignAllocationsMutationOptions = Apollo.BaseMutationOptions<IUpdateCampaignAllocationsMutation, IUpdateCampaignAllocationsMutationVariables>;
export const UpdateAutoReplySettingsDocument = gql`
    mutation UpdateAutoReplySettings($input: UpdateAutoReplySettingsInput!) {
  updateCampaignAutoReplySettings(input: $input) {
    id
    autoReplySettings {
      isEnabled
    }
  }
}
    `;
export type IUpdateAutoReplySettingsMutationFn = Apollo.MutationFunction<IUpdateAutoReplySettingsMutation, IUpdateAutoReplySettingsMutationVariables>;

/**
 * __useUpdateAutoReplySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAutoReplySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoReplySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoReplySettingsMutation, { data, loading, error }] = useUpdateAutoReplySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutoReplySettingsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAutoReplySettingsMutation, IUpdateAutoReplySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAutoReplySettingsMutation, IUpdateAutoReplySettingsMutationVariables>(UpdateAutoReplySettingsDocument, options);
      }
export type UpdateAutoReplySettingsMutationHookResult = ReturnType<typeof useUpdateAutoReplySettingsMutation>;
export type UpdateAutoReplySettingsMutationResult = Apollo.MutationResult<IUpdateAutoReplySettingsMutation>;
export type UpdateAutoReplySettingsMutationOptions = Apollo.BaseMutationOptions<IUpdateAutoReplySettingsMutation, IUpdateAutoReplySettingsMutationVariables>;
export const UpdateCampaignCalendarLinkDocument = gql`
    mutation UpdateCampaignCalendarLink($input: UpdateCampaignCalendarLinkInput!) {
  updateCampaignCalendarLink(input: $input) {
    id
    autoReplySettings {
      calendarLink
    }
  }
}
    `;
export type IUpdateCampaignCalendarLinkMutationFn = Apollo.MutationFunction<IUpdateCampaignCalendarLinkMutation, IUpdateCampaignCalendarLinkMutationVariables>;

/**
 * __useUpdateCampaignCalendarLinkMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignCalendarLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignCalendarLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignCalendarLinkMutation, { data, loading, error }] = useUpdateCampaignCalendarLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignCalendarLinkMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCampaignCalendarLinkMutation, IUpdateCampaignCalendarLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCampaignCalendarLinkMutation, IUpdateCampaignCalendarLinkMutationVariables>(UpdateCampaignCalendarLinkDocument, options);
      }
export type UpdateCampaignCalendarLinkMutationHookResult = ReturnType<typeof useUpdateCampaignCalendarLinkMutation>;
export type UpdateCampaignCalendarLinkMutationResult = Apollo.MutationResult<IUpdateCampaignCalendarLinkMutation>;
export type UpdateCampaignCalendarLinkMutationOptions = Apollo.BaseMutationOptions<IUpdateCampaignCalendarLinkMutation, IUpdateCampaignCalendarLinkMutationVariables>;
export const ToggleWarmupStatusDocument = gql`
    mutation ToggleWarmupStatus($input: ToggleWarmupStatusInput!) {
  toggleWarmupStatus(input: $input) {
    id
    warmUpSettings {
      isEnabled
      percentage
      lastIncreaseDate
    }
  }
}
    `;
export type IToggleWarmupStatusMutationFn = Apollo.MutationFunction<IToggleWarmupStatusMutation, IToggleWarmupStatusMutationVariables>;

/**
 * __useToggleWarmupStatusMutation__
 *
 * To run a mutation, you first call `useToggleWarmupStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWarmupStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWarmupStatusMutation, { data, loading, error }] = useToggleWarmupStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleWarmupStatusMutation(baseOptions?: Apollo.MutationHookOptions<IToggleWarmupStatusMutation, IToggleWarmupStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IToggleWarmupStatusMutation, IToggleWarmupStatusMutationVariables>(ToggleWarmupStatusDocument, options);
      }
export type ToggleWarmupStatusMutationHookResult = ReturnType<typeof useToggleWarmupStatusMutation>;
export type ToggleWarmupStatusMutationResult = Apollo.MutationResult<IToggleWarmupStatusMutation>;
export type ToggleWarmupStatusMutationOptions = Apollo.BaseMutationOptions<IToggleWarmupStatusMutation, IToggleWarmupStatusMutationVariables>;
export const UpdateCampaignNameDocument = gql`
    mutation UpdateCampaignName($input: UpdateCampaignNameInput!) {
  updateCampaignName(input: $input) {
    id
    name
  }
}
    `;
export type IUpdateCampaignNameMutationFn = Apollo.MutationFunction<IUpdateCampaignNameMutation, IUpdateCampaignNameMutationVariables>;

/**
 * __useUpdateCampaignNameMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignNameMutation, { data, loading, error }] = useUpdateCampaignNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignNameMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCampaignNameMutation, IUpdateCampaignNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCampaignNameMutation, IUpdateCampaignNameMutationVariables>(UpdateCampaignNameDocument, options);
      }
export type UpdateCampaignNameMutationHookResult = ReturnType<typeof useUpdateCampaignNameMutation>;
export type UpdateCampaignNameMutationResult = Apollo.MutationResult<IUpdateCampaignNameMutation>;
export type UpdateCampaignNameMutationOptions = Apollo.BaseMutationOptions<IUpdateCampaignNameMutation, IUpdateCampaignNameMutationVariables>;
export const UpdateCampaignStatusDocument = gql`
    mutation UpdateCampaignStatus($campaignId: ID!, $status: CampaignStatusInput!) {
  updateCampaignStatus(campaignId: $campaignId, status: $status) {
    id
    status
  }
}
    `;
export type IUpdateCampaignStatusMutationFn = Apollo.MutationFunction<IUpdateCampaignStatusMutation, IUpdateCampaignStatusMutationVariables>;

/**
 * __useUpdateCampaignStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignStatusMutation, { data, loading, error }] = useUpdateCampaignStatusMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateCampaignStatusMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCampaignStatusMutation, IUpdateCampaignStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCampaignStatusMutation, IUpdateCampaignStatusMutationVariables>(UpdateCampaignStatusDocument, options);
      }
export type UpdateCampaignStatusMutationHookResult = ReturnType<typeof useUpdateCampaignStatusMutation>;
export type UpdateCampaignStatusMutationResult = Apollo.MutationResult<IUpdateCampaignStatusMutation>;
export type UpdateCampaignStatusMutationOptions = Apollo.BaseMutationOptions<IUpdateCampaignStatusMutation, IUpdateCampaignStatusMutationVariables>;
export const GetCampaignIssuesDocument = gql`
    query GetCampaignIssues($campaignId: ID!, $orgMemberId: ID!, $organizationId: ID!) {
  campaignSummary(campaignId: $campaignId) {
    name
    attentionItems {
      level
      memberId
      type
    }
  }
  orgMembers(
    input: {organizationIds: [$organizationId], orgMemberIds: [$orgMemberId]}
  ) {
    id
    organizationId
    attentionItems {
      level
      memberId
      type
    }
  }
}
    `;

/**
 * __useGetCampaignIssuesQuery__
 *
 * To run a query within a React component, call `useGetCampaignIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignIssuesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      orgMemberId: // value for 'orgMemberId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCampaignIssuesQuery(baseOptions: Apollo.QueryHookOptions<IGetCampaignIssuesQuery, IGetCampaignIssuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCampaignIssuesQuery, IGetCampaignIssuesQueryVariables>(GetCampaignIssuesDocument, options);
      }
export function useGetCampaignIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCampaignIssuesQuery, IGetCampaignIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCampaignIssuesQuery, IGetCampaignIssuesQueryVariables>(GetCampaignIssuesDocument, options);
        }
export type GetCampaignIssuesQueryHookResult = ReturnType<typeof useGetCampaignIssuesQuery>;
export type GetCampaignIssuesLazyQueryHookResult = ReturnType<typeof useGetCampaignIssuesLazyQuery>;
export type GetCampaignIssuesQueryResult = Apollo.QueryResult<IGetCampaignIssuesQuery, IGetCampaignIssuesQueryVariables>;
export function refetchGetCampaignIssuesQuery(variables: IGetCampaignIssuesQueryVariables) {
      return { query: GetCampaignIssuesDocument, variables: variables }
    }
export const UpdateCampaignServiceScheduleDocument = gql`
    mutation UpdateCampaignServiceSchedule($input: UpdateServiceScheduleInput!) {
  updateServiceSchedule(input: $input) {
    id
    hierarchyType
    ownerId
    synchronization
    timezoneCode
    weeklySchedule {
      enable
      start
      end
    }
  }
}
    `;
export type IUpdateCampaignServiceScheduleMutationFn = Apollo.MutationFunction<IUpdateCampaignServiceScheduleMutation, IUpdateCampaignServiceScheduleMutationVariables>;

/**
 * __useUpdateCampaignServiceScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignServiceScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignServiceScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignServiceScheduleMutation, { data, loading, error }] = useUpdateCampaignServiceScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignServiceScheduleMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCampaignServiceScheduleMutation, IUpdateCampaignServiceScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCampaignServiceScheduleMutation, IUpdateCampaignServiceScheduleMutationVariables>(UpdateCampaignServiceScheduleDocument, options);
      }
export type UpdateCampaignServiceScheduleMutationHookResult = ReturnType<typeof useUpdateCampaignServiceScheduleMutation>;
export type UpdateCampaignServiceScheduleMutationResult = Apollo.MutationResult<IUpdateCampaignServiceScheduleMutation>;
export type UpdateCampaignServiceScheduleMutationOptions = Apollo.BaseMutationOptions<IUpdateCampaignServiceScheduleMutation, IUpdateCampaignServiceScheduleMutationVariables>;